import axios from 'axios';

function _regeneratorRuntime() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function () {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) keys.push(key);

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var fails$p = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$o = fails$p;

var functionBindNative = !fails$o(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$4 = functionBindNative;

var FunctionPrototype$3 = Function.prototype;
var bind$a = FunctionPrototype$3.bind;
var call$n = FunctionPrototype$3.call;
var uncurryThis$s = NATIVE_BIND$4 && bind$a.bind(call$n, call$n);

var functionUncurryThis = NATIVE_BIND$4 ? function (fn) {
  return fn && uncurryThis$s(fn);
} : function (fn) {
  return fn && function () {
    return call$n.apply(fn, arguments);
  };
};

var uncurryThis$r = functionUncurryThis;

var toString$9 = uncurryThis$r({}.toString);
var stringSlice$6 = uncurryThis$r(''.slice);

var classofRaw$1 = function (it) {
  return stringSlice$6(toString$9(it), 8, -1);
};

var uncurryThis$q = functionUncurryThis;
var fails$n = fails$p;
var classof$a = classofRaw$1;

var $Object$4 = Object;
var split$3 = uncurryThis$q(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$n(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$a(it) == 'String' ? split$3(it, '') : $Object$4(it);
} : $Object$4;

var $TypeError$f = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$6 = function (it) {
  if (it == undefined) throw $TypeError$f("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$5 = requireObjectCoercible$6;

var toIndexedObject$6 = function (it) {
  return IndexedObject$2(requireObjectCoercible$5(it));
};

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$p =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var shared$4 = {exports: {}};

var isPure = false;

var global$o = global$p;

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(global$o, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$o[key] = value;
  } return value;
};

var global$n = global$p;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = global$n[SHARED] || defineGlobalProperty$2(SHARED, {});

var sharedStore = store$3;

var store$2 = sharedStore;

(shared$4.exports = function (key, value) {
  return store$2[key] || (store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.24.1',
  mode: 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.24.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var requireObjectCoercible$4 = requireObjectCoercible$6;

var $Object$3 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$9 = function (argument) {
  return $Object$3(requireObjectCoercible$4(argument));
};

var uncurryThis$p = functionUncurryThis;
var toObject$8 = toObject$9;

var hasOwnProperty = uncurryThis$p({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$8(it), key);
};

var uncurryThis$o = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$8 = uncurryThis$o(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$8(++id + postfix, 36);
};

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var isCallable$n = function (argument) {
  return typeof argument == 'function';
};

var global$m = global$p;
var isCallable$m = isCallable$n;

var aFunction = function (argument) {
  return isCallable$m(argument) ? argument : undefined;
};

var getBuiltIn$8 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$m[namespace]) : global$m[namespace] && global$m[namespace][method];
};

var getBuiltIn$7 = getBuiltIn$8;

var engineUserAgent = getBuiltIn$7('navigator', 'userAgent') || '';

var global$l = global$p;
var userAgent$3 = engineUserAgent;

var process$3 = global$l.process;
var Deno$1 = global$l.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es-x/no-symbol -- required for testing */

var V8_VERSION$3 = engineV8Version;
var fails$m = fails$p;

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$m(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$3 && V8_VERSION$3 < 41;
});

/* eslint-disable es-x/no-symbol -- required for testing */

var NATIVE_SYMBOL$1 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$1
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var global$k = global$p;
var shared$3 = shared$4.exports;
var hasOwn$e = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var WellKnownSymbolsStore = shared$3('wks');
var Symbol$1 = global$k.Symbol;
var symbolFor = Symbol$1 && Symbol$1['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid$1;

var wellKnownSymbol$n = function (name) {
  if (!hasOwn$e(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn$e(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else if (USE_SYMBOL_AS_UID$1 && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};

var isCallable$l = isCallable$n;

var isObject$e = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$l(it);
};

var isObject$d = isObject$e;

var $String$3 = String;
var $TypeError$e = TypeError;

// `Assert: Type(argument) is Object`
var anObject$i = function (argument) {
  if (isObject$d(argument)) return argument;
  throw $TypeError$e($String$3(argument) + ' is not an object');
};

var objectDefineProperties = {};

var fails$l = fails$p;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$l(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var DESCRIPTORS$e = descriptors;
var fails$k = fails$p;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$e && fails$k(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});

var objectDefineProperty = {};

var global$j = global$p;
var isObject$c = isObject$e;

var document$3 = global$j.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$c(document$3) && isObject$c(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$d = descriptors;
var fails$j = fails$p;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$d && !fails$j(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var NATIVE_BIND$3 = functionBindNative;

var call$m = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$m.bind(call$m) : function () {
  return call$m.apply(call$m, arguments);
};

var uncurryThis$n = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$n({}.isPrototypeOf);

var getBuiltIn$6 = getBuiltIn$8;
var isCallable$k = isCallable$n;
var isPrototypeOf$3 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var $Object$2 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$6('Symbol');
  return isCallable$k($Symbol) && isPrototypeOf$3($Symbol.prototype, $Object$2(it));
};

var $String$2 = String;

var tryToString$5 = function (argument) {
  try {
    return $String$2(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$j = isCallable$n;
var tryToString$4 = tryToString$5;

var $TypeError$d = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$9 = function (argument) {
  if (isCallable$j(argument)) return argument;
  throw $TypeError$d(tryToString$4(argument) + ' is not a function');
};

var aCallable$8 = aCallable$9;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$5 = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable$8(func);
};

var call$l = functionCall;
var isCallable$i = isCallable$n;
var isObject$b = isObject$e;

var $TypeError$c = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$i(fn = input.toString) && !isObject$b(val = call$l(fn, input))) return val;
  if (isCallable$i(fn = input.valueOf) && !isObject$b(val = call$l(fn, input))) return val;
  if (pref !== 'string' && isCallable$i(fn = input.toString) && !isObject$b(val = call$l(fn, input))) return val;
  throw $TypeError$c("Can't convert object to primitive value");
};

var call$k = functionCall;
var isObject$a = isObject$e;
var isSymbol$1 = isSymbol$2;
var getMethod$4 = getMethod$5;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$m = wellKnownSymbol$n;

var $TypeError$b = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$m('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$a(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$4(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$k(exoticToPrim, input, pref);
    if (!isObject$a(result) || isSymbol$1(result)) return result;
    throw $TypeError$b("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$3 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var DESCRIPTORS$c = descriptors;
var IE8_DOM_DEFINE$1 = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$h = anObject$i;
var toPropertyKey$2 = toPropertyKey$3;

var $TypeError$a = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$c ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$h(O);
  P = toPropertyKey$2(P);
  anObject$h(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor$1(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$h(O);
  P = toPropertyKey$2(P);
  anObject$h(Attributes);
  if (IE8_DOM_DEFINE$1) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError$a('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var ceil = Math.ceil;
var floor$4 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$4 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$5 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$4 = toIntegerOrInfinity$5;

var max$3 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$3 = function (index, length) {
  var integer = toIntegerOrInfinity$4(index);
  return integer < 0 ? max$3(integer + length, 0) : min$3(integer, length);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$5;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$2 = function (argument) {
  return argument > 0 ? min$2(toIntegerOrInfinity$3(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$1 = toLength$2;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$7 = function (obj) {
  return toLength$1(obj.length);
};

var toIndexedObject$5 = toIndexedObject$6;
var toAbsoluteIndex$2 = toAbsoluteIndex$3;
var lengthOfArrayLike$6 = lengthOfArrayLike$7;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$5($this);
    var length = lengthOfArrayLike$6(O);
    var index = toAbsoluteIndex$2(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var hiddenKeys$4 = {};

var uncurryThis$m = functionUncurryThis;
var hasOwn$d = hasOwnProperty_1;
var toIndexedObject$4 = toIndexedObject$6;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$3 = hiddenKeys$4;

var push$6 = uncurryThis$m([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$4(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$d(hiddenKeys$3, key) && hasOwn$d(O, key) && push$6(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$d(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$6(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var objectKeys$3 = Object.keys || function keys(O) {
  return internalObjectKeys$1(O, enumBugKeys$2);
};

var DESCRIPTORS$b = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$6 = objectDefineProperty;
var anObject$g = anObject$i;
var toIndexedObject$3 = toIndexedObject$6;
var objectKeys$2 = objectKeys$3;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$b && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$g(O);
  var props = toIndexedObject$3(Properties);
  var keys = objectKeys$2(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$6.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$5 = getBuiltIn$8;

var html$2 = getBuiltIn$5('document', 'documentElement');

var shared$2 = shared$4.exports;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

/* global ActiveXObject -- old IE, WSH */

var anObject$f = anObject$i;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys$1 = enumBugKeys$3;
var hiddenKeys$2 = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$2 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys$1.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys$1[length]];
  return NullProtoObject();
};

hiddenKeys$2[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$f(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$l = wellKnownSymbol$n;
var create$3 = objectCreate;
var defineProperty$6 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$l('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] == undefined) {
  defineProperty$6(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$3(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$2 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var uncurryThis$l = functionUncurryThis;
var isCallable$h = isCallable$n;
var store$1 = sharedStore;

var functionToString$1 = uncurryThis$l(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$h(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString$1(it);
  };
}

var inspectSource$4 = store$1.inspectSource;

var global$i = global$p;
var isCallable$g = isCallable$n;
var inspectSource$3 = inspectSource$4;

var WeakMap$1 = global$i.WeakMap;

var nativeWeakMap = isCallable$g(WeakMap$1) && /native code/.test(inspectSource$3(WeakMap$1));

var createPropertyDescriptor$6 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var DESCRIPTORS$a = descriptors;
var definePropertyModule$5 = objectDefineProperty;
var createPropertyDescriptor$5 = createPropertyDescriptor$6;

var createNonEnumerableProperty$5 = DESCRIPTORS$a ? function (object, key, value) {
  return definePropertyModule$5.f(object, key, createPropertyDescriptor$5(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var NATIVE_WEAK_MAP = nativeWeakMap;
var global$h = global$p;
var uncurryThis$k = functionUncurryThis;
var isObject$9 = isObject$e;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$c = hasOwnProperty_1;
var shared$1 = sharedStore;
var sharedKey$1 = sharedKey$3;
var hiddenKeys$1 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$4 = global$h.TypeError;
var WeakMap = global$h.WeakMap;
var set$2, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$2(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$9(it) || (state = get(it)).type !== TYPE) {
      throw TypeError$4('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  var wmget = uncurryThis$k(store.get);
  var wmhas = uncurryThis$k(store.has);
  var wmset = uncurryThis$k(store.set);
  set$2 = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey$1('state');
  hiddenKeys$1[STATE] = true;
  set$2 = function (it, metadata) {
    if (hasOwn$c(it, STATE)) throw new TypeError$4(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$c(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$c(it, STATE);
  };
}

var internalState = {
  set: set$2,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var objectGetOwnPropertyDescriptor = {};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable$1 = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable$1.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$1;

var DESCRIPTORS$9 = descriptors;
var call$j = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$6;
var toIndexedObject$2 = toIndexedObject$6;
var toPropertyKey$1 = toPropertyKey$3;
var hasOwn$b = hasOwnProperty_1;
var IE8_DOM_DEFINE = ie8DomDefine;

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$9 ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$2(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$b(O, P)) return createPropertyDescriptor$4(!call$j(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$8 = descriptors;
var hasOwn$a = hasOwnProperty_1;

var FunctionPrototype$2 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$8 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$a(FunctionPrototype$2, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$8 || (DESCRIPTORS$8 && getDescriptor(FunctionPrototype$2, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var fails$i = fails$p;
var isCallable$f = isCallable$n;
var hasOwn$9 = hasOwnProperty_1;
var DESCRIPTORS$7 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$4;
var InternalStateModule$5 = internalState;

var enforceInternalState = InternalStateModule$5.enforce;
var getInternalState$3 = InternalStateModule$5.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;

var CONFIGURABLE_LENGTH = DESCRIPTORS$7 && !fails$i(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$9(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$7) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$9(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$9(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$7) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$9(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$f(this) && getInternalState$3(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$e = isCallable$n;
var definePropertyModule$4 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$c = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$e(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$4.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$3;

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$4 = getBuiltIn$8;
var uncurryThis$j = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$e = anObject$i;

var concat$3 = uncurryThis$j([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$4('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$e(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$3(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$8 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var definePropertyModule$3 = objectDefineProperty;

var copyConstructorProperties$1 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$3.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$1.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$8(target, key) && !(exceptions && hasOwn$8(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$h = fails$p;
var isCallable$d = isCallable$n;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable$d(detection) ? fails$h(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$g = global$p;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$b = defineBuiltIn$c;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties = copyConstructorProperties$1;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$g;
  } else if (STATIC) {
    target = global$g[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global$g[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$b(target, key, sourceProperty, options);
  }
};

var fails$g = fails$p;

var correctPrototypeGetter = !fails$g(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$7 = hasOwnProperty_1;
var isCallable$c = isCallable$n;
var toObject$7 = toObject$9;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object$1 = Object;
var ObjectPrototype = $Object$1.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object$1.getPrototypeOf : function (O) {
  var object = toObject$7(O);
  if (hasOwn$7(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$c(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object$1 ? ObjectPrototype : null;
};

var fails$f = fails$p;
var isCallable$b = isCallable$n;
var getPrototypeOf$2 = objectGetPrototypeOf;
var defineBuiltIn$a = defineBuiltIn$c;
var wellKnownSymbol$k = wellKnownSymbol$n;

var ITERATOR$7 = wellKnownSymbol$k('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$f(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$7].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$b(IteratorPrototype$2[ITERATOR$7])) {
  defineBuiltIn$a(IteratorPrototype$2, ITERATOR$7, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$4 = objectDefineProperty.f;
var hasOwn$6 = hasOwnProperty_1;
var wellKnownSymbol$j = wellKnownSymbol$n;

var TO_STRING_TAG$3 = wellKnownSymbol$j('toStringTag');

var setToStringTag$5 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$6(target, TO_STRING_TAG$3)) {
    defineProperty$4(target, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$2 = objectCreate;
var createPropertyDescriptor$3 = createPropertyDescriptor$6;
var setToStringTag$4 = setToStringTag$5;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$2 = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$2(IteratorPrototype$1, { next: createPropertyDescriptor$3(+!ENUMERABLE_NEXT, next) });
  setToStringTag$4(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var isCallable$a = isCallable$n;

var $String$1 = String;
var $TypeError$9 = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (typeof argument == 'object' || isCallable$a(argument)) return argument;
  throw $TypeError$9("Can't set " + $String$1(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */

var uncurryThis$i = functionUncurryThis;
var anObject$d = anObject$i;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis$i(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$d(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$n = _export;
var call$i = functionCall;
var FunctionName = functionName;
var isCallable$9 = isCallable$n;
var createIteratorConstructor$1 = createIteratorConstructor$2;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$3 = setToStringTag$5;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var defineBuiltIn$9 = defineBuiltIn$c;
var wellKnownSymbol$i = wellKnownSymbol$n;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$6 = wellKnownSymbol$i('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$2 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor$1(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$6]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$9(CurrentIteratorPrototype[ITERATOR$6])) {
          defineBuiltIn$9(CurrentIteratorPrototype, ITERATOR$6, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$3(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$i(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$9(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$n({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$6] !== defaultIterator) {
    defineBuiltIn$9(IterablePrototype, ITERATOR$6, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

var toIndexedObject$1 = toIndexedObject$6;
var addToUnscopables$1 = addToUnscopables$2;
var Iterators$2 = iterators;
var InternalStateModule$4 = internalState;
var defineProperty$3 = objectDefineProperty.f;
var defineIterator$1 = defineIterator$2;
var DESCRIPTORS$6 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$4 = InternalStateModule$4.set;
var getInternalState$2 = InternalStateModule$4.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator$1(Array, 'Array', function (iterated, kind) {
  setInternalState$4(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$1(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('keys');
addToUnscopables$1('values');
addToUnscopables$1('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$6 && values.name !== 'values') try {
  defineProperty$3(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

var wellKnownSymbol$h = wellKnownSymbol$n;

var TO_STRING_TAG$2 = wellKnownSymbol$h('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var isCallable$8 = isCallable$n;
var classofRaw = classofRaw$1;
var wellKnownSymbol$g = wellKnownSymbol$n;

var TO_STRING_TAG$1 = wellKnownSymbol$g('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$9 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable$8(O.callee) ? 'Arguments' : result;
};

var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$8 = classof$9;

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
  return '[object ' + classof$8(this) + ']';
};

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var defineBuiltIn$8 = defineBuiltIn$c;
var toString$7 = objectToString;

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn$8(Object.prototype, 'toString', toString$7, { unsafe: true });
}

var classof$7 = classofRaw$1;
var global$f = global$p;

var engineIsNode = classof$7(global$f.process) == 'process';

var getBuiltIn$3 = getBuiltIn$8;
var definePropertyModule$2 = objectDefineProperty;
var wellKnownSymbol$f = wellKnownSymbol$n;
var DESCRIPTORS$5 = descriptors;

var SPECIES$5 = wellKnownSymbol$f('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$2.f;

  if (DESCRIPTORS$5 && Constructor && !Constructor[SPECIES$5]) {
    defineProperty(Constructor, SPECIES$5, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$2 = objectIsPrototypeOf;

var $TypeError$8 = TypeError;

var anInstance$3 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw $TypeError$8('Incorrect invocation');
};

var uncurryThis$h = functionUncurryThis;
var fails$e = fails$p;
var isCallable$7 = isCallable$n;
var classof$6 = classof$9;
var getBuiltIn$2 = getBuiltIn$8;
var inspectSource$1 = inspectSource$4;

var noop = function () { /* empty */ };
var empty = [];
var construct$1 = getBuiltIn$2('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$3 = uncurryThis$h(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$7(argument)) return false;
  try {
    construct$1(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$7(argument)) return false;
  switch (classof$6(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$3(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$3 = !construct$1 || fails$e(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$2 = isConstructor$3;
var tryToString$3 = tryToString$5;

var $TypeError$7 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$2(argument)) return argument;
  throw $TypeError$7(tryToString$3(argument) + ' is not a constructor');
};

var anObject$c = anObject$i;
var aConstructor = aConstructor$1;
var wellKnownSymbol$e = wellKnownSymbol$n;

var SPECIES$4 = wellKnownSymbol$e('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$c(O).constructor;
  var S;
  return C === undefined || (S = anObject$c(C)[SPECIES$4]) == undefined ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$1 = Function.prototype;
var apply$2 = FunctionPrototype$1.apply;
var call$h = FunctionPrototype$1.call;

// eslint-disable-next-line es-x/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$2 ? call$h.bind(apply$2) : function () {
  return call$h.apply(apply$2, arguments);
});

var uncurryThis$g = functionUncurryThis;
var aCallable$7 = aCallable$9;
var NATIVE_BIND$1 = functionBindNative;

var bind$9 = uncurryThis$g(uncurryThis$g.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$7(fn);
  return that === undefined ? fn : NATIVE_BIND$1 ? bind$9(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis$f = functionUncurryThis;

var arraySlice$4 = uncurryThis$f([].slice);

var $TypeError$6 = TypeError;

var validateArgumentsLength$3 = function (passed, required) {
  if (passed < required) throw $TypeError$6('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$e = global$p;
var apply$1 = functionApply;
var bind$8 = functionBindContext;
var isCallable$6 = isCallable$n;
var hasOwn$5 = hasOwnProperty_1;
var fails$d = fails$p;
var html = html$2;
var arraySlice$3 = arraySlice$4;
var createElement = documentCreateElement$2;
var validateArgumentsLength$2 = validateArgumentsLength$3;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var set$1 = global$e.setImmediate;
var clear = global$e.clearImmediate;
var process$2 = global$e.process;
var Dispatch = global$e.Dispatch;
var Function$1 = global$e.Function;
var MessageChannel = global$e.MessageChannel;
var String$1 = global$e.String;
var counter = 0;
var queue$1 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location$1, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location$1 = global$e.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn$5(queue$1, id)) {
    var fn = queue$1[id];
    delete queue$1[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$e.postMessage(String$1(id), location$1.protocol + '//' + location$1.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength$2(arguments.length, 1);
    var fn = isCallable$6(handler) ? handler : Function$1(handler);
    var args = arraySlice$3(arguments, 1);
    queue$1[++counter] = function () {
      apply$1(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$1[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$8(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$e.addEventListener &&
    isCallable$6(global$e.postMessage) &&
    !global$e.importScripts &&
    location$1 && location$1.protocol !== 'file:' &&
    !fails$d(post)
  ) {
    defer = post;
    global$e.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set$1,
  clear: clear
};

var userAgent$1 = engineUserAgent;
var global$d = global$p;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && global$d.Pebble !== undefined;

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$c = global$p;
var bind$7 = functionBindContext;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$1.set;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver = global$c.MutationObserver || global$c.WebKitMutationObserver;
var document$2 = global$c.document;
var process$1 = global$c.process;
var Promise$1 = global$c.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$1(global$c, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$1.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify$1();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$7(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind$7(macrotask, global$c);
    notify$1 = function () {
      macrotask(flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify$1();
  } last = task;
};

var global$b = global$p;

var hostReportErrors$1 = function (a, b) {
  var console = global$b.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};

var perform$4 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var Queue$1 = function () {
  this.head = null;
  this.tail = null;
};

Queue$1.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

var queue = Queue$1;

var global$a = global$p;

var promiseNativeConstructor = global$a.Promise;

/* global Deno -- Deno case */

var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$1 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$1
  && typeof window == 'object'
  && typeof document == 'object';

var global$9 = global$p;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$5 = isCallable$n;
var isForced = isForced_1;
var inspectSource = inspectSource$4;
var wellKnownSymbol$d = wellKnownSymbol$n;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION$2 = engineV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES$3 = wellKnownSymbol$d('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$5(global$9.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION$2 === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION$2 || V8_VERSION$2 < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$3] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$6 = aCallable$9;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$6(resolve);
  this.reject = aCallable$6(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$m = _export;
var IS_NODE = engineIsNode;
var global$8 = global$p;
var call$g = functionCall;
var defineBuiltIn$7 = defineBuiltIn$c;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$5;
var setSpecies = setSpecies$1;
var aCallable$5 = aCallable$9;
var isCallable$4 = isCallable$n;
var isObject$8 = isObject$e;
var anInstance$2 = anInstance$3;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask$1;
var hostReportErrors = hostReportErrors$1;
var perform$3 = perform$4;
var Queue = queue;
var InternalStateModule$3 = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$4 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$3.getterFor(PROMISE);
var setInternalState$3 = InternalStateModule$3.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$3 = global$8.TypeError;
var document$1 = global$8.document;
var process = global$8.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$4.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$8.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$8(it) && isCallable$4(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError$3('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$g(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$8.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$8['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$g(task, global$8, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$3(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$g(task, global$8, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$6 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$3("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$g(then, value,
            bind$6(internalResolve, wrapper, state),
            bind$6(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$2(this, PromisePrototype);
    aCallable$5(executor);
    call$g(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$6(internalResolve, state), bind$6(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$3(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$7(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$4(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$4(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$6(internalResolve, state);
    this.reject = bind$6(internalReject, state);
  };

  newPromiseCapabilityModule$4.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$4(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$7(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$g(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

$$m({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$2(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var wellKnownSymbol$c = wellKnownSymbol$n;
var Iterators$1 = iterators;

var ITERATOR$5 = wellKnownSymbol$c('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$2 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$5] === it);
};

var classof$5 = classof$9;
var getMethod$3 = getMethod$5;
var Iterators = iterators;
var wellKnownSymbol$b = wellKnownSymbol$n;

var ITERATOR$4 = wellKnownSymbol$b('iterator');

var getIteratorMethod$4 = function (it) {
  if (it != undefined) return getMethod$3(it, ITERATOR$4)
    || getMethod$3(it, '@@iterator')
    || Iterators[classof$5(it)];
};

var call$f = functionCall;
var aCallable$4 = aCallable$9;
var anObject$b = anObject$i;
var tryToString$2 = tryToString$5;
var getIteratorMethod$3 = getIteratorMethod$4;

var $TypeError$5 = TypeError;

var getIterator$3 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$3(argument) : usingIterator;
  if (aCallable$4(iteratorMethod)) return anObject$b(call$f(iteratorMethod, argument));
  throw $TypeError$5(tryToString$2(argument) + ' is not iterable');
};

var call$e = functionCall;
var anObject$a = anObject$i;
var getMethod$2 = getMethod$5;

var iteratorClose$2 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$a(iterator);
  try {
    innerResult = getMethod$2(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$e(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$a(innerResult);
  return value;
};

var bind$5 = functionBindContext;
var call$d = functionCall;
var anObject$9 = anObject$i;
var tryToString$1 = tryToString$5;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
var lengthOfArrayLike$5 = lengthOfArrayLike$7;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator$2 = getIterator$3;
var getIteratorMethod$2 = getIteratorMethod$4;
var iteratorClose$1 = iteratorClose$2;

var $TypeError$4 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$3 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$5(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$1(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$9(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$2(iterable);
    if (!iterFn) throw $TypeError$4(tryToString$1(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$5(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator$2(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$d(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$a = wellKnownSymbol$n;

var ITERATOR$3 = wellKnownSymbol$a('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$3] = function () {
    return this;
  };
  // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$3] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$l = _export;
var call$c = functionCall;
var aCallable$3 = aCallable$9;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;
var perform$2 = perform$4;
var iterate$2 = iterate$3;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$l({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$3.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$2(function () {
      var $promiseResolve = aCallable$3(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$2(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$c($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$k = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$1 = getBuiltIn$8;
var isCallable$3 = isCallable$n;
var defineBuiltIn$6 = defineBuiltIn$c;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$k({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$3(NativePromiseConstructor)) {
  var method = getBuiltIn$1('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$6(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$j = _export;
var call$b = functionCall;
var aCallable$2 = aCallable$9;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$4;
var iterate$1 = iterate$3;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$j({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$2(C.resolve);
      iterate$1(iterable, function (promise) {
        call$b($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$i = _export;
var call$a = functionCall;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$i({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule$1.f(this);
    call$a(capability.reject, undefined, r);
    return capability.promise;
  }
});

var anObject$8 = anObject$i;
var isObject$7 = isObject$e;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$8(C);
  if (isObject$7(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$h = _export;
var getBuiltIn = getBuiltIn$8;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$h({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

var $$g = _export;
var call$9 = functionCall;
var aCallable$1 = aCallable$9;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$4;
var iterate = iterate$3;

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$$g({ target: 'Promise', stat: true }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$9(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var classof$4 = classof$9;

var $String = String;

var toString$6 = function (argument) {
  if (classof$4(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};

var uncurryThis$e = functionUncurryThis;
var toIntegerOrInfinity$2 = toIntegerOrInfinity$5;
var toString$5 = toString$6;
var requireObjectCoercible$3 = requireObjectCoercible$6;

var charAt$6 = uncurryThis$e(''.charAt);
var charCodeAt$1 = uncurryThis$e(''.charCodeAt);
var stringSlice$5 = uncurryThis$e(''.slice);

var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$5(requireObjectCoercible$3($this));
    var position = toIntegerOrInfinity$2(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt$1(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$6(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$5(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt$5 = stringMultibyte.charAt;
var toString$4 = toString$6;
var InternalStateModule$2 = internalState;
var defineIterator = defineIterator$2;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$2 = InternalStateModule$2.set;
var getInternalState$1 = InternalStateModule$2.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState$2(this, {
    type: STRING_ITERATOR,
    string: toString$4(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$5(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$7 = global$p;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var wellKnownSymbol$9 = wellKnownSymbol$n;

var ITERATOR$2 = wellKnownSymbol$9('iterator');
var TO_STRING_TAG = wellKnownSymbol$9('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty$1(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$7[COLLECTION_NAME] && global$7[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

var classof$3 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
var isArray$3 = Array.isArray || function isArray(argument) {
  return classof$3(argument) == 'Array';
};

var isArray$2 = isArray$3;
var isConstructor$1 = isConstructor$3;
var isObject$6 = isObject$e;
var wellKnownSymbol$8 = wellKnownSymbol$n;

var SPECIES$2 = wellKnownSymbol$8('species');
var $Array$2 = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray$2(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor$1(C) && (C === $Array$2 || isArray$2(C.prototype))) C = undefined;
    else if (isObject$6(C)) {
      C = C[SPECIES$2];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array$2 : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$3 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var bind$4 = functionBindContext;
var uncurryThis$d = functionUncurryThis;
var IndexedObject$1 = indexedObject;
var toObject$6 = toObject$9;
var lengthOfArrayLike$4 = lengthOfArrayLike$7;
var arraySpeciesCreate$2 = arraySpeciesCreate$3;

var push$5 = uncurryThis$d([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$6($this);
    var self = IndexedObject$1(O);
    var boundFunction = bind$4(callbackfn, that);
    var length = lengthOfArrayLike$4(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate$2;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$5(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push$5(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod$1(7)
};

var fails$c = fails$p;
var wellKnownSymbol$7 = wellKnownSymbol$n;
var V8_VERSION$1 = engineV8Version;

var SPECIES$1 = wellKnownSymbol$7('species');

var arrayMethodHasSpeciesSupport$4 = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION$1 >= 51 || !fails$c(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var $$f = _export;
var $map = arrayIteration.map;
var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$4;

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$3('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$$f({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var DESCRIPTORS$4 = descriptors;
var uncurryThis$c = functionUncurryThis;
var objectKeys$1 = objectKeys$3;
var toIndexedObject = toIndexedObject$6;
var $propertyIsEnumerable = objectPropertyIsEnumerable.f;

var propertyIsEnumerable = uncurryThis$c($propertyIsEnumerable);
var push$4 = uncurryThis$c([].push);

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys$1(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS$4 || propertyIsEnumerable(O, key)) {
        push$4(result, TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod(false)
};

var $$e = _export;
var $values = objectToArray.values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$$e({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var SlardarConfig = {
  bid: 'tiktok_pns_web_runtime',
  domains: {
    TTP: 'mon.us.tiktokv.com',
    NON_TTP: 'mon-va.byteoversea.com'
  }
};
var SlardarEventName = {
  RUNTIME_SDK_START_MAIN: 'main_start'
};
var EventSource = {
  MAIN_THREAD: 'main_thread',
  IN_APP: 'in_app',
  SW: 'service_worker'
};
var TrackingEventName = {
  COOKIE_SET: 'cookie_set_by_document',
  COOKIE_GET: 'cookie_get_by_document',
  THIRD_PARTY_TRACKER: 'tracker_use',
  GENERAL_FETCH: 'general_fetch',
  STORAGE_USE: 'storage_use'
};

var pluginRegistrySymbol = Symbol["for"]('pluginRegistry');

var logger = {};
var supportMethods = ['debug', 'info', 'verbose', 'log', 'error', 'warn'];

var _loop = function _loop() {
  var method = _supportMethods[_i];

  logger[method] = function () {
  };
};

for (var _i = 0, _supportMethods = supportMethods; _i < _supportMethods.length; _i++) {
  _loop();
}

var $$d = _export;
var toObject$5 = toObject$9;
var nativeKeys = objectKeys$3;
var fails$b = fails$p;

var FAILS_ON_PRIMITIVES = fails$b(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$$d({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject$5(it));
  }
});

var DESCRIPTORS$3 = descriptors;
var uncurryThis$b = functionUncurryThis;
var call$8 = functionCall;
var fails$a = fails$p;
var objectKeys = objectKeys$3;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$4 = toObject$9;
var IndexedObject = indexedObject;

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty$2 = Object.defineProperty;
var concat$2 = uncurryThis$b([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$a(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$3 && $assign({ b: 1 }, $assign(defineProperty$2({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$2(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$4(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$2(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$3 || call$8(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$c = _export;
var assign$1 = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$$c({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign$1 }, {
  assign: assign$1
});

var $TypeError$3 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$2 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$3('Maximum allowed index exceeded');
  return it;
};

var toPropertyKey = toPropertyKey$3;
var definePropertyModule$1 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$6;

var createProperty$4 = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule$1.f(object, propertyKey, createPropertyDescriptor$2(0, value));
  else object[propertyKey] = value;
};

var $$b = _export;
var fails$9 = fails$p;
var isArray$1 = isArray$3;
var isObject$5 = isObject$e;
var toObject$3 = toObject$9;
var lengthOfArrayLike$3 = lengthOfArrayLike$7;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$2;
var createProperty$3 = createProperty$4;
var arraySpeciesCreate$1 = arraySpeciesCreate$3;
var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$4;
var wellKnownSymbol$6 = wellKnownSymbol$n;
var V8_VERSION = engineV8Version;

var IS_CONCAT_SPREADABLE = wellKnownSymbol$6('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails$9(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport$2('concat');

var isConcatSpreadable = function (O) {
  if (!isObject$5(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray$1(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$$b({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$3(this);
    var A = arraySpeciesCreate$1(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike$3(E);
        doesNotExceedSafeInteger$1(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty$3(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger$1(n + 1);
        createProperty$3(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

/**
 * Unified fetch in ui thread
 * @param requestConfig request config
 * @param requestConfig.rawResponse if set, return complete response body object
 * @returns AxiosPromise
 */

function browserFetch(requestConfig) {
  var _a, _b;

  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _requestConfig$rawRes, rawResponse, axiosConfig, defaultOptions, mergedConfig, response, status;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _requestConfig$rawRes = requestConfig.rawResponse, rawResponse = _requestConfig$rawRes === void 0 ? false : _requestConfig$rawRes, axiosConfig = __rest(requestConfig, ["rawResponse"]);
            defaultOptions = {
              url: '',
              method: 'GET',
              params: {},
              config: {
                timeout: 15000
              }
            };
            mergedConfig = Object.assign(Object.assign({}, defaultOptions), axiosConfig);
            _context.prev = 3;
            _context.next = 6;
            return axios(mergedConfig);

          case 6:
            response = _context.sent;

            if (!rawResponse) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", response);

          case 9:
            status = (_b = (_a = response.data.statusCode) !== null && _a !== void 0 ? _a : response.data.code) !== null && _b !== void 0 ? _b : response.data.status;

            if (!(status === 0 || status === 200)) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return", response.data.body);

          case 12:
            throw response;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](3);

            if (!axios.isCancel(_context.t0)) {
              _context.next = 22;
              break;
            }

            logger.log('request canceled');
            return _context.abrupt("return", null);

          case 22:
            throw _context.t0;

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 15]]);
  }));
}

var domainRegionMap = {
  'va': 'https://api-pns-va.tiktok.com',
  'sg': 'https://api-pns-sg.tiktok.com',
  'us-ttp': 'https://api-pns.us.tiktok.com'
};
function getRuntimeConfig(params) {
  var _headers;

  var region = params.region,
      locale = params.locale;
  var domain = typeof region === 'string' && domainRegionMap[region.toLowerCase()] || 'https://www.tiktok.com';
  return browserFetch({
    url: "".concat(domain, "/node/common/web-privacy-config"),
    params: {
      locale: locale
    },
    withCredentials: false,
    headers: (_headers = {}, _defineProperty(_headers, 'x-web-privacy-sdk-ver', "0.0.0"), _defineProperty(_headers, 'x-pns-referrer', "".concat(location.protocol, "//").concat(location.host).concat(location.pathname)), _headers)
  });
}

var configFetchTask = null;
var cachedQueryArgs = {};

function isPrimitive(obj) {
  return obj !== Object(obj);
}

function isConfigEqual(config1, config2) {
  if (config1 === config2) {
    return true;
  }

  if (isPrimitive(config1) && isPrimitive(config2)) {
    return config1 === config2;
  }

  if (Object.keys(config1).length !== Object.keys(config2).length) {
    return false;
  }

  for (var key in config1) {
    if (!(key in config2)) {
      return false;
    }

    if (!isConfigEqual(config1[key], config2[key])) {
      return false;
    }
  }

  return true;
}
/**
 * Fetch runtime config and cache it according to query params
 * @typedef {Object} RuntimePrivacyQuery
 * @property {string} locale locale name same as starling
 * @property {string} region idc region
 * @returns {Promise<RuntimePrivacyConfig>}
 */


function fetchRuntimeConfig(query) {
  if (typeof window === 'undefined') {
    return Promise.resolve(null);
  }

  if (!query) {
    query = cachedQueryArgs;
  } else {
    query = Object.assign(Object.assign({}, cachedQueryArgs), query);
  }

  if (configFetchTask && isConfigEqual(query, cachedQueryArgs)) {
    return configFetchTask;
  }

  cachedQueryArgs = query;
  configFetchTask = getRuntimeConfig(query);
  return configFetchTask;
}
function getRuntimeQuery() {
  return cachedQueryArgs;
}

var DESCRIPTORS$2 = descriptors;
var FUNCTION_NAME_EXISTS = functionName.EXISTS;
var uncurryThis$a = functionUncurryThis;
var defineProperty$1 = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis$a(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec$2 = uncurryThis$a(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS$2 && !FUNCTION_NAME_EXISTS) {
  defineProperty$1(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec$2(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var $$a = _export;
var global$6 = global$p;

// `globalThis` object
// https://tc39.es/ecma262/#sec-globalthis
$$a({ global: true }, {
  globalThis: global$6
});

var fails$8 = fails$p;
var wellKnownSymbol$5 = wellKnownSymbol$n;
var IS_PURE = isPure;

var ITERATOR$1 = wellKnownSymbol$5('iterator');

var nativeUrl = !fails$8(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR$1]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty = objectDefineProperty;

var defineBuiltInAccessor$1 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};

var anObject$7 = anObject$i;
var iteratorClose = iteratorClose$2;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$7(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};

var bind$3 = functionBindContext;
var call$7 = functionCall;
var toObject$2 = toObject$9;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$2;
var isConstructor = isConstructor$3;
var lengthOfArrayLike$2 = lengthOfArrayLike$7;
var createProperty$2 = createProperty$4;
var getIterator$1 = getIterator$3;
var getIteratorMethod$1 = getIteratorMethod$4;

var $Array$1 = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$2(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind$3(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod$1(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array$1 && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator$1(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call$7(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty$2(result, index, value);
    }
  } else {
    length = lengthOfArrayLike$2(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array$1(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty$2(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var toAbsoluteIndex$1 = toAbsoluteIndex$3;
var lengthOfArrayLike$1 = lengthOfArrayLike$7;
var createProperty$1 = createProperty$4;

var $Array = Array;
var max$2 = Math.max;

var arraySliceSimple = function (O, start, end) {
  var length = lengthOfArrayLike$1(O);
  var k = toAbsoluteIndex$1(start, length);
  var fin = toAbsoluteIndex$1(end === undefined ? length : end, length);
  var result = $Array(max$2(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty$1(result, n, O[k]);
  result.length = n;
  return result;
};

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var uncurryThis$9 = functionUncurryThis;

var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;

var $RangeError = RangeError;
var exec$2 = uncurryThis$9(regexSeparators.exec);
var floor$3 = Math.floor;
var fromCharCode = String.fromCharCode;
var charCodeAt = uncurryThis$9(''.charCodeAt);
var join$3 = uncurryThis$9([].join);
var push$3 = uncurryThis$9([].push);
var replace$4 = uncurryThis$9(''.replace);
var split$2 = uncurryThis$9(''.split);
var toLowerCase$1 = uncurryThis$9(''.toLowerCase);

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = charCodeAt(string, counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = charCodeAt(string, counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        push$3(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        push$3(output, value);
        counter--;
      }
    } else {
      push$3(output, value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor$3(delta / damp) : delta >> 1;
  delta += floor$3(delta / numPoints);
  while (delta > baseMinusTMin * tMax >> 1) {
    delta = floor$3(delta / baseMinusTMin);
    k += base;
  }
  return floor$3(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      push$3(output, fromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    push$3(output, delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor$3((maxInt - delta) / handledCPCountPlusOne)) {
      throw $RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw $RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        var k = base;
        while (true) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          push$3(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor$3(qMinusT / baseMinusT);
          k += base;
        }

        push$3(output, fromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        handledCPCount++;
      }
    }

    delta++;
    n++;
  }
  return join$3(output, '');
};

var stringPunycodeToAscii = function (input) {
  var encoded = [];
  var labels = split$2(replace$4(toLowerCase$1(input), regexSeparators, '\u002E'), '.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    push$3(encoded, exec$2(regexNonASCII, label) ? 'xn--' + encode(label) : label);
  }
  return join$3(encoded, '.');
};

var defineBuiltIn$5 = defineBuiltIn$c;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$5(target, key, src[key], options);
  return target;
};

var arraySlice$2 = arraySliceSimple;

var floor$2 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$2(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice$2(array, 0, middle), comparefn),
    mergeSort(arraySlice$2(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

var arraySort$1 = mergeSort;

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$9 = _export;
var global$5 = global$p;
var call$6 = functionCall;
var uncurryThis$8 = functionUncurryThis;
var DESCRIPTORS$1 = descriptors;
var USE_NATIVE_URL$1 = nativeUrl;
var defineBuiltIn$4 = defineBuiltIn$c;
var defineBuiltIns = defineBuiltIns$1;
var setToStringTag$1 = setToStringTag$5;
var createIteratorConstructor = createIteratorConstructor$2;
var InternalStateModule$1 = internalState;
var anInstance$1 = anInstance$3;
var isCallable$2 = isCallable$n;
var hasOwn$4 = hasOwnProperty_1;
var bind$2 = functionBindContext;
var classof$2 = classof$9;
var anObject$6 = anObject$i;
var isObject$4 = isObject$e;
var $toString$2 = toString$6;
var create$1 = objectCreate;
var createPropertyDescriptor$1 = createPropertyDescriptor$6;
var getIterator = getIterator$3;
var getIteratorMethod = getIteratorMethod$4;
var validateArgumentsLength$1 = validateArgumentsLength$3;
var wellKnownSymbol$4 = wellKnownSymbol$n;
var arraySort = arraySort$1;

var ITERATOR = wellKnownSymbol$4('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalParamsState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule$1.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS$1) return global$5[name];
  var descriptor = getOwnPropertyDescriptor(global$5, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers$1 = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers$1 && Headers$1.prototype;
var RegExp$1 = global$5.RegExp;
var TypeError$2 = global$5.TypeError;
var decodeURIComponent = global$5.decodeURIComponent;
var encodeURIComponent$1 = global$5.encodeURIComponent;
var charAt$4 = uncurryThis$8(''.charAt);
var join$2 = uncurryThis$8([].join);
var push$2 = uncurryThis$8([].push);
var replace$3 = uncurryThis$8(''.replace);
var shift$1 = uncurryThis$8([].shift);
var splice = uncurryThis$8([].splice);
var split$1 = uncurryThis$8(''.split);
var stringSlice$4 = uncurryThis$8(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp$1('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace$3(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace$3(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace$3(encodeURIComponent$1(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState$1(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject$4(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt$4(init, 0) === '?' ? stringSlice$4(init, 1) : init : $toString$2(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call$6(next, iterator)).done) {
        entryIterator = getIterator(anObject$6(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call$6(entryNext, entryIterator)).done ||
          (second = call$6(entryNext, entryIterator)).done ||
          !call$6(entryNext, entryIterator).done
        ) throw TypeError$2('Expected sequence with length 2');
        push$2(this.entries, { key: $toString$2(first.value), value: $toString$2(second.value) });
      }
    } else for (var key in object) if (hasOwn$4(object, key)) {
      push$2(this.entries, { key: key, value: $toString$2(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split$1(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split$1(attribute, '=');
          push$2(this.entries, {
            key: deserialize(shift$1(entry)),
            value: deserialize(join$2(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push$2(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join$2(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance$1(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState$1(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength$1(arguments.length, 2);
    var state = getInternalParamsState(this);
    push$2(state.entries, { key: $toString$2(name), value: $toString$2(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString$2(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$2(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$2(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push$2(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength$1(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString$2(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength$1(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString$2(name);
    var val = $toString$2(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push$2(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind$2(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn$4(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn$4(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

setToStringTag$1(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$$9({ global: true, constructor: true, forced: !USE_NATIVE_URL$1 }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL$1 && isCallable$2(Headers$1)) {
  var headersHas = uncurryThis$8(HeadersPrototype.has);
  var headersSet = uncurryThis$8(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject$4(init)) {
      var body = init.body;
      var headers;
      if (classof$2(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers$1(init.headers) : new Headers$1();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create$1(init, {
          body: createPropertyDescriptor$1(0, $toString$2(body)),
          headers: createPropertyDescriptor$1(0, headers)
        });
      }
    } return init;
  };

  if (isCallable$2(nativeFetch)) {
    $$9({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable$2(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance$1(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $$9({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
      Request: RequestConstructor
    });
  }
}

var web_urlSearchParams_constructor = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`

var $$8 = _export;
var DESCRIPTORS = descriptors;
var USE_NATIVE_URL = nativeUrl;
var global$4 = global$p;
var bind$1 = functionBindContext;
var uncurryThis$7 = functionUncurryThis;
var defineBuiltIn$3 = defineBuiltIn$c;
var defineBuiltInAccessor = defineBuiltInAccessor$1;
var anInstance = anInstance$3;
var hasOwn$3 = hasOwnProperty_1;
var assign = objectAssign;
var arrayFrom = arrayFrom$1;
var arraySlice$1 = arraySliceSimple;
var codeAt = stringMultibyte.codeAt;
var toASCII = stringPunycodeToAscii;
var $toString$1 = toString$6;
var setToStringTag = setToStringTag$5;
var validateArgumentsLength = validateArgumentsLength$3;
var URLSearchParamsModule = web_urlSearchParams_constructor;
var InternalStateModule = internalState;

var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var URLSearchParams$1 = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;

var NativeURL = global$4.URL;
var TypeError$1 = global$4.TypeError;
var parseInt = global$4.parseInt;
var floor$1 = Math.floor;
var pow = Math.pow;
var charAt$3 = uncurryThis$7(''.charAt);
var exec$1 = uncurryThis$7(/./.exec);
var join$1 = uncurryThis$7([].join);
var numberToString = uncurryThis$7(1.0.toString);
var pop = uncurryThis$7([].pop);
var push$1 = uncurryThis$7([].push);
var replace$2 = uncurryThis$7(''.replace);
var shift = uncurryThis$7([].shift);
var split = uncurryThis$7(''.split);
var stringSlice$3 = uncurryThis$7(''.slice);
var toLowerCase = uncurryThis$7(''.toLowerCase);
var unshift = uncurryThis$7([].unshift);

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var ALPHANUMERIC = /[\d+-.a-z]/i;
var DIGIT = /\d/;
var HEX_START = /^0x/i;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */
var EOF;

// https://url.spec.whatwg.org/#ipv4-number-parser
var parseIPv4 = function (input) {
  var parts = split(input, '.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.length--;
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && charAt$3(part, 0) == '0') {
      radix = exec$1(HEX_START, part) ? 16 : 8;
      part = stringSlice$3(part, radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!exec$1(radix == 10 ? DEC : radix == 8 ? OCT : HEX, part)) return input;
      number = parseInt(part, radix);
    }
    push$1(numbers, number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = pop(numbers);
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var chr = function () {
    return charAt$3(input, pointer);
  };

  if (chr() == ':') {
    if (charAt$3(input, 1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (chr()) {
    if (pieceIndex == 8) return;
    if (chr() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && exec$1(HEX, chr())) {
      value = value * 16 + parseInt(chr(), 16);
      pointer++;
      length++;
    }
    if (chr() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (chr()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (chr() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!exec$1(DIGIT, chr())) return;
        while (exec$1(DIGIT, chr())) {
          number = parseInt(chr(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (chr() == ':') {
      pointer++;
      if (!chr()) return;
    } else if (chr()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

// https://url.spec.whatwg.org/#host-serializing
var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      unshift(result, host % 256);
      host = floor$1(host / 256);
    } return join$1(result, '.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += numberToString(host[index], 16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (chr, set) {
  var code = codeAt(chr, 0);
  return code > 0x20 && code < 0x7F && !hasOwn$3(set, chr) ? chr : encodeURIComponent(chr);
};

// https://url.spec.whatwg.org/#special-scheme
var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

// https://url.spec.whatwg.org/#windows-drive-letter
var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && exec$1(ALPHA, charAt$3(string, 0))
    && ((second = charAt$3(string, 1)) == ':' || (!normalized && second == '|'));
};

// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(stringSlice$3(string, 0, 2)) && (
    string.length == 2 ||
    ((third = charAt$3(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

// https://url.spec.whatwg.org/#single-dot-path-segment
var isSingleDot = function (segment) {
  return segment === '.' || toLowerCase(segment) === '%2e';
};

// https://url.spec.whatwg.org/#double-dot-path-segment
var isDoubleDot = function (segment) {
  segment = toLowerCase(segment);
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

var URLState = function (url, isBase, base) {
  var urlString = $toString$1(url);
  var baseState, failure, searchParams;
  if (isBase) {
    failure = this.parse(urlString);
    if (failure) throw TypeError$1(failure);
    this.searchParams = null;
  } else {
    if (base !== undefined) baseState = new URLState(base, true);
    failure = this.parse(urlString, null, baseState);
    if (failure) throw TypeError$1(failure);
    searchParams = getInternalSearchParamsState(new URLSearchParams$1());
    searchParams.bindURL(this);
    this.searchParams = searchParams;
  }
};

URLState.prototype = {
  type: 'URL',
  // https://url.spec.whatwg.org/#url-parsing
  // eslint-disable-next-line max-statements -- TODO
  parse: function (input, stateOverride, base) {
    var url = this;
    var state = stateOverride || SCHEME_START;
    var pointer = 0;
    var buffer = '';
    var seenAt = false;
    var seenBracket = false;
    var seenPasswordToken = false;
    var codePoints, chr, bufferCodePoints, failure;

    input = $toString$1(input);

    if (!stateOverride) {
      url.scheme = '';
      url.username = '';
      url.password = '';
      url.host = null;
      url.port = null;
      url.path = [];
      url.query = null;
      url.fragment = null;
      url.cannotBeABaseURL = false;
      input = replace$2(input, LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
    }

    input = replace$2(input, TAB_AND_NEW_LINE, '');

    codePoints = arrayFrom(input);

    while (pointer <= codePoints.length) {
      chr = codePoints[pointer];
      switch (state) {
        case SCHEME_START:
          if (chr && exec$1(ALPHA, chr)) {
            buffer += toLowerCase(chr);
            state = SCHEME;
          } else if (!stateOverride) {
            state = NO_SCHEME;
            continue;
          } else return INVALID_SCHEME;
          break;

        case SCHEME:
          if (chr && (exec$1(ALPHANUMERIC, chr) || chr == '+' || chr == '-' || chr == '.')) {
            buffer += toLowerCase(chr);
          } else if (chr == ':') {
            if (stateOverride && (
              (url.isSpecial() != hasOwn$3(specialSchemes, buffer)) ||
              (buffer == 'file' && (url.includesCredentials() || url.port !== null)) ||
              (url.scheme == 'file' && !url.host)
            )) return;
            url.scheme = buffer;
            if (stateOverride) {
              if (url.isSpecial() && specialSchemes[url.scheme] == url.port) url.port = null;
              return;
            }
            buffer = '';
            if (url.scheme == 'file') {
              state = FILE;
            } else if (url.isSpecial() && base && base.scheme == url.scheme) {
              state = SPECIAL_RELATIVE_OR_AUTHORITY;
            } else if (url.isSpecial()) {
              state = SPECIAL_AUTHORITY_SLASHES;
            } else if (codePoints[pointer + 1] == '/') {
              state = PATH_OR_AUTHORITY;
              pointer++;
            } else {
              url.cannotBeABaseURL = true;
              push$1(url.path, '');
              state = CANNOT_BE_A_BASE_URL_PATH;
            }
          } else if (!stateOverride) {
            buffer = '';
            state = NO_SCHEME;
            pointer = 0;
            continue;
          } else return INVALID_SCHEME;
          break;

        case NO_SCHEME:
          if (!base || (base.cannotBeABaseURL && chr != '#')) return INVALID_SCHEME;
          if (base.cannotBeABaseURL && chr == '#') {
            url.scheme = base.scheme;
            url.path = arraySlice$1(base.path);
            url.query = base.query;
            url.fragment = '';
            url.cannotBeABaseURL = true;
            state = FRAGMENT;
            break;
          }
          state = base.scheme == 'file' ? FILE : RELATIVE;
          continue;

        case SPECIAL_RELATIVE_OR_AUTHORITY:
          if (chr == '/' && codePoints[pointer + 1] == '/') {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
            pointer++;
          } else {
            state = RELATIVE;
            continue;
          } break;

        case PATH_OR_AUTHORITY:
          if (chr == '/') {
            state = AUTHORITY;
            break;
          } else {
            state = PATH;
            continue;
          }

        case RELATIVE:
          url.scheme = base.scheme;
          if (chr == EOF) {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice$1(base.path);
            url.query = base.query;
          } else if (chr == '/' || (chr == '\\' && url.isSpecial())) {
            state = RELATIVE_SLASH;
          } else if (chr == '?') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice$1(base.path);
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice$1(base.path);
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            url.path = arraySlice$1(base.path);
            url.path.length--;
            state = PATH;
            continue;
          } break;

        case RELATIVE_SLASH:
          if (url.isSpecial() && (chr == '/' || chr == '\\')) {
            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          } else if (chr == '/') {
            state = AUTHORITY;
          } else {
            url.username = base.username;
            url.password = base.password;
            url.host = base.host;
            url.port = base.port;
            state = PATH;
            continue;
          } break;

        case SPECIAL_AUTHORITY_SLASHES:
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          if (chr != '/' || charAt$3(buffer, pointer + 1) != '/') continue;
          pointer++;
          break;

        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
          if (chr != '/' && chr != '\\') {
            state = AUTHORITY;
            continue;
          } break;

        case AUTHORITY:
          if (chr == '@') {
            if (seenAt) buffer = '%40' + buffer;
            seenAt = true;
            bufferCodePoints = arrayFrom(buffer);
            for (var i = 0; i < bufferCodePoints.length; i++) {
              var codePoint = bufferCodePoints[i];
              if (codePoint == ':' && !seenPasswordToken) {
                seenPasswordToken = true;
                continue;
              }
              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
              if (seenPasswordToken) url.password += encodedCodePoints;
              else url.username += encodedCodePoints;
            }
            buffer = '';
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (seenAt && buffer == '') return INVALID_AUTHORITY;
            pointer -= arrayFrom(buffer).length + 1;
            buffer = '';
            state = HOST;
          } else buffer += chr;
          break;

        case HOST:
        case HOSTNAME:
          if (stateOverride && url.scheme == 'file') {
            state = FILE_HOST;
            continue;
          } else if (chr == ':' && !seenBracket) {
            if (buffer == '') return INVALID_HOST;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PORT;
            if (stateOverride == HOSTNAME) return;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial())
          ) {
            if (url.isSpecial() && buffer == '') return INVALID_HOST;
            if (stateOverride && buffer == '' && (url.includesCredentials() || url.port !== null)) return;
            failure = url.parseHost(buffer);
            if (failure) return failure;
            buffer = '';
            state = PATH_START;
            if (stateOverride) return;
            continue;
          } else {
            if (chr == '[') seenBracket = true;
            else if (chr == ']') seenBracket = false;
            buffer += chr;
          } break;

        case PORT:
          if (exec$1(DIGIT, chr)) {
            buffer += chr;
          } else if (
            chr == EOF || chr == '/' || chr == '?' || chr == '#' ||
            (chr == '\\' && url.isSpecial()) ||
            stateOverride
          ) {
            if (buffer != '') {
              var port = parseInt(buffer, 10);
              if (port > 0xFFFF) return INVALID_PORT;
              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
              buffer = '';
            }
            if (stateOverride) return;
            state = PATH_START;
            continue;
          } else return INVALID_PORT;
          break;

        case FILE:
          url.scheme = 'file';
          if (chr == '/' || chr == '\\') state = FILE_SLASH;
          else if (base && base.scheme == 'file') {
            if (chr == EOF) {
              url.host = base.host;
              url.path = arraySlice$1(base.path);
              url.query = base.query;
            } else if (chr == '?') {
              url.host = base.host;
              url.path = arraySlice$1(base.path);
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.host = base.host;
              url.path = arraySlice$1(base.path);
              url.query = base.query;
              url.fragment = '';
              state = FRAGMENT;
            } else {
              if (!startsWithWindowsDriveLetter(join$1(arraySlice$1(codePoints, pointer), ''))) {
                url.host = base.host;
                url.path = arraySlice$1(base.path);
                url.shortenPath();
              }
              state = PATH;
              continue;
            }
          } else {
            state = PATH;
            continue;
          } break;

        case FILE_SLASH:
          if (chr == '/' || chr == '\\') {
            state = FILE_HOST;
            break;
          }
          if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(join$1(arraySlice$1(codePoints, pointer), ''))) {
            if (isWindowsDriveLetter(base.path[0], true)) push$1(url.path, base.path[0]);
            else url.host = base.host;
          }
          state = PATH;
          continue;

        case FILE_HOST:
          if (chr == EOF || chr == '/' || chr == '\\' || chr == '?' || chr == '#') {
            if (!stateOverride && isWindowsDriveLetter(buffer)) {
              state = PATH;
            } else if (buffer == '') {
              url.host = '';
              if (stateOverride) return;
              state = PATH_START;
            } else {
              failure = url.parseHost(buffer);
              if (failure) return failure;
              if (url.host == 'localhost') url.host = '';
              if (stateOverride) return;
              buffer = '';
              state = PATH_START;
            } continue;
          } else buffer += chr;
          break;

        case PATH_START:
          if (url.isSpecial()) {
            state = PATH;
            if (chr != '/' && chr != '\\') continue;
          } else if (!stateOverride && chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            state = PATH;
            if (chr != '/') continue;
          } break;

        case PATH:
          if (
            chr == EOF || chr == '/' ||
            (chr == '\\' && url.isSpecial()) ||
            (!stateOverride && (chr == '?' || chr == '#'))
          ) {
            if (isDoubleDot(buffer)) {
              url.shortenPath();
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$1(url.path, '');
              }
            } else if (isSingleDot(buffer)) {
              if (chr != '/' && !(chr == '\\' && url.isSpecial())) {
                push$1(url.path, '');
              }
            } else {
              if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
                if (url.host) url.host = '';
                buffer = charAt$3(buffer, 0) + ':'; // normalize windows drive letter
              }
              push$1(url.path, buffer);
            }
            buffer = '';
            if (url.scheme == 'file' && (chr == EOF || chr == '?' || chr == '#')) {
              while (url.path.length > 1 && url.path[0] === '') {
                shift(url.path);
              }
            }
            if (chr == '?') {
              url.query = '';
              state = QUERY;
            } else if (chr == '#') {
              url.fragment = '';
              state = FRAGMENT;
            }
          } else {
            buffer += percentEncode(chr, pathPercentEncodeSet);
          } break;

        case CANNOT_BE_A_BASE_URL_PATH:
          if (chr == '?') {
            url.query = '';
            state = QUERY;
          } else if (chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case QUERY:
          if (!stateOverride && chr == '#') {
            url.fragment = '';
            state = FRAGMENT;
          } else if (chr != EOF) {
            if (chr == "'" && url.isSpecial()) url.query += '%27';
            else if (chr == '#') url.query += '%23';
            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
          } break;

        case FRAGMENT:
          if (chr != EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
          break;
      }

      pointer++;
    }
  },
  // https://url.spec.whatwg.org/#host-parsing
  parseHost: function (input) {
    var result, codePoints, index;
    if (charAt$3(input, 0) == '[') {
      if (charAt$3(input, input.length - 1) != ']') return INVALID_HOST;
      result = parseIPv6(stringSlice$3(input, 1, -1));
      if (!result) return INVALID_HOST;
      this.host = result;
    // opaque host
    } else if (!this.isSpecial()) {
      if (exec$1(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
      result = '';
      codePoints = arrayFrom(input);
      for (index = 0; index < codePoints.length; index++) {
        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
      }
      this.host = result;
    } else {
      input = toASCII(input);
      if (exec$1(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
      result = parseIPv4(input);
      if (result === null) return INVALID_HOST;
      this.host = result;
    }
  },
  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
  cannotHaveUsernamePasswordPort: function () {
    return !this.host || this.cannotBeABaseURL || this.scheme == 'file';
  },
  // https://url.spec.whatwg.org/#include-credentials
  includesCredentials: function () {
    return this.username != '' || this.password != '';
  },
  // https://url.spec.whatwg.org/#is-special
  isSpecial: function () {
    return hasOwn$3(specialSchemes, this.scheme);
  },
  // https://url.spec.whatwg.org/#shorten-a-urls-path
  shortenPath: function () {
    var path = this.path;
    var pathSize = path.length;
    if (pathSize && (this.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
      path.length--;
    }
  },
  // https://url.spec.whatwg.org/#concept-url-serializer
  serialize: function () {
    var url = this;
    var scheme = url.scheme;
    var username = url.username;
    var password = url.password;
    var host = url.host;
    var port = url.port;
    var path = url.path;
    var query = url.query;
    var fragment = url.fragment;
    var output = scheme + ':';
    if (host !== null) {
      output += '//';
      if (url.includesCredentials()) {
        output += username + (password ? ':' + password : '') + '@';
      }
      output += serializeHost(host);
      if (port !== null) output += ':' + port;
    } else if (scheme == 'file') output += '//';
    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join$1(path, '/') : '';
    if (query !== null) output += '?' + query;
    if (fragment !== null) output += '#' + fragment;
    return output;
  },
  // https://url.spec.whatwg.org/#dom-url-href
  setHref: function (href) {
    var failure = this.parse(href);
    if (failure) throw TypeError$1(failure);
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-origin
  getOrigin: function () {
    var scheme = this.scheme;
    var port = this.port;
    if (scheme == 'blob') try {
      return new URLConstructor(scheme.path[0]).origin;
    } catch (error) {
      return 'null';
    }
    if (scheme == 'file' || !this.isSpecial()) return 'null';
    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
  },
  // https://url.spec.whatwg.org/#dom-url-protocol
  getProtocol: function () {
    return this.scheme + ':';
  },
  setProtocol: function (protocol) {
    this.parse($toString$1(protocol) + ':', SCHEME_START);
  },
  // https://url.spec.whatwg.org/#dom-url-username
  getUsername: function () {
    return this.username;
  },
  setUsername: function (username) {
    var codePoints = arrayFrom($toString$1(username));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.username = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-password
  getPassword: function () {
    return this.password;
  },
  setPassword: function (password) {
    var codePoints = arrayFrom($toString$1(password));
    if (this.cannotHaveUsernamePasswordPort()) return;
    this.password = '';
    for (var i = 0; i < codePoints.length; i++) {
      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
    }
  },
  // https://url.spec.whatwg.org/#dom-url-host
  getHost: function () {
    var host = this.host;
    var port = this.port;
    return host === null ? ''
      : port === null ? serializeHost(host)
      : serializeHost(host) + ':' + port;
  },
  setHost: function (host) {
    if (this.cannotBeABaseURL) return;
    this.parse(host, HOST);
  },
  // https://url.spec.whatwg.org/#dom-url-hostname
  getHostname: function () {
    var host = this.host;
    return host === null ? '' : serializeHost(host);
  },
  setHostname: function (hostname) {
    if (this.cannotBeABaseURL) return;
    this.parse(hostname, HOSTNAME);
  },
  // https://url.spec.whatwg.org/#dom-url-port
  getPort: function () {
    var port = this.port;
    return port === null ? '' : $toString$1(port);
  },
  setPort: function (port) {
    if (this.cannotHaveUsernamePasswordPort()) return;
    port = $toString$1(port);
    if (port == '') this.port = null;
    else this.parse(port, PORT);
  },
  // https://url.spec.whatwg.org/#dom-url-pathname
  getPathname: function () {
    var path = this.path;
    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join$1(path, '/') : '';
  },
  setPathname: function (pathname) {
    if (this.cannotBeABaseURL) return;
    this.path = [];
    this.parse(pathname, PATH_START);
  },
  // https://url.spec.whatwg.org/#dom-url-search
  getSearch: function () {
    var query = this.query;
    return query ? '?' + query : '';
  },
  setSearch: function (search) {
    search = $toString$1(search);
    if (search == '') {
      this.query = null;
    } else {
      if ('?' == charAt$3(search, 0)) search = stringSlice$3(search, 1);
      this.query = '';
      this.parse(search, QUERY);
    }
    this.searchParams.update();
  },
  // https://url.spec.whatwg.org/#dom-url-searchparams
  getSearchParams: function () {
    return this.searchParams.facade;
  },
  // https://url.spec.whatwg.org/#dom-url-hash
  getHash: function () {
    var fragment = this.fragment;
    return fragment ? '#' + fragment : '';
  },
  setHash: function (hash) {
    hash = $toString$1(hash);
    if (hash == '') {
      this.fragment = null;
      return;
    }
    if ('#' == charAt$3(hash, 0)) hash = stringSlice$3(hash, 1);
    this.fragment = '';
    this.parse(hash, FRAGMENT);
  },
  update: function () {
    this.query = this.searchParams.serialize() || null;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLPrototype);
  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
  var state = setInternalState(that, new URLState(url, false, base));
  if (!DESCRIPTORS) {
    that.href = state.serialize();
    that.origin = state.getOrigin();
    that.protocol = state.getProtocol();
    that.username = state.getUsername();
    that.password = state.getPassword();
    that.host = state.getHost();
    that.hostname = state.getHostname();
    that.port = state.getPort();
    that.pathname = state.getPathname();
    that.search = state.getSearch();
    that.searchParams = state.getSearchParams();
    that.hash = state.getHash();
  }
};

var URLPrototype = URLConstructor.prototype;

var accessorDescriptor = function (getter, setter) {
  return {
    get: function () {
      return getInternalURLState(this)[getter]();
    },
    set: setter && function (value) {
      return getInternalURLState(this)[setter](value);
    },
    configurable: true,
    enumerable: true
  };
};

if (DESCRIPTORS) {
  // `URL.prototype.href` accessors pair
  // https://url.spec.whatwg.org/#dom-url-href
  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
  // `URL.prototype.origin` getter
  // https://url.spec.whatwg.org/#dom-url-origin
  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
  // `URL.prototype.protocol` accessors pair
  // https://url.spec.whatwg.org/#dom-url-protocol
  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
  // `URL.prototype.username` accessors pair
  // https://url.spec.whatwg.org/#dom-url-username
  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
  // `URL.prototype.password` accessors pair
  // https://url.spec.whatwg.org/#dom-url-password
  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
  // `URL.prototype.host` accessors pair
  // https://url.spec.whatwg.org/#dom-url-host
  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
  // `URL.prototype.hostname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hostname
  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
  // `URL.prototype.port` accessors pair
  // https://url.spec.whatwg.org/#dom-url-port
  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
  // `URL.prototype.pathname` accessors pair
  // https://url.spec.whatwg.org/#dom-url-pathname
  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
  // `URL.prototype.search` accessors pair
  // https://url.spec.whatwg.org/#dom-url-search
  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
  // `URL.prototype.searchParams` getter
  // https://url.spec.whatwg.org/#dom-url-searchparams
  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
  // `URL.prototype.hash` accessors pair
  // https://url.spec.whatwg.org/#dom-url-hash
  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
defineBuiltIn$3(URLPrototype, 'toJSON', function toJSON() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
defineBuiltIn$3(URLPrototype, 'toString', function toString() {
  return getInternalURLState(this).serialize();
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  if (nativeCreateObjectURL) defineBuiltIn$3(URLConstructor, 'createObjectURL', bind$1(nativeCreateObjectURL, NativeURL));
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  if (nativeRevokeObjectURL) defineBuiltIn$3(URLConstructor, 'revokeObjectURL', bind$1(nativeRevokeObjectURL, NativeURL));
}

setToStringTag(URLConstructor, 'URL');

$$8({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});

var anObject$5 = anObject$i;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$5(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$7 = fails$p;
var global$3 = global$p;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$3.RegExp;

var UNSUPPORTED_Y$1 = fails$7(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$7(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$7(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var fails$6 = fails$p;
var global$2 = global$p;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$2.RegExp;

var regexpUnsupportedDotAll = fails$6(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var fails$5 = fails$p;
var global$1 = global$p;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$1.RegExp;

var regexpUnsupportedNcg = fails$5(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$5 = functionCall;
var uncurryThis$6 = functionUncurryThis;
var toString$3 = toString$6;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4.exports;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$2 = uncurryThis$6(''.charAt);
var indexOf = uncurryThis$6(''.indexOf);
var replace$1 = uncurryThis$6(''.replace);
var stringSlice$2 = uncurryThis$6(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$5(nativeExec, re1, 'a');
  call$5(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$3(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$5(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$5(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$1(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$2(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$2(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$5(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$2(match.input, charsAdded);
        match[0] = stringSlice$2(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$5(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$7 = _export;
var exec = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$7({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var uncurryThis$5 = functionUncurryThis;
var defineBuiltIn$2 = defineBuiltIn$c;
var regexpExec$1 = regexpExec$2;
var fails$4 = fails$p;
var wellKnownSymbol$3 = wellKnownSymbol$n;
var createNonEnumerableProperty = createNonEnumerableProperty$5;

var SPECIES = wellKnownSymbol$3('species');
var RegExpPrototype$2 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$3(KEY);

  var DELEGATES_TO_SYMBOL = !fails$4(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$4(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis$5(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis$5(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$2(String.prototype, KEY, methods[0]);
    defineBuiltIn$2(RegExpPrototype$2, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype$2[SYMBOL], 'sham', true);
};

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es-x/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

var call$4 = functionCall;
var anObject$4 = anObject$i;
var isCallable$1 = isCallable$n;
var classof$1 = classofRaw$1;
var regexpExec = regexpExec$2;

var $TypeError$2 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$1(exec)) {
    var result = call$4(exec, R, S);
    if (result !== null) anObject$4(result);
    return result;
  }
  if (classof$1(R) === 'RegExp') return call$4(regexpExec, R, S);
  throw $TypeError$2('RegExp#exec called on incompatible receiver');
};

var call$3 = functionCall;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$3 = anObject$i;
var requireObjectCoercible$2 = requireObjectCoercible$6;
var sameValue = sameValue$1;
var toString$2 = toString$6;
var getMethod$1 = getMethod$5;
var regExpExec$1 = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic$1('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible$2(this);
      var searcher = regexp == undefined ? undefined : getMethod$1(regexp, SEARCH);
      return searcher ? call$3(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString$2(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject$3(this);
      var S = toString$2(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec$1(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});

// TODO: Remove from `core-js@4`
var uncurryThis$4 = functionUncurryThis;
var defineBuiltIn$1 = defineBuiltIn$c;

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING$1 = 'toString';
var un$DateToString = uncurryThis$4(DatePrototype[TO_STRING$1]);
var getTime = uncurryThis$4(DatePrototype.getTime);

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (String(new Date(NaN)) != INVALID_DATE) {
  defineBuiltIn$1(DatePrototype, TO_STRING$1, function toString() {
    var value = getTime(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? un$DateToString(this) : INVALID_DATE;
  });
}

var call$2 = functionCall;
var hasOwn$2 = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn$2(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R)
    ? call$2(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$c;
var anObject$2 = anObject$i;
var $toString = toString$6;
var fails$3 = fails$p;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails$3(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$2(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

var EVENT_MAIN_LOAD_FAIL = 'load_main_plugin_fail';

function loadMainModulePlugin(pluginCfg, globalName, monitor) {
  var _a;

  var script = pluginCfg.script,
      name = pluginCfg.name;

  if (!script || !name) {
    logger.warn("[WebPrivacySDK] Plugin config error: ".concat(JSON.stringify(pluginCfg)));
    return;
  }

  var pluginRegistry = (_a = globalThis[globalName]) === null || _a === void 0 ? void 0 : _a[pluginRegistrySymbol];
  return new Promise(function (resolve, reject) {
    var scriptEle = document.createElement('script');
    var scriptUrl = new URL(script);
    var searchParams = new URLSearchParams(scriptUrl.search);
    searchParams.append('globalName', globalName);
    scriptUrl.search = searchParams.toString();
    scriptEle.src = scriptUrl.toString();
    scriptEle.async = true;

    scriptEle.onerror = function (error) {
      monitor.reportError(error);
      monitor.reportCustomizedEvent(EVENT_MAIN_LOAD_FAIL, {
        count: 1
      }, {
        script: script,
        name: name,
        reason: 'script_error'
      });
      reject(error);
    };

    scriptEle.onload = function (e) {
      if (typeof (pluginRegistry === null || pluginRegistry === void 0 ? void 0 : pluginRegistry[name]) === 'undefined') {
        monitor.reportCustomizedEvent(EVENT_MAIN_LOAD_FAIL, {
          count: 1
        }, {
          script: script,
          name: name,
          reason: 'register_error'
        });
        reject();
      } else {
        resolve(pluginRegistry[name]);
      }

      var target = e.target;

      if (target === null || target === void 0 ? void 0 : target.src) {
        monitor.reportPerf(target.src);
      }
    };

    document.head.appendChild(scriptEle);
  });
}

var uncurryThis$3 = functionUncurryThis;
var aCallable = aCallable$9;
var isObject$3 = isObject$e;
var hasOwn$1 = hasOwnProperty_1;
var arraySlice = arraySlice$4;
var NATIVE_BIND = functionBindNative;

var $Function = Function;
var concat$1 = uncurryThis$3([].concat);
var join = uncurryThis$3([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn$1(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
var functionBind = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat$1(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject$3(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};

// TODO: Remove from `core-js@4`
var $$6 = _export;
var bind = functionBind;

// `Function.prototype.bind` method
// https://tc39.es/ecma262/#sec-function.prototype.bind
$$6({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
  bind: bind
});

var $$5 = _export;
var isArray = isArray$3;

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
$$5({ target: 'Array', stat: true }, {
  isArray: isArray
});

var $$4 = _export;
var $includes = arrayIncludes.includes;
var fails$2 = fails$p;
var addToUnscopables = addToUnscopables$2;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$2(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$4({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

var isObject$2 = isObject$e;
var classof = classofRaw$1;
var wellKnownSymbol$2 = wellKnownSymbol$n;

var MATCH$1 = wellKnownSymbol$2('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$2(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$1 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw $TypeError$1("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$1 = wellKnownSymbol$n;

var MATCH = wellKnownSymbol$1('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$3 = _export;
var uncurryThis$2 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$1 = requireObjectCoercible$6;
var toString$1 = toString$6;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf$1 = uncurryThis$2(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$3({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString$1(requireObjectCoercible$1(this)),
      toString$1(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

var tryToString = tryToString$5;

var $TypeError = TypeError;

var deletePropertyOrThrow$1 = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};

var $$2 = _export;
var toObject$1 = toObject$9;
var toAbsoluteIndex = toAbsoluteIndex$3;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$5;
var lengthOfArrayLike = lengthOfArrayLike$7;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$2;
var arraySpeciesCreate = arraySpeciesCreate$3;
var createProperty = createProperty$4;
var deletePropertyOrThrow = deletePropertyOrThrow$1;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$4;

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$1('splice');

var max$1 = Math.max;
var min$1 = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$$2({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$1(max$1(toIntegerOrInfinity$1(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

var $$1 = _export;
var $filter = arrayIteration.filter;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$4;

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$$1({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var sg = {};

(function (exports) {

	Object.defineProperty(exports, '__esModule', { value: true });

	// document.currentScript polyfill by Adam Miller
	// MIT license
	typeof document === 'object' &&
	    (function (document) {
	        if (!('currentScript' in document)) {
	            Object.defineProperty(document, 'currentScript', {
	                get: function () {
	                    // IE 8-10 support script readyState
	                    // IE 11+ support stack trace
	                    try {
	                        throw new Error();
	                    }
	                    catch (err) {
	                        // Find the second match for the "at" string to get file src url from stack.
	                        // Specifically works with the format of stack traces in IE.
	                        var i = 0;
	                        var stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(err.stack);
	                        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
	                        var scriptLocation = (stackDetails && stackDetails[1]) || false;
	                        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
	                        var line = (stackDetails && stackDetails[2]) || 0;
	                        var currentLocation = document.location.href.replace(document.location.hash, '');
	                        var inlineScriptSource = '';
	                        var scripts = document.getElementsByTagName('script'); // Live NodeList collection
	                        if (scriptLocation === currentLocation) {
	                            var pageSource = document.documentElement.outerHTML;
	                            var inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
	                            inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
	                        }
	                        for (; i < scripts.length; i++) {
	                            // If ready state is interactive, return the script tag
	                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
	                            // @ts-ignore
	                            if (scripts[i].readyState === 'interactive') {
	                                return scripts[i];
	                            }
	                            // If src matches, return the script tag
	                            if (scripts[i].src === scriptLocation) {
	                                return scripts[i];
	                            }
	                            // If inline source matches, return the script tag
	                            if (scriptLocation === currentLocation &&
	                                scripts[i].innerHTML &&
	                                scripts[i].innerHTML.trim() === inlineScriptSource) {
	                                return scripts[i];
	                            }
	                        }
	                        // If no match, return null
	                        return null;
	                    }
	                },
	            });
	        }
	    })(document);

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */

	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};

	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}

	function __spreadArray(to, from, pack) {
	    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	        if (ar || !(i in from)) {
	            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	        }
	    }
	    return to.concat(ar || Array.prototype.slice.call(from));
	}

	var DEFAULT_SIZE = 10;
	var DEFAULT_WAIT = 1000;
	var stringifyBatch = function (list) {
	    return JSON.stringify({
	        ev_type: 'batch',
	        list: list,
	    });
	};
	function createBatchSender(config) {
	    var transport = config.transport;
	    var endpoint = config.endpoint, _a = config.size, size = _a === void 0 ? DEFAULT_SIZE : _a, _b = config.wait, wait = _b === void 0 ? DEFAULT_WAIT : _b;
	    var batch = [];
	    var tid = 0;
	    var sender = {
	        getSize: function () {
	            return size;
	        },
	        getWait: function () {
	            return wait;
	        },
	        setSize: function (v) {
	            size = v;
	        },
	        setWait: function (v) {
	            wait = v;
	        },
	        getEndpoint: function () {
	            return endpoint;
	        },
	        setEndpoint: function (v) {
	            endpoint = v;
	        },
	        send: function (e) {
	            batch.push(e);
	            if (batch.length >= size) {
	                sendBatch.call(this);
	            }
	            clearTimeout(tid);
	            tid = setTimeout(sendBatch.bind(this), wait);
	        },
	        flush: function () {
	            clearTimeout(tid);
	            sendBatch.call(this);
	        },
	        getBatchData: function () {
	            return batch.length ? stringifyBatch(batch) : '';
	        },
	        clear: function () {
	            clearTimeout(tid);
	            batch = [];
	        },
	    };
	    function sendBatch() {
	        if (!batch.length) {
	            return;
	        }
	        transport.post({
	            url: endpoint,
	            data: this.getBatchData(),
	        });
	        batch = [];
	    }
	    return sender;
	}

	var EVENTS = [
	    'init',
	    'start',
	    'config',
	    'beforeDestroy',
	    'provide',
	    'report',
	    'beforeBuild',
	    'build',
	    'beforeSend',
	    'send',
	    'beforeConfig',
	];

	var noop = function () { };
	function id(v) {
	    return v;
	}

	// eslint-disable-next-line @typescript-eslint/ban-types
	function isObject(o) {
	    return typeof o === 'object' && o !== null;
	}
	function isInstanceOf(wat, base) {
	    try {
	        return wat instanceof base;
	    }
	    catch (_e) {
	        return false;
	    }
	}
	var objProto = Object.prototype;
	// https://stackoverflow.com/a/5878101
	function isPlainObject(o) {
	    if (isObject(o)) {
	        if (typeof Object.getPrototypeOf === 'function') {
	            var proto = Object.getPrototypeOf(o);
	            return proto === objProto || proto === null;
	        }
	        // cannot test, requires ES3
	        /* istanbul ignore next */
	        return objProto.toString.call(o) === '[object Object]';
	    }
	    return false;
	}
	function isArray(o) {
	    return objProto.toString.call(o) === '[object Array]';
	}
	// eslint-disable-next-line @typescript-eslint/ban-types
	function isFunction(o) {
	    return typeof o === 'function';
	}
	function isBoolean(o) {
	    return typeof o === 'boolean';
	}
	function isNumber(o) {
	    return typeof o === 'number';
	}
	function isString(o) {
	    return typeof o === 'string';
	}
	function isError(wat) {
	    switch (Object.prototype.toString.call(wat)) {
	        case '[object Error]':
	            return true;
	        case '[object Exception]':
	            /* istanbul ignore next */
	            return true;
	        case '[object DOMError]':
	            return true;
	        case '[object DOMException]':
	            /* istanbul ignore next */
	            return true;
	        default:
	            /* istanbul ignore next */
	            return wat instanceof Error;
	    }
	}
	function isEvent(wat) {
	    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
	}
	function isErrorEvent(what) {
	    return Object.prototype.toString.call(what) === '[object ErrorEvent]';
	}
	function isPromiseRejectionEvent(what) {
	    return Object.prototype.toString.call(what) === '[object PromiseRejectionEvent]';
	}

	function hasKey(object, key) {
	    return Object.prototype.hasOwnProperty.call(object, key);
	}
	// 把source对象中的内容深度赋给target, 数组合并
	function mergeDeepConcatArray() {
	    var source = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        source[_i] = arguments[_i];
	    }
	    var result = {};
	    var k = 0;
	    while (k < source.length) {
	        result = _mergeDeepMergeArray(result, source[k++]);
	    }
	    return result;
	}
	// 递归赋值
	function _mergeDeepMergeArray(target, source) {
	    var result = __assign({}, target);
	    for (var key in source) {
	        if (hasKey(source, key) && source[key] !== undefined) {
	            if (isObject(source[key]) && isPlainObject(source[key])) {
	                result[key] = _mergeDeepMergeArray(isObject(target[key]) ? target[key] : {}, source[key]);
	            }
	            else if (isArray(source[key]) && isArray(target[key])) {
	                result[key] = _mergeDeepArray(target[key], source[key]);
	            }
	            else {
	                result[key] = source[key];
	            }
	        }
	    }
	    return result;
	}
	function _mergeDeepArray(target, source) {
	    var _target = isArray(target) ? target : [];
	    var _source = isArray(source) ? source : [];
	    return Array.prototype.concat.call(_target, _source).map(function (v) {
	        if (v instanceof RegExp) {
	            return v;
	        }
	        else if (isObject(v) && isPlainObject(v)) {
	            return _mergeDeepMergeArray({}, v);
	        }
	        else if (isArray(v)) {
	            return _mergeDeepArray([], v);
	        }
	        else {
	            return v;
	        }
	    });
	}
	// 检查数组中是否有元素
	function arrayIncludes(array, value) {
	    if (!isArray(array)) {
	        return false;
	    }
	    if (array.length === 0) {
	        return false;
	    }
	    var k = 0;
	    while (k < array.length) {
	        if (array[k] === value) {
	            return true;
	        }
	        k++;
	    }
	    return false;
	}
	var arrayRemove = function (arr, e) {
	    if (!isArray(arr)) {
	        return arr;
	    }
	    var i = arr.indexOf(e);
	    if (i >= 0) {
	        var arr_ = arr.slice();
	        arr_.splice(i, 1);
	        return arr_;
	    }
	    return arr;
	};
	/**
	 * 按路径访问对象属性
	 * @param target 待访问对象
	 * @param property 访问属性路径
	 * @param { (target: any, property: string): any } visitor 访问器
	 */
	var safeVisit = function (target, path, visitor) {
	    var _a, _b;
	    var paths = path.split('.');
	    var _c = __read(paths), method = _c[0], rest = _c.slice(1);
	    while (target && rest.length > 0) {
	        target = target[method];
	        _a = rest, _b = __read(_a), method = _b[0], rest = _b.slice(1);
	    }
	    if (!target) {
	        return undefined;
	    }
	    return visitor(target, method);
	};
	/**
	 *  按路径调用函数
	 * @param target 待调用对象，如 `client`
	 * @param methods 待调用方法路径，可能是一级路径 `client.start`, 或者是多级命令 `client.context.set`
	 * @param args 调用参数
	 */
	var safeCall = function (target, method, args) {
	    return safeVisit(target, method, function (obj, property) {
	        if (obj && property in obj && isFunction(obj[property])) {
	            try {
	                return obj[property].apply(obj, args);
	            }
	            catch (err) {
	                // ignore
	                return undefined;
	            }
	        }
	    });
	};
	var applyRecord = function () {
	    var record = {};
	    var set = function (key, val) { return (record[key] = val); };
	    var del = function (key) { return delete record[key]; };
	    return [record, set, del];
	};
	var pick = function (obj, keys) {
	    if (!obj || !isObject(obj))
	        return obj;
	    return keys.reduce(function (prev, cur) {
	        prev[cur] = obj[cur];
	        return prev;
	    }, {});
	};

	var camelToKebab = function (str) {
	    return str.replace(/([a-z])([A-Z])/g, function (_, a, b) { return a + "-" + b.toLowerCase(); });
	};
	function getRegexp(ignore) {
	    if (!isArray(ignore)) {
	        return null;
	    }
	    return ignore.length ? joinRegExp(ignore) : null;
	}
	function joinRegExp(patterns) {
	    var sources = [];
	    var len = patterns.length;
	    for (var i = 0; i < len; i++) {
	        var pattern = patterns[i];
	        if (isString(pattern)) {
	            sources.push(pattern.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1'));
	        }
	        else if (pattern && pattern.source) {
	            sources.push(pattern.source);
	        }
	    }
	    return new RegExp(sources.join('|'), 'i');
	}
	function safeStringify(a) {
	    try {
	        return isString(a) ? a : JSON.stringify(a);
	    }
	    catch (err) {
	        return '[FAILED_TO_STRINGIFY]:' + String(err);
	    }
	}

	function createContextAgent() {
	    var context = {};
	    var stringified = {};
	    var contextAgent = {
	        set: function (k, v) {
	            context[k] = v;
	            stringified[k] = safeStringify(v);
	            return contextAgent;
	        },
	        merge: function (ctx) {
	            context = __assign(__assign({}, context), ctx);
	            Object.keys(ctx).forEach(function (key) {
	                stringified[key] = safeStringify(ctx[key]);
	            });
	            return contextAgent;
	        },
	        delete: function (k) {
	            delete context[k];
	            delete stringified[k];
	            return contextAgent;
	        },
	        clear: function () {
	            context = {};
	            stringified = {};
	            return contextAgent;
	        },
	        get: function (k) {
	            return stringified[k];
	        },
	        toString: function () {
	            return __assign({}, stringified);
	        },
	    };
	    return contextAgent;
	}

	// eslint-disable-next-line @typescript-eslint/ban-types
	var hookObjectProperty = function (obj, key, hookFunc) {
	    return function () {
	        var params = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            params[_i] = arguments[_i];
	        }
	        if (!obj) {
	            return noop;
	        }
	        var origin = obj[key];
	        var hookedUnsafe = hookFunc.apply(void 0, __spreadArray([origin], __read(params), false));
	        var hooked = hookedUnsafe;
	        // 给所有 hook 之后的方法包一层 try catch
	        if (isFunction(hooked)) {
	            hooked = function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                try {
	                    return hookedUnsafe.apply(this, args);
	                }
	                catch (_a) {
	                    return isFunction(origin) && origin.apply(this, args);
	                }
	            };
	        }
	        obj[key] = hooked;
	        return function (strict) {
	            if (!strict || hooked === obj[key]) {
	                obj[key] = origin;
	            }
	        };
	    };
	};
	/**
	 * 劫持对象方法
	 * 必须记得给 hookFunc 劫持的方法包 try catch ！
	 * 不在本方法里包是为了避免对象原方法被调用两次
	 */
	var hookMethodDangerously = function (obj, key, hookFunc) {
	    return function () {
	        var params = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            params[_i] = arguments[_i];
	        }
	        obj[key] = hookFunc.apply(void 0, __spreadArray([obj[key]], __read(params), false));
	    };
	};

	var errCount = 0;
	var error = function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    // eslint-disable-next-line no-console
	    console.error.apply(console, __spreadArray(['[SDK]', Date.now(), ("" + errCount++).padStart(8, ' ')], __read(args), false));
	};
	var warnCount = 0;
	var warn = function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    // eslint-disable-next-line no-console
	    console.warn.apply(console, __spreadArray(['[SDK]', Date.now(), ("" + warnCount++).padStart(8, ' ')], __read(args), false));
	};

	var isHitBySampleRate = function (sampleRate) {
	    if (Math.random() < Number(sampleRate)) {
	        return true;
	    }
	    return false;
	};
	var isHitByRandom = function (random, sampleRate) {
	    if (random < Number(sampleRate)) {
	        return true;
	    }
	    return false;
	};

	var runProcessors = function (fns) {
	    return function (e) {
	        var r = e;
	        for (var i = 0; i < fns.length; i++) {
	            if (r) {
	                try {
	                    r = fns[i](r);
	                }
	                catch (err) {
	                    error(err);
	                }
	            }
	            else {
	                break;
	            }
	        }
	        return r;
	    };
	};

	/**
	 * 生成uuid
	 * stolen from https://github.com/kelektiv/node-uuid#readme uuid/v4
	 *
	 * @returns
	 */
	function mathRNG() {
	    var rnds = new Array(16);
	    var r = 0;
	    for (var i = 0; i < 16; i++) {
	        if ((i & 0x03) === 0) {
	            r = Math.random() * 0x100000000;
	        }
	        rnds[i] = (r >>> ((i & 0x03) << 3)) & 0xff;
	    }
	    return rnds;
	}
	function bytesToUuid(buf) {
	    var byteToHex = [];
	    for (var index = 0; index < 256; ++index) {
	        byteToHex[index] = (index + 0x100).toString(16).substr(1);
	    }
	    var i = 0;
	    var bth = byteToHex;
	    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
	    return [
	        bth[buf[i++]],
	        bth[buf[i++]],
	        bth[buf[i++]],
	        bth[buf[i++]],
	        '-',
	        bth[buf[i++]],
	        bth[buf[i++]],
	        '-',
	        bth[buf[i++]],
	        bth[buf[i++]],
	        '-',
	        bth[buf[i++]],
	        bth[buf[i++]],
	        '-',
	        bth[buf[i++]],
	        bth[buf[i++]],
	        bth[buf[i++]],
	        bth[buf[i++]],
	        bth[buf[i++]],
	        bth[buf[i++]],
	    ].join('');
	}
	function uuid() {
	    var rnds = mathRNG();
	    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
	    rnds[6] = (rnds[6] & 0x0f) | 0x40;
	    rnds[8] = (rnds[8] & 0x3f) | 0x80;
	    return bytesToUuid(rnds);
	}

	function createClient(creationConfig) {
	    var builder = creationConfig.builder, createSender = creationConfig.createSender, createDefaultConfig = creationConfig.createDefaultConfig, createConfigManager = creationConfig.createConfigManager, userConfigNormalizer = creationConfig.userConfigNormalizer, initConfigNormalizer = creationConfig.initConfigNormalizer, validateInitConfig = creationConfig.validateInitConfig;
	    var sender;
	    var configManager;
	    var handlers = {};
	    EVENTS.forEach(function (e) { return (handlers[e] = []); });
	    var inited = false;
	    var started = false;
	    // 缓存 start 之前 build 的事件
	    var preStartQueue = [];
	    // 禁止通过 provide 挂载的字段名
	    var reservedNames = [];
	    var client = {
	        getBuilder: function () { return builder; },
	        getSender: function () { return sender; },
	        getPreStartQueue: function () { return preStartQueue; },
	        init: function (c) {
	            if (inited) {
	                warn('already inited');
	                return;
	            }
	            if (c && isObject(c) && validateInitConfig(c)) {
	                var defaultConfig = createDefaultConfig(c);
	                if (!defaultConfig) {
	                    throw new Error('defaultConfig missing');
	                }
	                var initConfig = initConfigNormalizer(c);
	                configManager = createConfigManager(defaultConfig);
	                configManager.setConfig(initConfig);
	                configManager.onChange(function () {
	                    handle('config');
	                });
	                sender = createSender(configManager.getConfig());
	                if (!sender) {
	                    throw new Error('sender missing');
	                }
	                inited = true;
	                handle('init', true);
	            }
	            else {
	                throw new Error('invalid InitConfig, init failed');
	            }
	        },
	        set: function (c) {
	            if (!inited) {
	                return;
	            }
	            if (c && isObject(c)) {
	                handle('beforeConfig', false, c);
	                configManager === null || configManager === void 0 ? void 0 : configManager.setConfig(c);
	            }
	        },
	        config: function (c) {
	            if (!inited) {
	                return;
	            }
	            if (c && isObject(c)) {
	                handle('beforeConfig', false, c);
	                configManager === null || configManager === void 0 ? void 0 : configManager.setConfig(userConfigNormalizer(c));
	            }
	            return configManager === null || configManager === void 0 ? void 0 : configManager.getConfig();
	        },
	        provide: function (name, value) {
	            if (arrayIncludes(reservedNames, name)) {
	                warn("cannot provide " + name + ", reserved");
	                return;
	            }
	            client[name] = value;
	            handle('provide', false, name);
	        },
	        start: function () {
	            var _this = this;
	            if (!inited) {
	                return;
	            }
	            if (started) {
	                return;
	            }
	            configManager === null || configManager === void 0 ? void 0 : configManager.onReady(function () {
	                started = true;
	                handle('start', true);
	                preStartQueue.forEach(function (e) { return _this.build(e); });
	                preStartQueue = [];
	            });
	        },
	        report: function (data) {
	            if (!data) {
	                return;
	            }
	            var processed = runProcessors(handlers['report'])(data);
	            if (!processed) {
	                return;
	            }
	            if (started) {
	                this.build(processed);
	            }
	            else {
	                preStartQueue.push(processed);
	            }
	        },
	        build: function (data) {
	            if (!started) {
	                return;
	            }
	            var preBuild = runProcessors(handlers['beforeBuild'])(data);
	            if (!preBuild) {
	                return;
	            }
	            var built = builder.build(preBuild);
	            if (!built) {
	                return;
	            }
	            var processed = runProcessors(handlers['build'])(built);
	            if (!processed) {
	                return;
	            }
	            this.send(processed);
	        },
	        send: function (data) {
	            if (!started) {
	                return;
	            }
	            var processed = runProcessors(handlers['beforeSend'])(data);
	            if (processed) {
	                sender.send(processed);
	                handle('send', false, processed);
	            }
	        },
	        destroy: function () {
	            handle('beforeDestroy', true);
	        },
	        on: function (ev, handler) {
	            if (ev === 'init' && inited) {
	                handler();
	            }
	            else if (ev === 'start' && started) {
	                handler();
	            }
	            else if (handlers[ev]) {
	                handlers[ev].push(handler);
	            }
	        },
	        off: function (ev, handler) {
	            if (handlers[ev])
	                handlers[ev] = arrayRemove(handlers[ev], handler);
	        },
	    };
	    reservedNames = Object.keys(client);
	    return client;
	    function handle(ev, once) {
	        if (once === void 0) { once = false; }
	        var args = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            args[_i - 2] = arguments[_i];
	        }
	        handlers[ev].forEach(function (f) {
	            try {
	                f.apply(void 0, __spreadArray([], __read(args), false));
	            }
	            catch (_err) {
	                // ignore
	            }
	        });
	        if (once) {
	            handlers[ev].length = 0;
	        }
	    }
	}

	var ContextPlugin = function (client) {
	    var contextAgent = createContextAgent();
	    client.provide('context', contextAgent);
	    client.on('report', function (ev) {
	        if (!ev.extra) {
	            ev.extra = {};
	        }
	        ev.extra.context = contextAgent.toString();
	        return ev;
	    });
	};

	var withCommandArray = function (client, captureContext, applyArgsWithContext) {
	    // 缓存需要异步插件来消费的命令
	    var cache = {};
	    var newClient = function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var methodPath = args[0];
	        if (!methodPath)
	            return;
	        var method = methodPath.split('.')[0];
	        // 捕获上下文，等异步插件加载后传入
	        if (!(method in newClient)) {
	            var cachedCommands = cache[method] || [];
	            // 区分预收集来的上下文与普通上下文
	            var capturedContext = (_a = captureContext === null || captureContext === void 0 ? void 0 : captureContext(client)) !== null && _a !== void 0 ? _a : {};
	            cachedCommands.push(__spreadArray([capturedContext], __read(args), false));
	            cache[method] = cachedCommands;
	            return;
	        }
	        return safeCall(newClient, methodPath, [].slice.call(args, 1));
	    };
	    hookObjectProperty(client, 'provide', function (origin) {
	        return function (name, value) {
	            newClient[name] = value;
	            origin.call(client, name, value);
	        };
	    })();
	    for (var nextKey in client) {
	        // Avoid bugs when hasOwnProperty is shadowed
	        if (Object.prototype.hasOwnProperty.call(client, nextKey)) {
	            newClient[nextKey] = client[nextKey];
	        }
	    }
	    client.on('provide', function (name) {
	        if (cache[name]) {
	            cache[name].forEach(function (cachedCommands) {
	                var _a = __read(cachedCommands), capturedContext = _a[0], args = _a.slice(1);
	                applyArgsWithContext === null || applyArgsWithContext === void 0 ? void 0 : applyArgsWithContext(client, capturedContext, args);
	            });
	            cache[name] = null;
	        }
	    });
	    return newClient;
	};

	function IntegrationPlugin(client) {
	    client.on('init', function () {
	        var nameList = [];
	        var config = client.config();
	        if (!config || !config.integrations) {
	            return;
	        }
	        config.integrations.forEach(function (integration) {
	            if (!arrayIncludes(nameList, integration.name)) {
	                nameList.push(integration.name);
	                integration.setup(client);
	                integration.tearDown && client.on('beforeDestroy', integration.tearDown);
	            }
	        });
	    });
	}

	function getDefaultBrowser() {
	    if (typeof window === 'object' && isObject(window))
	        return window;
	}
	function getDefaultDocument() {
	    if (typeof document === 'object' && isObject(document))
	        return document;
	}
	function getDefaultLocation() {
	    return getDefaultBrowser() && window.location;
	}
	function getDefaultHistory() {
	    return getDefaultBrowser() && window.history;
	}
	function getDefaultPerformance() {
	    if (getDefaultBrowser() && isObject(window.performance))
	        return window.performance;
	}
	function getDefaultXMLHttpRequest() {
	    if (typeof XMLHttpRequest === 'function' && isFunction(XMLHttpRequest))
	        return XMLHttpRequest;
	}
	function getDefaultFetch() {
	    try {
	        new Headers();
	        new Request('');
	        new Response();
	        return window.fetch;
	    }
	    catch (_a) {
	        //
	    }
	}
	function getDefaultMutationObserver() {
	    if (getDefaultBrowser() && isFunction(window.MutationObserver))
	        return window.MutationObserver;
	}
	function getDefaultPerformanceObserver() {
	    if (getDefaultBrowser() && isFunction(window.PerformanceObserver))
	        return window.PerformanceObserver;
	}
	function getDefaultPerformanceTiming() {
	    var performance = getDefaultPerformance();
	    if (performance && isObject(performance.timing))
	        return performance.timing;
	}
	function getDefaultRaf() {
	    if (getDefaultBrowser() && 'requestAnimationFrame' in window) {
	        return window.requestAnimationFrame;
	    }
	}
	function getDefaultCaf() {
	    if (getDefaultBrowser() && 'cancelAnimationFrame' in window) {
	        return window.cancelAnimationFrame;
	    }
	}
	function getDefaultNavigator() {
	    if (getDefaultBrowser() && 'navigator' in window) {
	        return window.navigator;
	    }
	}
	function getDefaultNetworkInformation() {
	    var navigator = getDefaultNavigator();
	    if (navigator) {
	        return navigator.connection || navigator.mozConnection || navigator.webkitConnection;
	    }
	}

	// 获取全局注册表
	var getGlobalRegistry = function (global) {
	    if (!global)
	        return;
	    if (!global.__SLARDAR_REGISTRY__) {
	        global.__SLARDAR_REGISTRY__ = {
	            Slardar: {
	                plugins: [],
	                errors: [],
	            },
	        };
	    }
	    return global.__SLARDAR_REGISTRY__.Slardar;
	};
	var reportSelfError = function () {
	    var errorInfo = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        errorInfo[_i] = arguments[_i];
	    }
	    var registry = getGlobalRegistry(getDefaultBrowser());
	    if (!registry)
	        return;
	    if (!registry.errors) {
	        registry.errors = [];
	    }
	    registry.errors.push(errorInfo);
	};

	var applyMutationObserver = function (MutationObserver, callback) {
	    var observer = MutationObserver && new MutationObserver(callback);
	    var observe = function (target, options) {
	        observer && target && observer.observe(target, options);
	    };
	    var disconnect = function () { return observer && observer.disconnect(); };
	    return [observe, disconnect];
	};
	var applyAnimationFrame = function (document, originRAF, originCAF, force) {
	    var requestAnimationFrame = !isFunction(originRAF) || (force && document && document.hidden)
	        ? function (cb) {
	            cb(0);
	            return 0;
	        }
	        : originRAF;
	    var cancelAnimationFrame = isFunction(originCAF) ? originCAF : noop;
	    /**
	     * 以 animationFrame 调用函数，如果一帧内多次调用，则会取消前面的调用
	     */
	    var af;
	    var scheduleAnimationFrame = function (cb) {
	        af && cancelAnimationFrame(af);
	        af = requestAnimationFrame(cb);
	    };
	    return [scheduleAnimationFrame, requestAnimationFrame, cancelAnimationFrame];
	};
	var applyPerformance = function (performance) {
	    var timing = (performance && performance.timing) || undefined;
	    var now = function () {
	        if (performance && performance.now)
	            return performance.now();
	        var time = Date.now ? Date.now() : +new Date();
	        var start = (timing && timing.navigationStart) || 0;
	        return time - start;
	    };
	    var getEntriesByType = function (type) {
	        var getEntriesByType = (performance || {}).getEntriesByType;
	        return (isFunction(getEntriesByType) && getEntriesByType.call(performance, type)) || [];
	    };
	    var getEntriesByName = function (name) {
	        var getEntriesByName = (performance || {}).getEntriesByName;
	        return (isFunction(getEntriesByName) && getEntriesByName.call(performance, name)) || [];
	    };
	    var clearResourceTiming = function () {
	        var clearResourceTimings = (performance || {}).clearResourceTimings;
	        isFunction(clearResourceTimings) && clearResourceTimings.call(performance);
	    };
	    return [timing, now, getEntriesByType, clearResourceTiming, getEntriesByName];
	};
	var applyPerformanceObserver = function (PerformanceObserver, callback, once, onFail) {
	    var observer = PerformanceObserver &&
	        new PerformanceObserver(function (list, ob) {
	            if (list.getEntries) {
	                list.getEntries().forEach(function (val, i, arr) { return callback(val, i, arr, ob); });
	            }
	            else {
	                onFail && onFail();
	            }
	            once && ob.disconnect();
	        });
	    var observe = function () {
	        var types = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            types[_i] = arguments[_i];
	        }
	        if (!PerformanceObserver || !observer)
	            return onFail && onFail();
	        try {
	            types.forEach(function (type) {
	                if (PerformanceObserver.supportedEntryTypes.indexOf(type) > -1) {
	                    observer.observe({ type: type, buffered: false });
	                }
	            });
	        }
	        catch (_a) {
	            try {
	                observer.observe({ entryTypes: types });
	            }
	            catch (_b) {
	                return onFail && onFail();
	            }
	        }
	    };
	    var disconnect = function () { return observer && observer.disconnect(); };
	    return [observe, disconnect];
	};
	// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
	var applyMonitor = function (monitorCtor, props, cb, deps) {
	    if (props === void 0) { props = {}; }
	    if (deps === void 0) { deps = []; }
	    try {
	        var monitor = monitorCtor.apply(void 0, __spreadArray([], __read(deps), false));
	        return (monitor && monitor(props, cb)) || [];
	    }
	    catch (e) {
	        reportSelfError(e);
	        return [];
	    }
	};

	function getFullUrl(url) {
	    var document = getDefaultDocument();
	    if (!document || !url)
	        return '';
	    var a = document.createElement('a');
	    a.href = url;
	    return a.href;
	}
	function parseUrl(url) {
	    var document = getDefaultDocument();
	    if (!document || !url) {
	        return {
	            url: url,
	            protocol: '',
	            domain: '',
	            query: '',
	            path: '',
	            hash: '',
	        };
	    }
	    var a = document.createElement('a');
	    a.href = url;
	    var path = a.pathname || '/';
	    /* istanbul ignore next */
	    if (path[0] !== '/') {
	        path = '/' + path;
	    }
	    return {
	        url: a.href,
	        protocol: a.protocol.slice(0, -1),
	        domain: a.hostname,
	        query: a.search.substring(1),
	        path: path,
	        hash: a.hash,
	    };
	}
	function getLocationUrl() {
	    var location = getDefaultBrowser() && getDefaultLocation();
	    return location === null || location === void 0 ? void 0 : location.href;
	}

	var captureCurrentContext = function (client) {
	    var capturedContext = {
	        url: getLocationUrl(),
	        timestamp: Date.now(),
	    };
	    var config = client.config();
	    if (config === null || config === void 0 ? void 0 : config.pid) {
	        capturedContext.pid = config.pid;
	    }
	    if (client === null || client === void 0 ? void 0 : client['context']) {
	        capturedContext.context = client['context'].toString();
	    }
	    return capturedContext;
	};
	// only works for sync report
	// async report won't trigger 'report' immediately, es.g. sri
	var syncReportWithCapturedContext = function (client, ctx) {
	    return function (fn) {
	        var inject = function (ev) {
	            ev.overrides = ctx;
	            return ev;
	        };
	        client.on('report', inject);
	        fn();
	        client.off('report', inject);
	    };
	};

	/* eslint-disable @typescript-eslint/prefer-for-of */
	var getCookieId = function (cookieIdName) {
	    var document = getDefaultDocument();
	    try {
	        if (document === null || document === void 0 ? void 0 : document.cookie) {
	            return getValueFromCookieName(document.cookie, cookieIdName);
	        }
	    }
	    catch (_e) {
	        // do nothing
	    }
	    return '';
	};
	function getValueFromCookieName(cookie, name) {
	    if (!cookie || !name) {
	        return '';
	    }
	    return parseCookie(cookie)[name] || '';
	}
	function parseCookie(cookie) {
	    var list = cookie.split(';');
	    var cookieObj = {};
	    for (var i = 0; i < list.length; i++) {
	        var pair = list[i].split('=');
	        var cookieKey = isString(pair[0]) && pair[0].trim();
	        if (cookieKey && isString(pair[1])) {
	            cookieObj[cookieKey] = pair[1].trim();
	        }
	    }
	    return cookieObj;
	}

	function onPageLoad(callback) {
	    var window = getDefaultBrowser();
	    var document = getDefaultDocument();
	    if (!window || !document)
	        return;
	    if (document.readyState === 'complete') {
	        callback();
	        return;
	    }
	    window.addEventListener('load', function () {
	        setTimeout(function () {
	            callback();
	        }, 0);
	    }, false);
	}
	var invokeCallbackOnce = function (cb) {
	    var hasInvoked = false;
	    var invoke = function (params) {
	        if (hasInvoked)
	            return;
	        hasInvoked = true;
	        cb && cb(params);
	    };
	    return [invoke];
	};
	var onPageUnload = function (cb) {
	    var _a = __read(invokeCallbackOnce(cb), 1), invokeCbOnce = _a[0];
	    ['unload', 'beforeunload', 'pagehide'].forEach(function (ev) {
	        addEventListener(ev, invokeCbOnce);
	    });
	};
	var onceHidden = function (cb) {
	    if (document.visibilityState === 'hidden') {
	        cb();
	        return;
	    }
	    var onVisibilityChange = function () {
	        if (document.visibilityState === 'hidden') {
	            cb();
	            removeEventListener('visibilitychange', onVisibilityChange, true);
	        }
	    };
	    addEventListener('visibilitychange', onVisibilityChange, true);
	};
	var loadScript = function (url, callback) {
	    var _a;
	    /* istanbul ignore next */
	    var document = getDefaultDocument();
	    // untestable for now
	    /* istanbul ignore next */
	    if (document) {
	        var script = document.createElement('script');
	        script.src = url;
	        script.crossOrigin = 'anonymous';
	        script.onload = callback;
	        (_a = document.head) === null || _a === void 0 ? void 0 : _a.appendChild(script);
	    }
	};

	/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
	var getStorageItem = function (name) {
	    try {
	        var value = localStorage.getItem(name);
	        var ret = value;
	        if (value && typeof value === 'string') {
	            ret = JSON.parse(value);
	        }
	        return ret;
	    }
	    catch (_e) {
	        return undefined;
	    }
	};
	var setStorageItem = function (key, value) {
	    try {
	        var stringValue = typeof value === 'string' ? value : JSON.stringify(value);
	        localStorage.setItem(key, stringValue);
	    }
	    catch (_o) {
	        // do nothing
	    }
	};

	var headerKeyRe = new RegExp('(cookie|auth|jwt|token|key|ticket|secret|credential|session|password)', 'i');
	var headerValueRe = new RegExp('(bearer|session)', 'i');
	var isSensitiveHeader = function (key, value) {
	    if (!key || !value)
	        return false;
	    return headerKeyRe.test(key) || headerValueRe.test(value);
	};
	function formatXHRAllResponseHeaders(headers) {
	    if (isString(headers) && headers) {
	        return headers.split('\r\n').reduce(function (result, line) {
	            if (isString(line)) {
	                var _a = __read(line.split(': '), 2), name_1 = _a[0], value = _a[1];
	                !isSensitiveHeader(name_1, value) && (result[name_1.toLowerCase()] = value);
	            }
	            return result;
	        }, {});
	    }
	    return {};
	}
	var getEventParams = function (xhr, props, getLatestEntryByName) {
	    var _method = xhr._method, _reqHeaders = xhr._reqHeaders, _url = xhr._url, _start = xhr._start, _data = xhr._data;
	    var params = {
	        api: 'xhr',
	        request: {
	            url: getFullUrl(_url),
	            method: (_method || '').toLowerCase(),
	            headers: _reqHeaders,
	            timestamp: _start,
	        },
	        response: {
	            status: xhr.status || 0,
	            is_custom_error: false,
	            timing: getLatestEntryByName(xhr.responseURL),
	            timestamp: Date.now(),
	        },
	        duration: Date.now() - _start,
	    };
	    if (typeof xhr.getAllResponseHeaders === 'function') {
	        params.response.headers = formatXHRAllResponseHeaders(xhr.getAllResponseHeaders());
	    }
	    var status = params.response.status;
	    var collectBodyOnError = props.collectBodyOnError, extraExtractor = props.extraExtractor;
	    try {
	        var extra = extraExtractor === null || extraExtractor === void 0 ? void 0 : extraExtractor(xhr.response, params);
	        extra && (params.extra = extra);
	        extra && (params.response.is_custom_error = true);
	        // 非 2xx , 3xx 请求，上传request body
	        if (collectBodyOnError && status >= 400) {
	            params.request.body = _data ? "" + _data : undefined;
	            params.response.body = xhr.response ? "" + xhr.response : undefined;
	        }
	    }
	    catch (_o) {
	        // do nothing
	    }
	    return params;
	};
	var checkIsIgnored = function (ignoreUrls, url) {
	    var ignoreRgx = getRegexp(ignoreUrls || []);
	    return !!ignoreRgx && ignoreRgx.test(url);
	};
	var getGetLatestEntryByName = function (performance) {
	    var _a = __read(applyPerformance(performance), 5), getEntriesByName = _a[4];
	    return function (name) {
	        return getEntriesByName(name).pop();
	    };
	};

	var hookSetHeader = function (setRequestHeader) {
	    return function () {
	        var setOptions = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            setOptions[_i] = arguments[_i];
	        }
	        this._reqHeaders = this._reqHeaders || {};
	        var _a = __read(setOptions, 2), name = _a[0], value = _a[1];
	        !isSensitiveHeader(name, value) && (this._reqHeaders[name.toLowerCase()] = value);
	        return setRequestHeader && setRequestHeader.apply(this, setOptions);
	    };
	};
	var hookOnreadystatechange = function (xhr, getLatestEntryByName) {
	    return hookMethodDangerously(xhr, 'onreadystatechange', function (origin, props, cb) {
	        return function () {
	            var ev = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                ev[_i] = arguments[_i];
	            }
	            try {
	                this.readyState === 4 &&
	                    !checkIsIgnored(props.ignoreUrls, xhr._url) &&
	                    cb &&
	                    cb({
	                        ev_type: 'http',
	                        payload: getEventParams(xhr, props, getLatestEntryByName),
	                    });
	            }
	            catch (e) {
	                reportSelfError(e);
	            }
	            return origin && origin.apply(this, ev);
	        };
	    });
	};
	var hookSend = function (send, props, cb, getLatestEntryByName) {
	    return function () {
	        var sendOptions = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            sendOptions[_i] = arguments[_i];
	        }
	        hookOnreadystatechange(this, getLatestEntryByName)(props, props.hookCbAtReq(cb));
	        this._start = Date.now();
	        this._data = sendOptions === null || sendOptions === void 0 ? void 0 : sendOptions[0];
	        return send.apply(this, sendOptions);
	    };
	};
	var hookOpen = function (open) {
	    return function () {
	        var _a;
	        var openOptions = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            openOptions[_i] = arguments[_i];
	        }
	        _a = __read(openOptions, 2), this._method = _a[0], this._url = _a[1];
	        return open.apply(this, openOptions);
	    };
	};
	var hookXhrMethods = function (xhr, props, cb, getLatestEntryByName) {
	    hookMethodDangerously(xhr, 'open', hookOpen)();
	    hookMethodDangerously(xhr, 'setRequestHeader', hookSetHeader)();
	    hookMethodDangerously(xhr, 'send', hookSend)(props, cb, getLatestEntryByName);
	};
	var hookXhr = function (Xhr, props, cb, getLatestEntryByName) {
	    function Ctor() {
	        var xhr = new Xhr();
	        hookXhrMethods(xhr, props, cb, getLatestEntryByName);
	        return xhr;
	    }
	    Ctor.prototype = new Xhr();
	    ['DONE', 'HEADERS_RECIEVED', 'LOADING', 'OPENED', 'UNSENT'].forEach(function (key) {
	        Ctor[key] = Xhr[key];
	    });
	    return Ctor;
	};
	var AjaxMonitor = function (global, performance) {
	    if (global === void 0) { global = getDefaultXMLHttpRequest() && getDefaultBrowser(); }
	    if (performance === void 0) { performance = getDefaultPerformance(); }
	    if (!global) {
	        return;
	    }
	    var getLatestEntryByName = getGetLatestEntryByName(performance);
	    return function (props, cb) {
	        if (props.autoWrap) {
	            var xhrProto = XMLHttpRequest && XMLHttpRequest.prototype;
	            if (xhrProto) {
	                hookXhrMethods(xhrProto, props, cb, getLatestEntryByName);
	            }
	        }
	        var wrapXhr = function (xhr, p, c) {
	            if (p === void 0) { p = props; }
	            if (c === void 0) { c = cb; }
	            return hookXhr(xhr, p, c, getLatestEntryByName);
	        };
	        return [wrapXhr];
	    };
	};

	function getPluginConfig(client, pluginName, defaultConfig) {
	    var _a;
	    var c = (_a = client.config()) === null || _a === void 0 ? void 0 : _a.plugins[pluginName];
	    if (isObject(c)) {
	        return __assign(__assign({}, defaultConfig), c);
	    }
	    else {
	        return c ? defaultConfig : false;
	    }
	}
	var reportOnInitCommonParams = function (client, overrides) {
	    var clientConfig = client.config();
	    var common = {
	        url: getLocationUrl(),
	        pid: clientConfig.pid,
	        view_id: clientConfig.viewId,
	    };
	    return function (ev) {
	        client.report(__assign(__assign({}, ev), { overrides: __assign(__assign({}, common), ((overrides && overrides(ev)) || {})) }));
	    };
	};

	var AJAX_MONITOR_PLUGIN_NAME = 'ajax';
	var defaultConfig$3 = {
	    autoWrap: true,
	    hookCbAtReq: id,
	    ignoreUrls: [],
	    collectBodyOnError: false,
	};
	var getCbHook = function (client) { return function (cb) {
	    if (!cb)
	        return cb;
	    var clientConfig = client.config();
	    var common = {
	        url: getLocationUrl(),
	        pid: clientConfig.pid,
	        view_id: clientConfig.viewId,
	    };
	    return function (ev) {
	        cb(__assign(__assign({}, ev), { overrides: __assign(__assign({}, common), { timestamp: ev.payload.request.timestamp }) }));
	    };
	}; };
	function AjaxMonitorPlugin(client) {
	    client.on('init', function () {
	        var config = getPluginConfig(client, AJAX_MONITOR_PLUGIN_NAME, defaultConfig$3);
	        if (!config) {
	            return;
	        }
	        var tearDownFlag = false;
	        var tearDown = function () {
	            tearDownFlag = true;
	        };
	        var cb = function (ev) { return !tearDownFlag && client.report(ev); };
	        var _a = __read(applyMonitor(AjaxMonitor, __assign(__assign({}, config), { hookCbAtReq: getCbHook(client) }), cb), 1), wrapXhr = _a[0];
	        client.on('beforeDestroy', tearDown);
	        client.provide('wrapXhr', wrapXhr);
	    });
	}

	function isHttpURL(url) {
	    if (!isString(url)) {
	        return false;
	    }
	    var _a = __read(url.split(':'), 2), protocol = _a[0], path = _a[1];
	    return !path || protocol === 'http' || protocol === 'https';
	}
	function isRequest(req, Request) {
	    return req instanceof Request;
	}
	var getFetchUrl = function (req, withQuery, Request) {
	    if (withQuery === void 0) { withQuery = false; }
	    var url = '';
	    if (isRequest(req, Request)) {
	        url = req.url;
	    }
	    else {
	        url = req;
	    }
	    if (!withQuery) {
	        url = isString(url) ? url.split('?')[0] : url;
	    }
	    return url;
	};
	function mergeHeaders(Headers) {
	    var headers = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        headers[_i - 1] = arguments[_i];
	    }
	    return headers.reduce(function (sum, cur) {
	        new Headers(cur).forEach(function (val, key) { return !isSensitiveHeader(key, val) && (sum[key] = val); });
	        return sum;
	    }, {});
	}
	var getFetchMethod = function (req, options, Request) {
	    var method = (options && options.method) || 'get';
	    if (isRequest(req, Request)) {
	        method = req.method || method;
	    }
	    return method.toLowerCase();
	};
	var getFetchBody = function (req, options, Request) {
	    if (isRequest(req, Request)) {
	        return req.body;
	    }
	    else {
	        return options === null || options === void 0 ? void 0 : options.body;
	    }
	};
	var getRequestParams = function (url, req, options, Request) {
	    return {
	        method: getFetchMethod(req, options, Request),
	        timestamp: Date.now(),
	        url: getFullUrl(url),
	    };
	};

	/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
	var hookFetch$1 = function (_fetch, props, cb, Headers, Request, getLatestEntryByName) {
	    return function (req, options) {
	        if (options === void 0) { options = {}; }
	        var fetchPromise = _fetch(req, options);
	        var url = getFetchUrl(req, false, Request);
	        // 有业务方通过 fetch 来将 base64 转化成 blob || 业务方自行配置ignore
	        if (!isHttpURL(url) || checkIsIgnored(props.ignoreUrls, url)) {
	            return fetchPromise;
	        }
	        var hookedCb = props.hookCbAtReq(cb);
	        var httpPayload = {
	            api: 'fetch',
	            request: getRequestParams(req instanceof Request ? req.url : req, req, options, Request),
	            response: {
	                is_custom_error: false,
	            },
	            duration: 0,
	        };
	        try {
	            httpPayload.request.headers = mergeHeaders(Headers, req.headers, options.headers);
	        }
	        catch (e) {
	            reportSelfError(e);
	        }
	        var revokeCb = function () {
	            hookedCb &&
	                hookedCb({
	                    ev_type: 'http',
	                    payload: httpPayload,
	                });
	        };
	        var onResolve = function (res) {
	            var _a;
	            try {
	                httpPayload.response.status = res.status || 0;
	                httpPayload.response.headers = mergeHeaders(Headers, res.headers);
	                httpPayload.duration = Date.now() - httpPayload.request.timestamp;
	                var collectBodyOnError = props.collectBodyOnError, extraExtractor_1 = props.extraExtractor;
	                try {
	                    extraExtractor_1 &&
	                        res
	                            .clone()
	                            .json()
	                            .then(function (o) {
	                            var extra = extraExtractor_1(o, httpPayload);
	                            if (extra) {
	                                httpPayload.extra = extra;
	                                httpPayload.response.is_custom_error = true;
	                            }
	                        });
	                }
	                catch (_o) {
	                    // do nothing
	                }
	                if (collectBodyOnError && res.status >= 400) {
	                    // fetch response body 正确地拿到涉及到异步和拷贝 先不拿
	                    httpPayload.request.body = (_a = getFetchBody(req, options, Request)) === null || _a === void 0 ? void 0 : _a.toString();
	                }
	                var setTiming_1 = function () { return (httpPayload.response.timing = getLatestEntryByName(res.url)); };
	                // 存在 entry 立即拿拿不到的情况
	                setTimeout(function () {
	                    setTiming_1();
	                    revokeCb();
	                }, 100);
	            }
	            catch (e) {
	                reportSelfError(e);
	            }
	        };
	        var onReject = function () {
	            var _a;
	            try {
	                // 请求失败,或被拦截
	                httpPayload.response.status = 0;
	                httpPayload.duration = Date.now() - httpPayload.request.timestamp;
	                // there won't be response in reject handler unless aborted
	                // https://fetch.spec.whatwg.org/#:~:text=If%20response%E2%80%99s%20body%20is%20not%20null%20and%20is%20readable
	                if (props.collectBodyOnError) {
	                    /* istanbul ignore next */
	                    httpPayload.request.body = (_a = getFetchBody(req, options, Request)) === null || _a === void 0 ? void 0 : _a.toString();
	                }
	            }
	            catch (e) {
	                reportSelfError(e);
	            }
	            revokeCb();
	        };
	        fetchPromise.then(onResolve, onReject);
	        return fetchPromise;
	    };
	};
	var FetchMonitor = function (global, Headers, Request, performance) {
	    if (global === void 0) { global = getDefaultFetch() && getDefaultBrowser(); }
	    if (Headers === void 0) { Headers = window.Headers; }
	    if (Request === void 0) { Request = window.Request; }
	    if (performance === void 0) { performance = getDefaultPerformance(); }
	    if (!global || !Headers || !Request) {
	        return;
	    }
	    var getLatestEntryByName = getGetLatestEntryByName(performance);
	    return function (props, cb) {
	        if (props.autoWrap) {
	            // 劫持用户 fetch 方法
	            hookMethodDangerously(global, 'fetch', hookFetch$1)(props, cb, Headers, Request, getLatestEntryByName);
	        }
	        var wrapFetch = function (fetch, p, c) {
	            if (p === void 0) { p = props; }
	            if (c === void 0) { c = cb; }
	            return hookFetch$1(fetch, p, c, Headers, Request, getLatestEntryByName);
	        };
	        return [wrapFetch];
	    };
	};

	var FETCH_MONITOR_PLUGIN_NAME = 'fetch';
	var defaultConfig$2 = {
	    autoWrap: true,
	    hookCbAtReq: id,
	    ignoreUrls: [],
	    collectBodyOnError: false,
	};
	function FetchMonitorPlugin(client) {
	    client.on('init', function () {
	        var config = getPluginConfig(client, FETCH_MONITOR_PLUGIN_NAME, defaultConfig$2);
	        if (!config) {
	            return;
	        }
	        var tearDownFlag = false;
	        var tearDown = function () {
	            tearDownFlag = true;
	        };
	        var cb = function (ev) { return !tearDownFlag && client.report(ev); };
	        var _a = __read(applyMonitor(FetchMonitor, __assign(__assign({}, config), { hookCbAtReq: getCbHook(client) }), cb), 1), wrapFetch = _a[0];
	        client.on('beforeDestroy', tearDown);
	        client.provide('wrapFetch', wrapFetch);
	    });
	}

	var ERROR_FIELDS = ['name', 'message', 'stack', 'filename', 'lineno', 'colno'];
	var normalize = function (ex) {
	    var error;
	    if (!isError(ex)) {
	        if (isPlainObject(ex) || isEvent(ex) || isString(ex)) {
	            error = {
	                message: safeStringify(ex),
	            };
	        }
	    }
	    else {
	        error = pick(ex, ERROR_FIELDS);
	    }
	    return error;
	};
	var normalizeError = function (event) {
	    return normalize(event.error);
	};
	var normalizeException = function (event) {
	    var _a;
	    // dig the object of the rejection out of known event types
	    try {
	        var error = void 0;
	        // PromiseRejectionEvents store the object of the rejection under 'reason'
	        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
	        if ('reason' in event) {
	            error = event.reason;
	        }
	        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
	        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
	        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
	        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
	        // https://github.com/getsentry/sentry-javascript/issues/2380
	        else if ('detail' in event && 'reason' in event.detail) {
	            error = event.detail.reason;
	        }
	        if (error) {
	            var rejectionError = normalize(error);
	            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
	            return __assign(__assign({}, rejectionError), { name: (_a = (rejectionError && rejectionError.name)) !== null && _a !== void 0 ? _a : 'UnhandledRejection' });
	        }
	    }
	    catch (_oO) {
	        // no-empty
	    }
	};
	var normalizeUnknownError = function (exception) {
	    if (isErrorEvent(exception)) {
	        return normalizeError(exception);
	    }
	    else if (isPromiseRejectionEvent(exception)) {
	        return normalizeException(exception);
	    }
	    else {
	        return normalize(exception);
	    }
	};

	/* eslint-disable @typescript-eslint/ban-types */
	var JS_ERROR_EV_TYPE = 'js_error';

	/* eslint-disable @typescript-eslint/prefer-optional-chain */
	var getDefaultExtractor = function (routeMode) { return function (url) {
	    var _a;
	    if (routeMode === 'hash') {
	        return ((_a = parseUrl(url).hash) === null || _a === void 0 ? void 0 : _a.replace(/^#/, '')) || '/';
	    }
	    else {
	        return parseUrl(url).path;
	    }
	}; };
	var applyOnPidChange = function (cb, initPid, firstOriginPid, onPidUpdate) {
	    // store originalPid from url
	    var originalPid = firstOriginPid;
	    // store finalPid send to server
	    var finalPid = initPid;
	    // set init pid in config
	    onPidUpdate && onPidUpdate(initPid);
	    var onPidChange = function (source, newPid, customPid) {
	        // newPid is extractPid from url, should send pageview if changed, no matter customPid changed
	        if (source !== "user_set" /* user_set */ && newPid !== originalPid) {
	            originalPid = newPid;
	            finalPid = customPid !== null && customPid !== void 0 ? customPid : originalPid;
	            onPidUpdate && onPidUpdate(finalPid); // update pid in common
	            cb(source, finalPid);
	            // newPid is by user set, should send pageview if not equal to finalPid
	        }
	        else if (source === "user_set" /* user_set */ && newPid !== finalPid) {
	            finalPid = newPid;
	            onPidUpdate && onPidUpdate(finalPid); // update pid in common
	            cb(source, finalPid);
	        }
	    };
	    var sendInit = function () {
	        initPid && cb("init" /* init */, initPid);
	    };
	    return [onPidChange, sendInit];
	};
	var applyOnUrlChange = function (cb, initUrl) {
	    var url = initUrl;
	    var onUrlChange = function (source, newUrl) {
	        if (newUrl !== url) {
	            url = newUrl;
	            cb(source, url);
	        }
	    };
	    return [onUrlChange];
	};

	var PAGEVIEW_EV_TYPE = 'pageview';
	var PageviewMonitor = function (window, location, history) {
	    if (window === void 0) { window = getDefaultBrowser(); }
	    if (location === void 0) { location = getDefaultLocation(); }
	    if (history === void 0) { history = getDefaultHistory(); }
	    if (!window || !location) {
	        return;
	    }
	    return function (props, cb) {
	        var sendInitFlag = props.sendInit, initPid = props.initPid, routeMode = props.routeMode, extractPid = props.extractPid, onPidUpdate = props.onPidUpdate;
	        var restoreFns = [];
	        var report = function (source, pid) {
	            cb &&
	                cb({
	                    ev_type: PAGEVIEW_EV_TYPE,
	                    payload: {
	                        pid: pid,
	                        source: source,
	                    },
	                });
	        };
	        var extractPidFromUrl = routeMode === 'manual' ? function () { return ''; } : getDefaultExtractor(routeMode);
	        var customPidFromUrl = extractPid || (function () { return undefined; });
	        var getFinalPid = function (url) { var _a; return (_a = customPidFromUrl(url)) !== null && _a !== void 0 ? _a : extractPidFromUrl(url); };
	        var _a = __read(applyOnPidChange(report, initPid || getFinalPid(location.href), extractPidFromUrl(location.href), onPidUpdate), 2), onPidChange = _a[0], sendInit = _a[1];
	        var sendPageview = onPidChange.bind(null, "user_set" /* user_set */);
	        if (routeMode !== 'manual') {
	            var _b = __read(applyOnUrlChange(function (sources, url) {
	                return onPidChange(sources, extractPidFromUrl(url), customPidFromUrl(url));
	            }, ''), 1), onUrlChange_1 = _b[0];
	            var historyChangeListener_1 = function () { return onUrlChange_1("history" /* history */, location.href); };
	            if (history) {
	                var hookStateChange = function (origin) {
	                    return function () {
	                        var params = [];
	                        for (var _i = 0; _i < arguments.length; _i++) {
	                            params[_i] = arguments[_i];
	                        }
	                        try {
	                            origin.apply(history, params);
	                        }
	                        finally {
	                            historyChangeListener_1();
	                        }
	                    };
	                };
	                restoreFns.push(hookObjectProperty(history, 'pushState', hookStateChange)(), hookObjectProperty(history, 'replaceState', hookStateChange)());
	            }
	            if (routeMode === 'hash') {
	                var hashChangeListener_1 = function () { return onUrlChange_1("hash" /* hash */, location.href); };
	                window.addEventListener('hashchange', hashChangeListener_1, true);
	                restoreFns.push(function () { return window.removeEventListener('hashchange', hashChangeListener_1, true); });
	            }
	            else {
	                window.addEventListener('popstate', historyChangeListener_1, true);
	                restoreFns.push(function () { return window.removeEventListener('popstate', historyChangeListener_1, true); });
	            }
	        }
	        var tearDown = function () {
	            restoreFns.forEach(function (fn) { return fn(); });
	        };
	        if (sendInitFlag) {
	            sendInit();
	        }
	        return [sendPageview, tearDown];
	    };
	};

	var PAGEVIEW_MONITOR_PLUGIN_NAME = 'pageview';
	var defaultConfig$1 = {
	    sendInit: true,
	    routeMode: 'history',
	};
	function PageviewMonitorPlugin(client) {
	    client.on('init', function () {
	        var _a;
	        var config = getPluginConfig(client, PAGEVIEW_MONITOR_PLUGIN_NAME, defaultConfig$1);
	        if (!config) {
	            return;
	        }
	        var _b = __read(applyMonitor(PageviewMonitor, __assign(__assign({}, config), { initPid: (_a = client.config()) === null || _a === void 0 ? void 0 : _a.pid, onPidUpdate: function (pid) {
	                client.set({ pid: pid, viewId: pid + "_" + Date.now(), actionId: undefined });
	            } }), client.report.bind(client)), 2), sendPageview = _b[0], tearDown = _b[1];
	        client.on('config', function () {
	            sendPageview(client.config().pid);
	        });
	        client.on('beforeDestroy', tearDown);
	        client.provide('sendPageview', sendPageview);
	    });
	}

	var defaultMetricContext = {
	    isSupport: true,
	    isPolyfill: false,
	    isBounced: false,
	    isCustom: false,
	    type: 'perf',
	};
	var initMetric = function (name, value) {
	    return __assign({ name: name, value: value }, defaultMetricContext);
	};
	var buildSingleMetricPayload = function (singleMetric) { return ({
	    ev_type: 'performance',
	    payload: singleMetric,
	}); };

	var FCP_ENTRY_NAME = 'first-contentful-paint';
	var Paint_Type = 'paint';
	var PaintMonitor = function (PerformanceObserver, performance) {
	    if (PerformanceObserver === void 0) { PerformanceObserver = getDefaultPerformanceObserver(); }
	    if (performance === void 0) { performance = getDefaultPerformance(); }
	    return function (props, cb) {
	        var metricName = props.metricName, entryName = props.entryName;
	        var metric = initMetric(metricName, 0);
	        var _a = __read(invokeCallbackOnce(cb), 1), invokeCbOnce = _a[0];
	        if (!performance || !PerformanceObserver) {
	            metric.isSupport = false;
	            invokeCbOnce(metric);
	            return;
	        }
	        var invokeCb = function (_a) {
	            var startTime = _a.startTime;
	            metric.value = startTime;
	            invokeCbOnce(metric);
	        };
	        var _b = __read(applyPerformance(performance), 5), getEntriesByName = _b[4];
	        var paint = getEntriesByName(entryName)[0];
	        // 先从 performance 里拿一下，拿不到则用 PerformanceObserver 监听
	        if (paint) {
	            invokeCb(paint);
	        }
	        else {
	            var invokeCbWithDisconnect = function (entry) {
	                if (entry.name === entryName) {
	                    invokeCb(entry);
	                    disconnect_1();
	                }
	            };
	            var _c = __read(applyPerformanceObserver(PerformanceObserver, invokeCbWithDisconnect), 2), observe = _c[0], disconnect_1 = _c[1];
	            observe(Paint_Type);
	            var handleOnceHidden = function () {
	                metric.isSupport = false;
	                invokeCbOnce(metric);
	                disconnect_1();
	            };
	            onceHidden(handleOnceHidden);
	            // 跳出率支持
	            var handlePageUnload = function () {
	                metric.isBounced = true;
	                invokeCbOnce(metric);
	                disconnect_1();
	            };
	            onPageUnload(handlePageUnload);
	        }
	    };
	};

	var defaultPerformancePrecollect = {
	    entries: [],
	    observer: undefined,
	};

	/**
	 * start 方法开启一个调度器，传入回调和调度时间
	 * reschedule 重新以一个更长的时间调度
	 * stop 停止调度
	 */
	var applyScheduler = function (now) {
	    var timerActiveTime = -Infinity;
	    var timerId = undefined;
	    var callback;
	    var clearTime = function () { return window.clearTimeout(timerId); };
	    var reschedule = function (earliestTime) {
	        if (timerActiveTime > earliestTime || !callback) {
	            return;
	        }
	        clearTime();
	        timerId = window.setTimeout(callback, earliestTime - now());
	        timerActiveTime = earliestTime;
	    };
	    var start = function (cb, earliestTime) {
	        callback = cb;
	        reschedule(earliestTime);
	    };
	    var stop = function () {
	        clearTime();
	        callback = undefined;
	    };
	    return [start, stop, reschedule];
	};
	/**
	 * Computes the time (in milliseconds since requestStart) that the network was
	 * last known to have >2 requests in-flight.
	 */
	var calcLastNet2Busy = function (undoneReqStarts, observedResReqs, now) {
	    if (undoneReqStarts.length > 2) {
	        return now();
	    }
	    var endpoints = [];
	    for (var i = 0; i < observedResReqs.length; i++) {
	        endpoints.push([observedResReqs[i].start, 0 /* S */], [observedResReqs[i].end, 1 /* E */]);
	    }
	    for (var i = 0; i < undoneReqStarts.length; i++) {
	        endpoints.push([undoneReqStarts[i], 0 /* S */]);
	    }
	    endpoints.sort(function (a, b) { return a[0] - b[0]; });
	    var currentActive = undoneReqStarts.length;
	    for (var i = endpoints.length - 1; i >= 0; i--) {
	        var _a = __read(endpoints[i], 2), timestamp = _a[0], type = _a[1];
	        switch (type) {
	            case 0 /* S */:
	                currentActive--;
	                break;
	            case 1 /* E */:
	                currentActive++;
	                if (currentActive > 2) {
	                    return timestamp;
	                }
	                break;
	        }
	    }
	    // If we reach here, we were never network 2-busy.
	    return 0;
	};
	var getRequestTimes = function (requestTimes) {
	    var keys = Object.keys(requestTimes);
	    var result = [];
	    // eslint-disable-next-line @typescript-eslint/prefer-for-of
	    for (var i = 0; i < keys.length; i++) {
	        var val = requestTimes[keys[i]];
	        if (typeof val === 'number') {
	            result.push(val);
	        }
	    }
	    return result;
	};
	/**
	 * 监听包含 ['img', 'script', 'iframe', 'link', 'audio', 'video', 'source'] 标签的 dom 变更
	 */
	var observeResFetchMutations = function (MutationObserver, callback) {
	    var requestCreatingNodeNames = ['img', 'script', 'iframe', 'link', 'audio', 'video', 'source'];
	    function subtreeContainsNodeName(nodes, nodeNames) {
	        for (var i = 0; i < nodes.length; i++) {
	            if (arrayIncludes(nodeNames, nodes[i].nodeName.toLowerCase()) ||
	                (nodes[i].children &&
	                    subtreeContainsNodeName(nodes[i].children, nodeNames))) {
	                return true;
	            }
	        }
	        return false;
	    }
	    var _a = __read(applyMutationObserver(MutationObserver, function (mutations) {
	        for (var i = 0; i < mutations.length; i++) {
	            if ((mutations[i].type === 'childList' &&
	                subtreeContainsNodeName(mutations[i].addedNodes, requestCreatingNodeNames)) ||
	                (mutations[i].type === 'attributes' &&
	                    arrayIncludes(requestCreatingNodeNames, mutations[i].target.nodeName.toLowerCase()))) {
	                callback(mutations[i]);
	            }
	        }
	    }), 2), observe = _a[0], disconnect = _a[1];
	    return [
	        function () {
	            return observe(document, {
	                attributes: true,
	                childList: true,
	                subtree: true,
	                attributeFilter: ['href', 'src'],
	            });
	        },
	        disconnect,
	    ];
	};
	/**
	 * Returns either a manually set min value or the time since
	 * domContentLoadedEventEnd and navigationStart. If the
	 * domContentLoadedEventEnd data isn't available, `null` is returned.
	 * @return {number|null}
	 */
	var getMinValue = function (timing) {
	    var _a = timing || {}, domContentLoadedEventEnd = _a.domContentLoadedEventEnd, _b = _a.navigationStart, navigationStart = _b === void 0 ? 0 : _b;
	    return domContentLoadedEventEnd ? domContentLoadedEventEnd - navigationStart : null;
	};
	/**
	 * Computes the TTI value...
	 * @param {number} searchStart
	 * @param {number} minValue
	 * @param {number} lastKnownNetwork2Busy
	 * @param {number} currentTime
	 * @param {!Array<{start: (number), end: (number)}>} longTasks
	 * @return {number|null}
	 */
	var computeTTI = function (searchStart, minValue, lastKnownNetwork2Busy, currentTime, longTasks) {
	    // Have not reached network 2-quiet yet.
	    if (currentTime - lastKnownNetwork2Busy < 5000) {
	        return null;
	    }
	    var maybeFCI = longTasks.length === 0 ? searchStart : longTasks[longTasks.length - 1].end;
	    // Main thread has not been quiet for long enough.
	    if (currentTime - maybeFCI < 5000) {
	        return null;
	    }
	    return Math.max(maybeFCI, minValue);
	};
	/**
	 * 劫持 XHR.open 方法, 记录 method
	 */
	var hookXHROpen = function (open) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._method = args[0];
	        return open.apply(this, args);
	    };
	};
	/**
	 * 劫持 XHR.send 方法，回调 uniqId 为偶数
	 */
	var hookXHRSend = function (send, before, after) {
	    var uniqId = 0;
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (this._method !== 'GET') {
	            return send.apply(this, args);
	        }
	        // No arrow function.
	        var requestId = (uniqId += 2);
	        before(requestId, Date.now());
	        hookObjectProperty(this, 'onreadystatechange', function (onreadystatechange) {
	            return function (e) {
	                onreadystatechange && onreadystatechange.call(this, e);
	                this.readyState === 4 && after(requestId);
	            };
	        })();
	        return send.apply(this, args);
	    };
	};
	/**
	 * 劫持 fetch，回调 uniqId 为奇数
	 */
	var hookFetch = function (_fetch, before, after) {
	    var uniqId = 1;
	    return function () {
	        var _a, _b;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var fetchMethod = ((_a = args[0]) === null || _a === void 0 ? void 0 : _a.method) || ((_b = args[1]) === null || _b === void 0 ? void 0 : _b.method) || 'GET';
	        if (fetchMethod !== 'GET') {
	            return _fetch.apply(void 0, __spreadArray([], __read(args), false));
	        }
	        return new Promise(function (resolve, reject) {
	            var requestId = (uniqId += 2);
	            before(requestId, Date.now());
	            _fetch.apply(void 0, __spreadArray([], __read(args), false)).then(function (value) {
	                after(requestId);
	                resolve(value);
	            }, function (err) {
	                after(requestId, err);
	                reject(err);
	            });
	        });
	    };
	};
	/**
	 * 返回的 iterEntries 方法用于迭代监听到的 longtask 和 resource entries，
	 * 将缓存监听到的 longTasks 和 network
	 */
	var gatherLongTaskAndNetworks = function () {
	    var longTasks = [];
	    var networkRequests = [];
	    var iterEntries = function (longTaskCb, resourceCb) {
	        return function (entry) {
	            var _a = entry, startTime = _a.startTime, duration = _a.duration, fetchStart = _a.fetchStart, responseEnd = _a.responseEnd, entryType = _a.entryType;
	            if (entryType === 'longtask') {
	                entry.start = startTime;
	                entry.end = startTime + duration;
	                longTasks.push(entry);
	                longTaskCb && longTaskCb(entry);
	            }
	            else if (entryType === 'resource') {
	                networkRequests.push({
	                    start: fetchStart,
	                    end: responseEnd,
	                });
	                resourceCb && resourceCb(entry);
	            }
	        };
	    };
	    return [longTasks, networkRequests, iterEntries];
	};

	var TTIMonitorMetricName = 'tti';
	/**
	 * 劫持 XHR 和 fetch，监听当前页面未完成的 GET 请求数量
	 */
	var applyIncompleteReq = function (global, XMLHttpRequest) {
	    var _a = __read(applyRecord(), 3), incompleteInitReqStartTimes = _a[0], before = _a[1], after = _a[2];
	    var restoreXHROpen = XMLHttpRequest && hookObjectProperty(XMLHttpRequest.prototype, 'open', hookXHROpen)();
	    var restoreXHRSend = XMLHttpRequest && hookObjectProperty(XMLHttpRequest.prototype, 'send', hookXHRSend)(before, after);
	    var restoreFetch = global && hookObjectProperty(global, 'fetch', hookFetch)(before, after);
	    var restore = function () {
	        restoreXHROpen && restoreXHROpen(true);
	        restoreXHRSend && restoreXHRSend(true);
	        restoreFetch && restoreFetch(true);
	    };
	    return [incompleteInitReqStartTimes, restore];
	};
	/**
	 * 监听 longtask resource 和 网络请求
	 * 返回 longtasks 数组、停止监听的函数、拿到最近一次请求大于2的时间的函数
	 */
	var observeLongTaskAndNetAndResource = function (global, XMLHttpRequest, PerformanceObserver, MutationObserver) {
	    return function (precollect, scheduler, // checkTTI 调度器
	    now) {
	        var _a = __read(gatherLongTaskAndNetworks(), 3), longTasks = _a[0], networkRequests = _a[1], iterEntries = _a[2];
	        var _b = __read(applyIncompleteReq(global, XMLHttpRequest), 2), incompleteInitReqStartTimes = _b[0], restoreHook = _b[1];
	        // 如果有资源节点新增，那么五秒后尝试 checkTTI
	        var _c = __read((MutationObserver && observeResFetchMutations(MutationObserver, function () { return scheduler(now() + 5000); })) || [], 2), observeRes = _c[0], stopObserveRes = _c[1];
	        observeRes && observeRes();
	        var getLastBusy = function () { return calcLastNet2Busy(getRequestTimes(incompleteInitReqStartTimes), networkRequests, now); };
	        var _d = __read(applyPerformanceObserver(PerformanceObserver, iterEntries(
	        // 遇到 longTask 则在 longTask 5秒后 checkTTI
	        function (_a) {
	            var startTime = _a.startTime, duration = _a.duration;
	            return scheduler(startTime + duration + 5000);
	        }, 
	        // 遇到 resource 加载，则在最后一次 busy 5 秒后 checkTTI
	        function () { return scheduler(getLastBusy() + 5000); }), false, function () { return (longTasks.notSupport = true); }), 2), observe = _d[0], stopLongTaskAndNetwork = _d[1];
	        var teardown = function () {
	            restoreHook();
	            stopLongTaskAndNetwork();
	            stopObserveRes && stopObserveRes();
	        };
	        observe('longtask', 'resource');
	        precollect.forEach(iterEntries());
	        return [longTasks, teardown, getLastBusy];
	    };
	};
	var TTIMonitor = function (XMLHttpRequest, window, PerformanceObserver, MutationObserver, performance) {
	    if (XMLHttpRequest === void 0) { XMLHttpRequest = getDefaultXMLHttpRequest(); }
	    if (window === void 0) { window = getDefaultFetch() && getDefaultBrowser(); }
	    if (PerformanceObserver === void 0) { PerformanceObserver = getDefaultPerformanceObserver(); }
	    if (MutationObserver === void 0) { MutationObserver = getDefaultMutationObserver(); }
	    if (performance === void 0) { performance = getDefaultPerformance(); }
	    return function (props, cb, tearDown, polyfill) {
	        var metric = initMetric(TTIMonitorMetricName, 0);
	        var buildTTIAndCb = function (_metric) {
	            var payload = buildSingleMetricPayload(_metric);
	            cb && cb(payload);
	        };
	        var _a = __read(invokeCallbackOnce(buildTTIAndCb), 1), buildAndInvokeCbOnce = _a[0];
	        if (!XMLHttpRequest || !window || !PerformanceObserver || !performance) {
	            metric.isSupport = false;
	            buildAndInvokeCbOnce(metric);
	            return [function () { return 0; }];
	        }
	        // If minValue is null, by default it is DOMContentLoadedEnd.
	        var precollect = props.precollect, _b = props.isAsync, isAsync = _b === void 0 ? 0 : _b, _c = props.minValue, minValue = _c === void 0 ? null : _c;
	        var _d = precollect || {}, _e = _d.entries, entries = _e === void 0 ? [] : _e, snippetObserver = _d.observer;
	        var _f = __read(applyPerformance(performance), 5), timing = _f[0], now = _f[1], getEntriesByName = _f[4];
	        var _g = __read(applyScheduler(now), 3), startSchedule = _g[0], stopSchedule = _g[1], reschedule = _g[2];
	        var _h = __read(observeLongTaskAndNetAndResource(window, XMLHttpRequest, PerformanceObserver, MutationObserver)(!isAsync ? entries : [], reschedule, now), 3), longTasks = _h[0], stopObserve = _h[1], getLastBusy = _h[2];
	        var disable = function () {
	            stopSchedule();
	            stopObserve();
	            tearDown && tearDown();
	            snippetObserver && snippetObserver.disconnect();
	            entries.length = 0;
	        };
	        var checkTTI = function (checkCb) {
	            var firstContentfulPaint = getEntriesByName('first-contentful-paint')[0];
	            var maybeFCI = computeTTI((firstContentfulPaint ? firstContentfulPaint.startTime : getMinValue(timing)) || 0, minValue || getMinValue(timing) || 0, getLastBusy(), now() + (checkCb ? 0 : 5000), // 同步模式下加 5 秒保证静默窗口
	            longTasks);
	            if (!checkCb) {
	                // 同步模式下立即返回
	                disable();
	                return maybeFCI;
	            }
	            if (!maybeFCI)
	                return reschedule(now() + 1000);
	            disable();
	            checkCb(maybeFCI);
	        };
	        polyfill && polyfill(longTasks, reschedule, metric);
	        if (longTasks.notSupport) {
	            metric.isSupport = false;
	            buildAndInvokeCbOnce(metric);
	            return [function () { return 0; }];
	        }
	        var invokeCb = function (value) {
	            metric.value = value;
	            buildAndInvokeCbOnce(metric);
	        };
	        var lastLongTask = longTasks[longTasks.length - 1];
	        startSchedule(function () { return checkTTI(invokeCb); }, Math.max(getLastBusy() + 5000, lastLongTask ? lastLongTask.end : 0));
	        var getTTISync = function () {
	            return checkTTI() || 0;
	        };
	        return [getTTISync];
	    };
	};

	var TTI_MONITOR_PLUGIN_NAME = 'tti';
	function TTIMonitorPlugin(client) {
	    client.on('init', function () {
	        var config = getPluginConfig(client, TTI_MONITOR_PLUGIN_NAME, {});
	        if (!config) {
	            return;
	        }
	        var precollect = client.pp || defaultPerformancePrecollect;
	        // TODO：如果新增SPA方法，需要重置 reportOnInitCommonParams
	        applyMonitor(TTIMonitor, __assign(__assign({}, config), { precollect: precollect }), reportOnInitCommonParams(client));
	    });
	}

	var FMPMonitorMetricName = 'fmp';
	var RENDER_TYPR_SSR = 'SSR';
	var DEFAULT_IGNORE_TAGS = ['SCRIPT', 'STYLE', 'META', 'HEAD'];
	var getScore = function (element, depth, exist, ignoreTags) {
	    if (!element || ignoreTags.indexOf(element.tagName) > -1) {
	        return 0;
	    }
	    var _a = element.children, children = _a === void 0 ? [] : _a;
	    var score = [].slice
	        .call(children)
	        .reduceRight(function (sum, child) { return sum + getScore(child, depth + 1, sum > 0, ignoreTags); }, 0);
	    if (score <= 0 && !exist) {
	        if (!isFunction(element.getBoundingClientRect)) {
	            return 0;
	        }
	        var _b = element.getBoundingClientRect() || {}, top_1 = _b.top, height = _b.height;
	        if (top_1 > window.innerHeight || height <= 0) {
	            return 0;
	        }
	    }
	    return score + 1 + 0.5 * depth;
	};
	var getFMPInternal = function (_a) {
	    var _b = _a === void 0 ? [] : _a, _c = __read(_b), first = _c[0], rest = _c.slice(1);
	    return ((rest &&
	        rest.reduce(function (_a, cur) {
	            var _b = __read(_a, 2), prev = _b[0], target = _b[1];
	            var diff = cur.score - prev.score;
	            return [cur, cur.time >= prev.time && target.rate < diff ? { time: cur.time, rate: diff } : target];
	        }, [first, { time: first === null || first === void 0 ? void 0 : first.time, rate: 0 }])[1].time) ||
	        0);
	};
	var FMPMonitor = function (document, MutationObserver, navigationStart, raf, caf) {
	    var _a;
	    if (document === void 0) { document = getDefaultDocument(); }
	    if (MutationObserver === void 0) { MutationObserver = getDefaultMutationObserver(); }
	    if (navigationStart === void 0) { navigationStart = (_a = getDefaultPerformanceTiming()) === null || _a === void 0 ? void 0 : _a.navigationStart; }
	    if (raf === void 0) { raf = getDefaultRaf(); }
	    if (caf === void 0) { caf = getDefaultCaf(); }
	    return function (props, cb) {
	        var renderType = props.renderType;
	        var metric = initMetric(FMPMonitorMetricName, 0);
	        var buildFMPAndCb = function (_metric) {
	            var payload = buildSingleMetricPayload(_metric);
	            cb && cb(payload);
	        };
	        if (renderType === RENDER_TYPR_SSR) {
	            applyMonitor(PaintMonitor, { metricName: FMPMonitorMetricName, entryName: FCP_ENTRY_NAME }, buildFMPAndCb);
	            return [noop];
	        }
	        var _a = __read(invokeCallbackOnce(buildFMPAndCb), 1), buildAndInvokeCbOnce = _a[0];
	        if (!document || !MutationObserver || !navigationStart) {
	            metric.isSupport = false;
	            buildAndInvokeCbOnce(metric);
	            return [noop];
	        }
	        var startTime = Date.now();
	        var list = [];
	        var record = function () {
	            return list.push({
	                time: Date.now() - startTime,
	                score: getScore(document && document.body, 1, false, DEFAULT_IGNORE_TAGS),
	            });
	        };
	        var _b = __read(applyAnimationFrame(document, raf, caf, true), 1), scheduleAF = _b[0];
	        // 持续监听 dom 变化，记录下时间和得分
	        // 这边放在 animationFrame 中计算一是为了避免强制回流
	        // 二是因为 Mutation callback 是作为 microTask 触发，在下一帧之前的任何 dom 变更不会立刻渲染在视图上，而真正渲染是在 animationFrame 中，
	        var _c = __read(applyMutationObserver(MutationObserver, function () { return scheduleAF(record); }), 2), observe = _c[0], disconnect = _c[1];
	        /**
	         * 停止监听，并从当前记录下的数据中计算出得分变化最大的时间点，作为 fmp
	         * 此方法在 performance monitor 的 perfLog 中调用
	         */
	        var tirggerFMP = function (timeGap) {
	            if (timeGap === void 0) { timeGap = 0; }
	            disconnect();
	            var fmp = getFMPInternal(list);
	            metric.value = fmp ? fmp + timeGap : 0;
	            buildAndInvokeCbOnce(metric);
	        };
	        var timeGap = startTime - (navigationStart || 0);
	        observe(document, { subtree: true, childList: true });
	        return [tirggerFMP.bind(null, timeGap)];
	    };
	};

	var FMP_MONITOR_PLUGIN_NAME = 'fmp';
	var defaultConfig = {
	    renderType: 'CSR',
	};
	function FMPMonitorPlugin(client) {
	    client.on('init', function () {
	        var config = getPluginConfig(client, FMP_MONITOR_PLUGIN_NAME, defaultConfig);
	        if (!config) {
	            return;
	        }
	        // TODO：如果新增SPA方法，需要重置 reportOnInitCommonParams
	        var _a = __read(applyMonitor(FMPMonitor, config, reportOnInitCommonParams(client)), 1), tirggerFMP = _a[0];
	        // trigger fmp
	        onPageLoad(function () { return setTimeout(tirggerFMP, 200); });
	    });
	}

	var HEATMAP_MONITOR_PLUGIN_NAME = 'heatmap';

	var CUSTOM_EV_TYPE = 'custom';
	var CUSTOM_EVENT_TYPE = 'event';
	var CUSTOM_LOG_TYPE = 'log';
	var normalizeCustomEventData = function (raw) {
	    if (!raw || !isObject(raw)) {
	        return;
	    }
	    // name is required
	    if (!raw['name'] || !isString(raw['name'])) {
	        return;
	    }
	    var res = {
	        name: raw['name'],
	        type: CUSTOM_EVENT_TYPE,
	    };
	    if ('metrics' in raw && isObject(raw['metrics'])) {
	        var rMetrics = raw['metrics'];
	        var metrics = {};
	        for (var k in rMetrics) {
	            if (isNumber(rMetrics[k])) {
	                metrics[k] = rMetrics[k];
	            }
	        }
	        res.metrics = metrics;
	    }
	    if ('categories' in raw && isObject(raw['categories'])) {
	        var rCategories = raw['categories'];
	        var categories = {};
	        for (var k in rCategories) {
	            categories[k] = safeStringify(rCategories[k]);
	        }
	        res.categories = categories;
	    }
	    return res;
	};
	var normalizeCustomLogData = function (raw) {
	    if (!raw || !isObject(raw)) {
	        return;
	    }
	    // content is required
	    if (!raw['content'] || !isString(raw['content'])) {
	        return;
	    }
	    var rContent = raw['content'];
	    var res = {
	        content: safeStringify(rContent),
	        type: CUSTOM_LOG_TYPE,
	        level: 'info',
	    };
	    if ('level' in raw) {
	        res.level = raw['level'];
	    }
	    if ('extra' in raw && isObject(raw['extra'])) {
	        var rExtra = raw['extra'];
	        var metrics = {};
	        var categories = {};
	        for (var k in rExtra) {
	            if (isNumber(rExtra[k])) {
	                metrics[k] = rExtra[k];
	            }
	            else {
	                categories[k] = safeStringify(rExtra[k]);
	            }
	        }
	        res.metrics = metrics;
	        res.categories = categories;
	    }
	    return res;
	};
	var CustomPlugin = function (client) {
	    var sendEvent = function (data) {
	        var normalized = normalizeCustomEventData(data);
	        if (normalized) {
	            client.report({
	                ev_type: CUSTOM_EV_TYPE,
	                payload: normalized,
	                extra: {
	                    timestamp: Date.now(),
	                },
	            });
	        }
	    };
	    var sendLog = function (data) {
	        var normalized = normalizeCustomLogData(data);
	        if (normalized) {
	            client.report({
	                ev_type: CUSTOM_EV_TYPE,
	                payload: normalized,
	                extra: {
	                    timestamp: Date.now(),
	                },
	            });
	        }
	    };
	    client.provide('sendEvent', sendEvent);
	    client.provide('sendLog', sendLog);
	};

	function getNetworkType(netInfo) {
	    return (netInfo === null || netInfo === void 0 ? void 0 : netInfo.effectiveType) || (netInfo === null || netInfo === void 0 ? void 0 : netInfo.type) || '';
	}
	var InjectNetworkTypePlugin = function (client) {
	    var netInfo = getDefaultNetworkInformation();
	    var network_type = getNetworkType(netInfo);
	    if (netInfo) {
	        netInfo.onchange = function () {
	            network_type = getNetworkType(netInfo);
	        };
	    }
	    client.on('report', function (ev) {
	        return __assign(__assign({}, ev), { extra: __assign(__assign({}, (ev.extra || {})), { network_type: network_type }) });
	    });
	};

	/* eslint-disable @typescript-eslint/prefer-for-of */
	var withSampleRate = function (ev, sampleRate) {
	    var common = ev.common || {};
	    common.sample_rate = sampleRate;
	    ev.common = common;
	    return ev;
	};
	var hitFnWithRandom = function (preCalc, sampleRate, isHitBySampleRate, random, isHitByRandom) {
	    return preCalc
	        ? (function (h) { return function () {
	            return h;
	        }; })(isHitByRandom(random, sampleRate))
	        : function () { return isHitBySampleRate(sampleRate); };
	};
	var parseValues = function (values, type) {
	    return values.map(function (v) {
	        switch (type) {
	            case 'number':
	                return Number(v);
	            case 'boolean':
	                return v === '1';
	            case 'string': // default to string
	            default:
	                return String(v);
	        }
	    });
	};
	var checkVal = function (val, values, op) {
	    switch (op) {
	        case 'eq':
	            return arrayIncludes(values, val);
	        case 'neq':
	            return !arrayIncludes(values, val);
	        case 'gt':
	            return val > values[0];
	        case 'gte':
	            return val >= values[0];
	        case 'lt':
	            return val < values[0];
	        case 'lte':
	            return val <= values[0];
	        case 'regex':
	            return Boolean(val.match(new RegExp(values.join('|'))));
	        case 'not_regex':
	            return !val.match(new RegExp(values.join('|')));
	        default: {
	            // unknown op
	            return false;
	        }
	    }
	};
	var checkFilter = function (ev, field, op, values) {
	    var val = safeVisit(ev, field, function (t, p) {
	        return t[p];
	    });
	    if (val === undefined) {
	        return false;
	    }
	    var field_type = isBoolean(val) ? 'bool' : isNumber(val) ? 'number' : 'string';
	    return checkVal(val, parseValues(values, field_type), op);
	};
	var matchFilter = function (ev, filter) {
	    try {
	        return filter.type === 'rule'
	            ? checkFilter(ev, filter.field, filter.op, filter.values)
	            : filter.type === 'and'
	                ? filter.children.every(function (f) { return matchFilter(ev, f); })
	                : filter.children.some(function (f) { return matchFilter(ev, f); });
	    }
	    catch (e) {
	        reportSelfError(e);
	        return false;
	    }
	};
	var getHitMap = function (rules, preCalcHit, baseRate, isHitBySampleRate, random, isHitByRandom) {
	    var hitMap = {};
	    Object.keys(rules).forEach(function (name) {
	        var _a = rules[name], enable = _a.enable, sample_rate = _a.sample_rate, conditional_sample_rules = _a.conditional_sample_rules;
	        if (enable) {
	            hitMap[name] = {
	                enable: enable,
	                sample_rate: sample_rate,
	                effectiveSampleRate: sample_rate * baseRate,
	                hit: hitFnWithRandom(preCalcHit, sample_rate, isHitBySampleRate, random, isHitByRandom),
	            };
	            if (conditional_sample_rules) {
	                hitMap[name].conditional_hit_rules = conditional_sample_rules.map(function (_a) {
	                    var s = _a.sample_rate, filter = _a.filter;
	                    return ({
	                        sample_rate: s,
	                        hit: hitFnWithRandom(preCalcHit, s, isHitBySampleRate, random, isHitByRandom),
	                        effectiveSampleRate: s * baseRate,
	                        filter: filter,
	                    });
	                });
	            }
	        }
	        else {
	            hitMap[name] = {
	                enable: enable,
	                hit: function () {
	                    /* istanbul ignore next */
	                    return false;
	                },
	                sample_rate: 0,
	                effectiveSampleRate: 0,
	            };
	        }
	    });
	    return hitMap;
	};
	var getSampler = function (userId, config, isHitBySampleRate, isHitByRandom) {
	    if (!config)
	        return id;
	    // r的设计是为了允许外部传入随机数，用于彻底实现按用户采样
	    var baseRate = config.sample_rate, include_users = config.include_users, sample_granularity = config.sample_granularity, rules = config.rules, _a = config.r, random = _a === void 0 ? Math.random() : _a;
	    // 用户名单采样
	    var userHit = arrayIncludes(include_users, userId);
	    if (userHit) {
	        return function (ev) { return withSampleRate(ev, 1); };
	    }
	    // should pre calculate hit
	    var preCalcHit = sample_granularity === 'session';
	    var baseHit = hitFnWithRandom(preCalcHit, baseRate, isHitBySampleRate, random, isHitByRandom);
	    var hitMap = getHitMap(rules, preCalcHit, baseRate, isHitBySampleRate, random, isHitByRandom);
	    return function (ev) {
	        var _a;
	        // 总采样必须命中才有后续
	        if (!baseHit()) {
	            return false;
	        }
	        // 未配置的事件类型
	        if (!(ev.ev_type in hitMap)) {
	            return withSampleRate(ev, baseRate);
	        }
	        // 忽略未开启的事件类型
	        if (!hitMap[ev.ev_type].enable) {
	            return false;
	        }
	        // 跳过采样配置
	        if ((_a = ev.common) === null || _a === void 0 ? void 0 : _a.sample_rate) {
	            return ev;
	        }
	        var hitConfig = hitMap[ev.ev_type];
	        var conditions = hitConfig.conditional_hit_rules;
	        if (conditions) {
	            // 先判断条件采样
	            for (var i = 0; i < conditions.length; i++) {
	                if (matchFilter(ev, conditions[i].filter)) {
	                    if (conditions[i].hit()) {
	                        return withSampleRate(ev, conditions[i].effectiveSampleRate);
	                    }
	                    // 条件匹配后不再搜索
	                    return false;
	                }
	            }
	        }
	        // 事件类型采样
	        if (!hitConfig.hit()) {
	            return false;
	        }
	        // 事件类型默认采样已经命中
	        return withSampleRate(ev, hitConfig.effectiveSampleRate);
	    };
	};
	var SamplePlugin = function (client) {
	    client.on('start', function () {
	        var _a = client.config(), userId = _a.userId, sample = _a.sample;
	        var sampler = getSampler(userId, sample, isHitBySampleRate, isHitByRandom);
	        client.on('build', sampler);
	    });
	};

	/* eslint-disable @typescript-eslint/prefer-optional-chain */
	var getBeaconTransport = function () {
	    var window = getDefaultBrowser();
	    return window && window.navigator.sendBeacon
	        ? {
	            get: function () { },
	            post: function (url, data) {
	                window.navigator.sendBeacon(url, data);
	            },
	        }
	        : {
	            get: noop,
	            post: noop,
	        };
	};

	var request = function (method, options, XMLHttpRequest) {
	    var url = options.url, data = options.data, _a = options.success, success = _a === void 0 ? noop : _a, _b = options.fail, fail = _b === void 0 ? noop : _b, _c = options.getResponseText, getResponseText = _c === void 0 ? noop : _c, _d = options.withCredentials, withCredentials = _d === void 0 ? false : _d;
	    var xhr = new XMLHttpRequest();
	    xhr.withCredentials = withCredentials;
	    xhr.open(method, url, true);
	    xhr.setRequestHeader('Content-Type', 'application/json');
	    xhr.onload = function () {
	        getResponseText === null || getResponseText === void 0 ? void 0 : getResponseText(this.responseText);
	        try {
	            if (this.responseText) {
	                var result = JSON.parse(this.responseText);
	                success(result);
	            }
	            else {
	                success({});
	            }
	        }
	        catch (e) {
	            fail(e);
	        }
	    };
	    xhr.onerror = function () {
	        fail(new Error('Network request failed'));
	    };
	    xhr.onabort = function () {
	        /* istanbul ignore next */
	        fail(new Error('Network request aborted'));
	    };
	    xhr.send(data);
	};
	var getXhrTransport = function () {
	    var XMLHttpRequest = getDefaultXMLHttpRequest();
	    return XMLHttpRequest
	        ? {
	            get: function (options) {
	                request('GET', options, XMLHttpRequest);
	            },
	            post: function (options) {
	                request('POST', options, XMLHttpRequest);
	            },
	        }
	        : {
	            get: noop,
	            post: noop,
	        };
	};

	// createSender has side effects(register onClose behaviour)
	// so it must be create lazily
	function createBrowserSender(config) {
	    var sender = createBatchSender(config);
	    var beaconTransport = getBeaconTransport();
	    var sendOnClose = function (data) {
	        beaconTransport.post(sender.getEndpoint(), stringifyBatch([data]));
	    };
	    onPageUnload(function () {
	        var data = sender.getBatchData();
	        if (data) {
	            beaconTransport.post(sender.getEndpoint(), data);
	            sender.clear();
	        }
	        sender.send = sendOnClose;
	    });
	    return sender;
	}

	var REPORT_DOMAIN = "mon-va.byteoversea.com";
	var SETTINGS_DOMAIN = REPORT_DOMAIN;
	var PLUGINS_LOAD_PREFIX = "https:" + "//" + ("sf16-short-sg.bytedapm.com") + "/slardar/fe/sdk-web/plugins";
	var SDK_VERSION = "0.11.1" ;
	var SDK_NAME = 'SDK_SLARDAR_WEB';
	var SETTINGS_PATH = '/monitor_web/settings/browser-settings';
	var BATCH_REPORT_PATH = "/monitor_browser/collect/batch/";
	var STORAGE_PREFIX = 'SLARDAR';
	var USER_ID_COOKIE_NAME = 'MONITOR_WEB_ID';
	var DEVICE_ID_COOKIE_NAME = 'MONITOR_DEVICE_ID';
	var DEFAULT_IGNORE_PATHS = ['/log/sentry/', BATCH_REPORT_PATH, SETTINGS_PATH];
	var DEFAULT_SAMPLE_GRANULARITY = 'session';
	var DEFAULT_SAMPLE_CONFIG = {
	    sample_rate: 1,
	    include_users: [],
	    sample_granularity: DEFAULT_SAMPLE_GRANULARITY,
	    rules: {},
	};
	var DEFAULT_SENDER_SIZE = 20;

	function normalizeInitConfig(config) {
	    var plugins = config.plugins || {};
	    for (var k in plugins) {
	        if (plugins[k] && !isObject(plugins[k])) {
	            plugins[k] = {};
	        }
	    }
	    return __assign(__assign({}, config), { plugins: plugins });
	}
	function validateInitConfig(config) {
	    return isObject(config) && 'bid' in config;
	}
	function normalizeUserConfig(config) {
	    return __assign({}, config);
	}
	function parseServerConfig(serverConfig) {
	    var _a;
	    if (!serverConfig) {
	        return {};
	    }
	    var sample = serverConfig.sample, user_id = serverConfig.user_id, plugins = serverConfig.plugins, timestamp = serverConfig.timestamp;
	    if (!sample) {
	        return {
	            userId: user_id,
	        };
	    }
	    var sample_rate = sample.sample_rate, _b = sample.sample_granularity, sample_granularity = _b === void 0 ? DEFAULT_SAMPLE_GRANULARITY : _b, include_users = sample.include_users, _c = sample.rules, rules = _c === void 0 ? [] : _c;
	    return {
	        userId: user_id,
	        sample: {
	            include_users: include_users,
	            sample_rate: sample_rate,
	            sample_granularity: sample_granularity,
	            rules: rules.reduce(function (prev, cur) {
	                var name = cur.name, enable = cur.enable, sample_rate = cur.sample_rate, conditional_sample_rules = cur.conditional_sample_rules;
	                prev[name] = {
	                    enable: enable,
	                    sample_rate: sample_rate,
	                    conditional_sample_rules: conditional_sample_rules,
	                };
	                return prev;
	            }, {}),
	        },
	        plugins: {
	            heatmap: (_a = plugins === null || plugins === void 0 ? void 0 : plugins.heatmap) !== null && _a !== void 0 ? _a : false,
	        },
	        serverTimestamp: timestamp,
	    };
	}

	/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
	var getReportUrl = function (domain, path) {
	    if (path === void 0) { path = BATCH_REPORT_PATH; }
	    return "" + (domain && domain.indexOf('//') >= 0 ? '' : 'https://') + domain + path;
	};
	var getSettingsUrl = function (domain, path) {
	    if (path === void 0) { path = SETTINGS_PATH; }
	    return "" + (domain && domain.indexOf('//') >= 0 ? '' : 'https://') + domain + path;
	};
	var getViewId = function (pid) { return pid + "_" + Date.now(); };
	var getDefaultSessionId = function () {
	    return uuid();
	};
	var toObservableArray = function (arr) {
	    var observers = [];
	    arr.observe = function (o) {
	        observers.push(o);
	    };
	    arr.push = function () {
	        var _a;
	        var vs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            vs[_i] = arguments[_i];
	        }
	        vs.forEach(function (v) {
	            observers.forEach(function (o) { return o(v); });
	        });
	        return (_a = [].push).call.apply(_a, __spreadArray([arr], __read(vs), false));
	    };
	    return arr;
	};
	var getGlobalName = function () {
	    var _a, _b, _c;
	    var window = getDefaultBrowser();
	    var document = getDefaultDocument();
	    if (window && document) {
	        return ((_c = (_b = (_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.getAttribute('src')) === null || _b === void 0 ? void 0 : _b.match(/globalName=(.+)$/)) === null || _c === void 0 ? void 0 : _c[1]) || 'Slardar';
	    }
	};
	var getGlobalInstance = function () {
	    var window = getDefaultBrowser();
	    var globalName = getGlobalName();
	    if (window && globalName) {
	        return window[globalName];
	    }
	};
	var getStorageKey = function (bid) { return STORAGE_PREFIX + bid; };
	var getDefaultUserIdAndDeviceId = function (bid) {
	    if (bid === void 0) { bid = ''; }
	    var key = getStorageKey(bid);
	    return (getStorageItem(key) || {
	        // 兜底拿cookie 是为了切换时PV UV 不波动，后期稳定后可以去掉这个逻辑
	        userId: getCookieId(USER_ID_COOKIE_NAME) || uuid(),
	        deviceId: getCookieId(DEVICE_ID_COOKIE_NAME) || uuid(),
	    });
	};
	var hasSetStorageItem = function (bid) {
	    if (bid === void 0) { bid = ''; }
	    var key = getStorageKey(bid);
	    return !!getStorageItem(key);
	};
	var setStorageUserIdAndDeviceId = function (config) {
	    var bid = config.bid, userId = config.userId, deviceId = config.deviceId;
	    var key = getStorageKey(bid);
	    setStorageItem(key, {
	        userId: userId,
	        deviceId: deviceId,
	    });
	};

	var configHolder = {
	    get: function () {
	        return this.__SLARDAR__REPALCE__HOLDER__;
	    },
	};
	var createBrowserConfigManager = function (defaultConfig) {
	    // the merged config
	    var config = defaultConfig;
	    // save it so we know when initConfig is set
	    var initConfig;
	    // save UserConfig so we can merge with priority
	    var userConfig = {};
	    // save the original server config, from sdk-server or from get_setting response
	    var serverConfig = configHolder.get();
	    // cache the parsed ServerConfig, used in merge
	    var parsedServerConfig;
	    // call when ready to start(with initConfig and serverConfig)
	    var onReady = noop;
	    // call when config changed
	    var onChange = noop;
	    return {
	        getConfig: function () {
	            return config;
	        },
	        setConfig: function (c) {
	            userConfig = __assign(__assign({}, userConfig), (c || {}));
	            updateConfig();
	            if (!initConfig) {
	                // handle init
	                initConfig = c;
	                if (config.useLocalConfig || !config.bid) {
	                    parsedServerConfig = {};
	                    onReady();
	                }
	                else if (serverConfig) {
	                    handleServerConfig();
	                }
	                else {
	                    getServerConfig(config.domain, config.bid, function (res) {
	                        serverConfig = res;
	                        handleServerConfig();
	                    });
	                }
	            }
	            return config;
	        },
	        onChange: function (fn) {
	            onChange = fn;
	        },
	        onReady: function (fn) {
	            onReady = function () {
	                setStorageUserIdAndDeviceId(config);
	                fn();
	            };
	            if (parsedServerConfig) {
	                onReady();
	            }
	        },
	    };
	    function updateConfig() {
	        var newConfig = __assign(__assign(__assign({}, defaultConfig), (parsedServerConfig || {})), userConfig);
	        newConfig.plugins = mergeDeepConcatArray(defaultConfig.plugins, (parsedServerConfig === null || parsedServerConfig === void 0 ? void 0 : parsedServerConfig.plugins) || {}, userConfig.plugins || {});
	        newConfig.sample = mergeSampleConfig(mergeSampleConfig(defaultConfig.sample, parsedServerConfig === null || parsedServerConfig === void 0 ? void 0 : parsedServerConfig.sample), userConfig.sample);
	        config = newConfig;
	        onChange();
	    }
	    function handleServerConfig() {
	        parsedServerConfig = parseServerConfig(serverConfig);
	        // 兜底处理，如果目前localstorage中有值，则不需要setting下发的从cookie中拿的数据做覆盖
	        // 但是仍然需要保留server 返回的userID，当localstorage中没有值时，说明第一次设置还没有生效，需要走正常的覆盖逻辑，不然UV会偏高
	        if (hasSetStorageItem(config.bid)) {
	            parsedServerConfig.userId = defaultConfig.userId;
	        }
	        updateConfig();
	        onReady();
	    }
	};
	function getServerConfig(domain, bid, cb) {
	    getXhrTransport().get({
	        withCredentials: true,
	        url: getSettingsUrl(domain) + "?bid=" + bid + "&store=1",
	        success: function (res) {
	            cb(res.data || {});
	        },
	        fail: function () {
	            cb({ sample: { sample_rate: 0.001 } });
	        },
	    });
	}
	function mergeSampleConfig(a, b) {
	    if (!a || !b)
	        return a || b;
	    var res = __assign(__assign({}, a), b);
	    res.include_users = __spreadArray(__spreadArray([], __read((a.include_users || [])), false), __read((b.include_users || [])), false);
	    res.rules = __spreadArray(__spreadArray([], __read(Object.keys(a.rules || {})), false), __read(Object.keys(b.rules || {})), false).reduce(function (obj, key) {
	        var _a, _b;
	        if (!(key in obj)) {
	            if (key in (a.rules || {}) && key in (b.rules || {})) {
	                obj[key] = __assign(__assign({}, a.rules[key]), b.rules[key]);
	                obj[key].conditional_sample_rules = __spreadArray(__spreadArray([], __read((a.rules[key].conditional_sample_rules || [])), false), __read((b.rules[key].conditional_sample_rules || [])), false);
	            }
	            else {
	                obj[key] = ((_a = a.rules) === null || _a === void 0 ? void 0 : _a[key]) || ((_b = b.rules) === null || _b === void 0 ? void 0 : _b[key]);
	            }
	        }
	        return obj;
	    }, {});
	    return res;
	}

	var browserBuilder = {
	    build: function (e) {
	        return {
	            ev_type: e.ev_type,
	            payload: e.payload,
	            common: __assign(__assign({}, (e.extra || {})), (e.overrides || {})),
	        };
	    },
	};

	/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
	var isDebug = '';
	function loadPluginsOnPageLoad(client, registry, lp) {
	    if (lp === void 0) { lp = loadPlugins; }
	    onPageLoad(function () {
	        client.on('init', function () {
	            lp(client, registry);
	        });
	    });
	}
	function loadPlugins(client, registry, ld) {
	    if (ld === void 0) { ld = loadNow; }
	    var _a = client.config(), plugins = _a.plugins, pluginBundle = _a.pluginBundle;
	    Object.keys(plugins).forEach(function (name) {
	        // check if plugin is enabled, plugins[name]: false means it's disabled
	        if (plugins[name]) {
	            // check if we have a bundle containing this plugin
	            if (pluginBundle && arrayIncludes(pluginBundle.plugins, name)) {
	                ld(client, pluginBundle, registry);
	            }
	            else {
	                ld(client, { name: name, config: plugins[name] }, registry);
	            }
	        }
	    });
	}
	function loadNow(client, _a, registry, ls) {
	    var name = _a.name, plugins = _a.plugins, config = _a.config;
	    if (ls === void 0) { ls = loadScript; }
	    if (loadingOrLoaded(client, name)) {
	        return;
	    }
	    client.loading.push(name);
	    var path = getPluginPath(client, name, config);
	    ls(path, function () {
	        if (arrayIncludes(client.loaded, name)) {
	            return;
	        }
	        if (plugins) {
	            plugins.forEach(function (name) {
	                if (!arrayIncludes(client.loaded, name)) {
	                    applyPlugin(client, name, registry);
	                }
	            });
	        }
	        else {
	            applyPlugin(client, name, registry);
	        }
	    });
	}
	function loadingOrLoaded(client, name) {
	    return arrayIncludes(client.loaded, name) || arrayIncludes(client.loading, name);
	}
	function getPluginPath(client, name, config) {
	    var _a;
	    return (_a = config === null || config === void 0 ? void 0 : config.path) !== null && _a !== void 0 ? _a : client.config().pluginPathPrefix + "/" + camelToKebab(name) + "." + SDK_VERSION + "." + isDebug + "js";
	}
	function applyPlugin(client, name, registry) {
	    if (registry === void 0) { registry = getGlobalRegistry(getDefaultBrowser()); }
	    if (!registry)
	        return;
	    var plugin = getPluginFromRegistry(registry, name);
	    if (!plugin) {
	        warn('[loader].applyPlugin not found', name);
	        return;
	    }
	    try {
	        plugin.apply(client);
	        client.loaded.push(name);
	    }
	    catch (err) {
	        reportSelfError(err);
	        warn('[loader].applyPlugin failed', name, err);
	    }
	}
	function getPluginFromRegistry(registry, name) {
	    return registry.plugins.filter(function (l) { return l.name === name && l.version === SDK_VERSION; })[0];
	}
	// 注册到指定注册表
	function register(name, apply, registry) {
	    if (registry === void 0) { registry = getGlobalRegistry(getDefaultBrowser()); }
	    if (!registry || !registry.plugins)
	        return;
	    if (getPluginFromRegistry(registry, name)) {
	        return;
	    }
	    registry.plugins.push({
	        name: name,
	        version: SDK_VERSION,
	        apply: apply,
	    });
	}

	var addEnvToSendEvent = function (ev) {
	    var extra = {
	        url: getLocationUrl(),
	        timestamp: Date.now(),
	        sdk_version: SDK_VERSION,
	        sdk_name: SDK_NAME,
	    };
	    return __assign(__assign({}, ev), { extra: __assign(__assign({}, extra), (ev.extra || {})) });
	};
	var InjectEnvPlugin = function (client) {
	    client.on('report', function (ev) {
	        return addEnvToSendEvent(ev);
	    });
	};

	var EV_METHOD_MAP = {
	    sri: 'reportSri',
	    st: 'reportResourceError',
	    err: 'captureException',
	};
	var createStore = function (evMap) {
	    return Object.keys(evMap).reduce(function (prev, cur) {
	        prev[cur] = [];
	        return prev;
	    }, {});
	};
	var reverseMap = function (map) {
	    return Object.keys(map).reduce(function (prev, cur) {
	        prev[map[cur]] = cur;
	        return prev;
	    }, {});
	};
	var getStoreOrConsume = function (client, store, evMap) {
	    return function (type, data, timestamp, url) {
	        var _a;
	        if (timestamp === void 0) { timestamp = Date.now(); }
	        if (url === void 0) { url = location.href; }
	        var capturedContext = __assign(__assign({}, captureCurrentContext(client)), { url: url, timestamp: timestamp });
	        if (store[type]) {
	            if (client[evMap[type]]) {
	                syncReportWithCapturedContext(client, capturedContext)(function () {
	                    client[evMap[type]](data);
	                });
	            }
	            else {
	                (_a = store[type]) === null || _a === void 0 ? void 0 : _a.push([data, capturedContext]);
	            }
	        }
	    };
	};
	var getConsumeStored = function (client, store, evMethods) { return function (name) {
	    var _a;
	    if (name in evMethods) {
	        (_a = store[evMethods[name]]) === null || _a === void 0 ? void 0 : _a.forEach(function (_a) {
	            var _b = __read(_a, 2), event = _b[0], capturedContext = _b[1];
	            syncReportWithCapturedContext(client, capturedContext)(function () {
	                client[name](event);
	            });
	        });
	        // 置空，不再消费
	        store[evMethods[name]] = null;
	    }
	}; };
	// 只有 staticError, jsError, unhandledreject, sri 会被预收集
	var PrecollectPlugin = function (client, evMap) {
	    var _a;
	    if (evMap === void 0) { evMap = EV_METHOD_MAP; }
	    var store = createStore(evMap);
	    var evMethods = reverseMap(evMap);
	    var storeOrConsume = getStoreOrConsume(client, store, evMap);
	    // 继续消费后续预收集数据
	    if (((_a = client.p) === null || _a === void 0 ? void 0 : _a.a) && 'observe' in client.p.a) {
	        // 注册预收集消费回调
	        client.p.a.observe(function (_a) {
	            var _b = __read(_a, 5); _b[0]; var type = _b[1], data = _b[2], timestamp = _b[3], url = _b[4];
	            storeOrConsume(type, data, timestamp, url);
	        });
	    }
	    client.on('init', function () {
	        var _a;
	        // 消费已经收集的预收集数据
	        (_a = client.p) === null || _a === void 0 ? void 0 : _a.a.forEach(function (_a) {
	            var _b = __read(_a, 5); _b[0]; var type = _b[1], data = _b[2], timestamp = _b[3], url = _b[4];
	            storeOrConsume(type, data, timestamp, url);
	        });
	        // 由于已经消费，置空所有预收集的数据
	        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
	        client.p && client.p.a && (client.p.a.length = 0);
	    });
	    // 消费预收集并通知其他实例
	    client.provide('precollect', storeOrConsume);
	    // consume stored data when provided
	    client.on('provide', getConsumeStored(client, store, evMethods));
	};

	var buildSelfErrorEvent = function (ev) {
	    var _a = __read(ev, 2), err = _a[0], extra = _a[1];
	    return {
	        ev_type: JS_ERROR_EV_TYPE,
	        payload: {
	            error: normalizeUnknownError(err),
	            breadcrumbs: [],
	            extra: extra || {},
	        },
	        extra: {
	            bid: 'slardar_sdk',
	        },
	    };
	};
	var DEFAULT_OBSERVE_ERROR_RATE = 0.001;
	var ObserveErrorPlugin = function (client, rate) {
	    if (rate === void 0) { rate = DEFAULT_OBSERVE_ERROR_RATE; }
	    var registry = getGlobalRegistry(getDefaultBrowser());
	    // 如果没有获取到注册表 或者已经observe了，则不操作
	    if (!registry)
	        return;
	    if (!registry.errors) {
	        registry.errors = [];
	    }
	    if ('observe' in registry.errors)
	        return;
	    if (!isHitBySampleRate(rate))
	        return;
	    // 挂载observe方法
	    registry.errors = toObservableArray(registry.errors);
	    // 消费已挂载的错误
	    registry.errors.forEach(function (e) {
	        client.report(buildSelfErrorEvent(e));
	    });
	    // 注册observe回调用
	    registry.errors.observe(function (e) {
	        client.report(buildSelfErrorEvent(e));
	    });
	};

	var MAX_RTT = 700;
	/**
	 * This plugin is bound with BrowserConfigManager, so it can't be extract into @sdk/web
	 */
	var TimeCalibrationPlugin = function (client) {
	    var startTime;
	    var hasCalibrated = false;
	    client.on('init', function () {
	        startTime = new Date().getTime();
	        client.on('config', function () {
	            var _a;
	            var serverTime = (_a = client.config()) === null || _a === void 0 ? void 0 : _a.serverTimestamp;
	            if (isNaN(serverTime) || Number(serverTime) <= 0 || hasCalibrated) {
	                return;
	            }
	            hasCalibrated = true;
	            var endTime = new Date().getTime();
	            var potential_rtt = endTime - startTime;
	            if (potential_rtt < MAX_RTT && serverTime) {
	                var diff_1 = serverTime - (endTime + startTime) / 2;
	                if (!isNaN(diff_1)) {
	                    client.on('beforeBuild', function (ev) {
	                        var _a;
	                        return __assign(__assign({}, ev), { extra: __assign(__assign({}, ((_a = ev.extra) !== null && _a !== void 0 ? _a : {})), { sdk_offset: diff_1 !== null && diff_1 !== void 0 ? diff_1 : 0 }) });
	                    });
	                }
	            }
	        });
	    });
	};

	var addConfigToReportEvent = function (ev, config) {
	    var extra = {};
	    extra.bid = config.bid;
	    extra.pid = config.pid;
	    extra.view_id = config.viewId;
	    extra.user_id = config.userId;
	    extra.device_id = config.deviceId;
	    extra.session_id = config.sessionId;
	    extra.release = config.release;
	    extra.env = config.env;
	    return __assign(__assign({}, ev), { extra: __assign(__assign({}, extra), (ev.extra || {})) });
	};
	var InjectConfigPlugin = function (client) {
	    client.on('beforeBuild', function (ev) {
	        return addConfigToReportEvent(ev, client.config());
	    });
	};

	var getDefaultConfig = function (c) {
	    var storageInfo = getDefaultUserIdAndDeviceId(c.bid);
	    return {
	        bid: '',
	        pid: '',
	        viewId: getViewId('_'),
	        userId: storageInfo.userId,
	        deviceId: storageInfo.deviceId,
	        sessionId: getDefaultSessionId(),
	        domain: REPORT_DOMAIN,
	        pluginBundle: {
	            name: 'commonMonitors',
	            plugins: ['breadcrumb', 'jsError', 'performance', 'resourceError', 'resource', 'sri'],
	        },
	        pluginPathPrefix: PLUGINS_LOAD_PREFIX,
	        plugins: {
	            ajax: { ignoreUrls: DEFAULT_IGNORE_PATHS },
	            fetch: { ignoreUrls: DEFAULT_IGNORE_PATHS },
	            breadcrumb: {},
	            pageview: {},
	            jsError: {},
	            resource: {},
	            resourceError: {},
	            sri: {},
	            performance: {},
	            tti: {},
	            fmp: {},
	            blankScreen: false,
	            heatmap: false,
	        },
	        release: '',
	        env: 'production',
	        sample: DEFAULT_SAMPLE_CONFIG,
	    };
	};
	var createMinimalBrowserClient = function (_a) {
	    var _b = _a === void 0 ? {} : _a, _c = _b.createSender, createSender = _c === void 0 ? function (config) {
	        return createBrowserSender({
	            size: DEFAULT_SENDER_SIZE,
	            endpoint: getReportUrl(config.domain),
	            transport: getXhrTransport(),
	        });
	    } : _c, _d = _b.builder, builder = _d === void 0 ? browserBuilder : _d, _e = _b.createDefaultConfig, createDefaultConfig = _e === void 0 ? getDefaultConfig : _e;
	    var client = createClient({
	        validateInitConfig: validateInitConfig,
	        initConfigNormalizer: normalizeInitConfig,
	        userConfigNormalizer: normalizeUserConfig,
	        createSender: createSender,
	        builder: builder,
	        createDefaultConfig: createDefaultConfig,
	        createConfigManager: createBrowserConfigManager,
	    });
	    client.loaded = [];
	    client.loading = [];
	    ObserveErrorPlugin(client);
	    ContextPlugin(client);
	    TimeCalibrationPlugin(client);
	    InjectConfigPlugin(client);
	    InjectEnvPlugin(client);
	    InjectNetworkTypePlugin(client);
	    var commandClient = withCommandArray(client, captureCurrentContext, function (c, ctx, args) {
	        return syncReportWithCapturedContext(c, ctx)(function () {
	            var _a = __read(args), method = _a[0], others = _a.slice(1);
	            client[method].apply(client, __spreadArray([], __read(others), false));
	        });
	    });
	    // add plugin after with commnand array
	    IntegrationPlugin(commandClient);
	    return commandClient;
	};
	var createBrowserClient = function (config) {
	    if (config === void 0) { config = {}; }
	    var client = createMinimalBrowserClient(config);
	    // hack start heatmap需要服务端配置但是不希望异步加载文件
	    client.loaded.push(HEATMAP_MONITOR_PLUGIN_NAME);
	    // hack end
	    loadPluginsOnPageLoad(client);
	    SamplePlugin(client);
	    PrecollectPlugin(client);
	    CustomPlugin(client);
	    // bundled collectors
	    PageviewMonitorPlugin(client);
	    client.loaded.push(PAGEVIEW_MONITOR_PLUGIN_NAME);
	    AjaxMonitorPlugin(client);
	    client.loaded.push(AJAX_MONITOR_PLUGIN_NAME);
	    FetchMonitorPlugin(client);
	    client.loaded.push(FETCH_MONITOR_PLUGIN_NAME);
	    TTIMonitorPlugin(client);
	    client.loaded.push(TTI_MONITOR_PLUGIN_NAME);
	    FMPMonitorPlugin(client);
	    client.loaded.push(FMP_MONITOR_PLUGIN_NAME);
	    return client;
	};

	/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
	var PRECOLLECT = 'precollect';
	var BOTTOM_UP_TIME = 1000 * 60 * 5;
	function npmPreCollect(window, client) {
	    // precollect error
	    if ('addEventListener' in window) {
	        client.pcErr = function (ev) {
	            ev = ev || window.event;
	            var target = ev.target || ev.srcElement || {};
	            if (target instanceof Element || target instanceof HTMLElement) {
	                if (target.getAttribute('integrity')) {
	                    client(PRECOLLECT, 'sri', target.getAttribute('href') || target.getAttribute('src'));
	                }
	                else {
	                    client(PRECOLLECT, 'st', {
	                        tagName: target.tagName,
	                        url: target.getAttribute('href') || target.getAttribute('src'),
	                    });
	                }
	            }
	            else {
	                client(PRECOLLECT, 'err', ev.error || ev.message);
	            }
	        };
	        client.pcRej = function (ev) {
	            ev = ev || window.event;
	            client(PRECOLLECT, 'err', ev.reason || (ev.detail && ev.detail.reason));
	        };
	        window.addEventListener('error', client.pcErr, true);
	        window.addEventListener('unhandledrejection', client.pcRej, true);
	        // bottom-up cleanup logic, if user not start client or load async script error
	        setTimeout(function () {
	            window.removeEventListener('error', client.pcErr, true);
	            window.removeEventListener('unhandledrejection', client.pcRej, true);
	        }, BOTTOM_UP_TIME);
	    }
	    // precollect performance
	    if ('PerformanceObserver' in window && 'PerformanceLongTaskTiming' in window) {
	        client.pp = { entries: [] };
	        client.pp.observer = new PerformanceObserver(function (list) {
	            client.pp.entries = client.pp.entries.concat(list.getEntries());
	        });
	        client.pp.observer.observe({
	            entryTypes: ['longtask', 'largest-contentful-paint', 'layout-shift'],
	        });
	        // bottom-up cleanup logic, if user not start client or load async script error
	        setTimeout(function () {
	            client.pp.observer.disconnect();
	        }, BOTTOM_UP_TIME);
	    }
	}

	var browserClient = createBrowserClient();
	var win = getDefaultBrowser();
	win && npmPreCollect(win, browserClient);

	/**
	 * compat module entry
	 */

	exports.BATCH_REPORT_PATH = BATCH_REPORT_PATH;
	exports.DEFAULT_IGNORE_PATHS = DEFAULT_IGNORE_PATHS;
	exports.DEFAULT_SAMPLE_CONFIG = DEFAULT_SAMPLE_CONFIG;
	exports.DEFAULT_SAMPLE_GRANULARITY = DEFAULT_SAMPLE_GRANULARITY;
	exports.DEFAULT_SENDER_SIZE = DEFAULT_SENDER_SIZE;
	exports.DEVICE_ID_COOKIE_NAME = DEVICE_ID_COOKIE_NAME;
	exports.InjectConfigPlugin = InjectConfigPlugin;
	exports.InjectEnvPlugin = InjectEnvPlugin;
	exports.ObserveErrorPlugin = ObserveErrorPlugin;
	exports.PLUGINS_LOAD_PREFIX = PLUGINS_LOAD_PREFIX;
	exports.PrecollectPlugin = PrecollectPlugin;
	exports.REPORT_DOMAIN = REPORT_DOMAIN;
	exports.SDK_NAME = SDK_NAME;
	exports.SDK_VERSION = SDK_VERSION;
	exports.SETTINGS_DOMAIN = SETTINGS_DOMAIN;
	exports.SETTINGS_PATH = SETTINGS_PATH;
	exports.STORAGE_PREFIX = STORAGE_PREFIX;
	exports.TimeCalibrationPlugin = TimeCalibrationPlugin;
	exports.USER_ID_COOKIE_NAME = USER_ID_COOKIE_NAME;
	exports.addConfigToReportEvent = addConfigToReportEvent;
	exports.addEnvToSendEvent = addEnvToSendEvent;
	exports.applyPlugin = applyPlugin;
	exports.browserBuilder = browserBuilder;
	exports.buildSelfErrorEvent = buildSelfErrorEvent;
	exports.configHolder = configHolder;
	exports.createBrowserClient = createBrowserClient;
	exports.createBrowserConfigManager = createBrowserConfigManager;
	exports.createMinimalBrowserClient = createMinimalBrowserClient;
	exports.createStore = createStore;
	exports['default'] = browserClient;
	exports.getConsumeStored = getConsumeStored;
	exports.getDefaultConfig = getDefaultConfig;
	exports.getDefaultSessionId = getDefaultSessionId;
	exports.getDefaultUserIdAndDeviceId = getDefaultUserIdAndDeviceId;
	exports.getGlobalInstance = getGlobalInstance;
	exports.getGlobalName = getGlobalName;
	exports.getReportUrl = getReportUrl;
	exports.getServerConfig = getServerConfig;
	exports.getSettingsUrl = getSettingsUrl;
	exports.getStorageKey = getStorageKey;
	exports.getStoreOrConsume = getStoreOrConsume;
	exports.getViewId = getViewId;
	exports.hasSetStorageItem = hasSetStorageItem;
	exports.loadNow = loadNow;
	exports.loadPlugins = loadPlugins;
	exports.loadPluginsOnPageLoad = loadPluginsOnPageLoad;
	exports.mergeSampleConfig = mergeSampleConfig;
	exports.normalizeInitConfig = normalizeInitConfig;
	exports.normalizeUserConfig = normalizeUserConfig;
	exports.parseServerConfig = parseServerConfig;
	exports.register = register;
	exports.reverseMap = reverseMap;
	exports.setStorageUserIdAndDeviceId = setStorageUserIdAndDeviceId;
	exports.toObservableArray = toObservableArray;
	exports.validateInitConfig = validateInitConfig;
	
} (sg));

var custom = {};

function isObject$1(t){return "object"==typeof t&&null!==t}function isNumber(t){return "number"==typeof t}function isString(t){return "string"==typeof t}function safeStringify(t){try{return isString(t)?t:JSON.stringify(t)}catch(t){return "[FAILED_TO_STRINGIFY]:"+String(t)}}Object.defineProperty(custom,"__esModule",{value:!0});var CUSTOM_EV_TYPE="custom",CUSTOM_EVENT_TYPE="event",CUSTOM_LOG_TYPE="log",normalizeCustomEventData=function(t){if(t&&isObject$1(t)&&t.name&&isString(t.name)){var e={name:t.name,type:CUSTOM_EVENT_TYPE};if("metrics"in t&&isObject$1(t.metrics)){var n=t.metrics,i={};for(r in n)isNumber(n[r])&&(i[r]=n[r]);e.metrics=i;}if("categories"in t&&isObject$1(t.categories)){var r,o=t.categories,s={};for(r in o)s[r]=safeStringify(o[r]);e.categories=s;}return e}},normalizeCustomLogData=function(t){if(t&&isObject$1(t)&&t.content&&isString(t.content)){var e={content:safeStringify(t.content),type:CUSTOM_LOG_TYPE,level:"info"};if("level"in t&&(e.level=t.level),"extra"in t&&isObject$1(t.extra)){var n,i=t.extra,r={},o={};for(n in i)isNumber(i[n])?r[n]=i[n]:o[n]=safeStringify(i[n]);e.metrics=r,e.categories=o;}return e}},CustomPlugin=function(e){e.provide("sendEvent",function(t){t=normalizeCustomEventData(t);t&&e.report({ev_type:CUSTOM_EV_TYPE,payload:t,extra:{timestamp:Date.now()}});}),e.provide("sendLog",function(t){t=normalizeCustomLogData(t);t&&e.report({ev_type:CUSTOM_EV_TYPE,payload:t,extra:{timestamp:Date.now()}});});},customPlugin=function(){return {name:"custom",setup:function(t){CustomPlugin(t);}}};var customPlugin_1 = custom.customPlugin=customPlugin;

var pick = function pick(obj, fields) {
  var res = {};

  var _iterator = _createForOfIteratorHelper(fields),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;

      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        res[key] = obj[key];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return res;
};

var shouldDropError = function shouldDropError(current, previous) {
  if (!current || !previous) {
    return false;
  }

  return current.message && current.stack && current.message === previous.message && current.stack === previous.stack;
};

var dedupeErr = function dedupeErr() {
  var __previousError;

  return function (currentError) {
    if (shouldDropError(currentError, __previousError)) {
      __previousError = currentError;
      return;
    }

    __previousError = currentError;
    return currentError;
  };
};

var client = sg.createMinimalBrowserClient();
var ERROR_FIELDS = ['name', 'message', 'stack', 'filename', 'lineno', 'colno'];

var safeGetPerformanceEntry = function safeGetPerformanceEntry(src) {
  if (!performance || typeof performance.getEntriesByName !== 'function') {
    return;
  }

  var performances = performance.getEntriesByName(src);
  return performances[0];
};

var dedupe = dedupeErr();
var Monitor = /*#__PURE__*/function () {
  function Monitor(region) {
    var _this$eventQueueSize;

    _classCallCheck(this, Monitor);

    this.eventQueueMap = {};
    this.eventQueueSize = (_this$eventQueueSize = {}, _defineProperty(_this$eventQueueSize, TrackingEventName.COOKIE_GET, 10), _defineProperty(_this$eventQueueSize, TrackingEventName.COOKIE_SET, 10), _defineProperty(_this$eventQueueSize, TrackingEventName.THIRD_PARTY_TRACKER, 10), _defineProperty(_this$eventQueueSize, TrackingEventName.GENERAL_FETCH, 20), _this$eventQueueSize);
    this.eventHandlers = {};
    client('init', {
      bid: SlardarConfig.bid,
      domain: region === 'TTP' ? SlardarConfig.domains.TTP : SlardarConfig.domains.NON_TTP,
      integrations: [customPlugin_1()]
    });
    client('start');
  }

  _createClass(Monitor, [{
    key: "init",
    value: function init(globalName) {
      // rewrite `pushEvent` / `pushError` method under global object
      var globalContext = globalThis[globalName];

      if (!globalContext) {
        logger.warn('monitor exit due to no global context');
        return;
      }

      globalContext.pushEvent = this.emitEvent.bind(this);
      globalContext.pushError = this.reportError.bind(this); // handle pending events / errors / perf logs

      this.reportCustomizedEvent(SlardarEventName.RUNTIME_SDK_START_MAIN, {
        count: 1
      }, {});
      var pendingEvents = globalContext.pendingEvents,
          errors = globalContext.errors;

      if (Array.isArray(pendingEvents)) {
        while (pendingEvents.length) {
          var event = pendingEvents.shift();
          this.emitEvent(event.eventName, event.eventDetail, event.source);
        }
      }

      if (Array.isArray(errors)) {
        while (errors.length) {
          var error = errors.shift();
          this.reportError(error);
        }
      }

      this.reportPreloadScript();
    }
  }, {
    key: "registerHandler",
    value: function registerHandler(eventName, handler) {
      var _a;

      var _b;

      (_a = (_b = this.eventHandlers)[eventName]) !== null && _a !== void 0 ? _a : _b[eventName] = [];
      var handlers = this.eventHandlers[eventName];

      if (!handlers.includes(handler)) {
        handlers.push(handler);
      }
    }
  }, {
    key: "emitEvent",
    value: function emitEvent(eventName, eventDetail) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EventSource.MAIN_THREAD;

      var _a;

      var _b;

      (_a = (_b = this.eventQueueMap)[eventName]) !== null && _a !== void 0 ? _a : _b[eventName] = {
        queueEvents: [],
        idle: true
      };
      var eventQueue = this.eventQueueMap[eventName];
      eventQueue.queueEvents.push({
        eventName: eventName,
        eventDetail: eventDetail,
        source: source
      });

      if (Object.prototype.hasOwnProperty.call(this.eventQueueSize, eventName)) {
        var oversizeLen = eventQueue.queueEvents.length - this.eventQueueSize[eventName]; // exceed maximum queue size, dispose earliest events

        if (oversizeLen > 0) {
          eventQueue.queueEvents.splice(0, oversizeLen);
        }
      }

      if (eventQueue.idle) {
        this.startEventQueueHandling(eventQueue);
      }
    }
  }, {
    key: "report",
    value: function report(eventName, eventMetrics, eventCategories) {
      client('sendEvent', {
        name: eventName,
        metrics: eventMetrics,
        categories: eventCategories
      });
    }
  }, {
    key: "reportCustomizedEvent",
    value: function reportCustomizedEvent(eventName, eventMetrics, eventCategories) {
      client('sendEvent', {
        name: eventName,
        metrics: eventMetrics,
        categories: eventCategories
      });
    } // handle js runtime error & script load error

  }, {
    key: "reportError",
    value: function reportError(e) {
      if (e instanceof Error) {
        var res = dedupe(e);

        if (!res) {
          return;
        }

        client.report({
          ev_type: 'js_error',
          payload: {
            error: pick(e, ERROR_FIELDS),
            breadcrumbs: []
          }
        });
      } else if (e instanceof Event) {
        var target = typeof e !== 'string' ? e.target || e.srcElement : null;

        if (!target) {
          return;
        }

        var tagName = target.tagName;

        if (!tagName || typeof tagName !== 'string') {
          return;
        }

        var src = target.src;
        var payload = {
          type: 'script',
          url: src,
          timing: safeGetPerformanceEntry(src)
        };
        client.report({
          ev_type: 'resource_error',
          payload: payload
        });
      }
    }
  }, {
    key: "reportPerf",
    value: function reportPerf(source) {
      var perf;

      if (typeof source === 'string') {
        perf = safeGetPerformanceEntry(source);
      } else {
        perf = source;
      }

      if (!perf) {
        return;
      }

      client.report({
        ev_type: 'resource',
        payload: perf
      });
    }
  }, {
    key: "reportPreloadScript",
    value: function reportPreloadScript() {
      if (!performance || typeof performance.getEntriesByType !== 'function') {
        return;
      }

      var resources = performance.getEntriesByType('resource');
      var perf = resources.filter(function (r) {
        return String.prototype.includes.call(r.name, '/pns/runtime-preload');
      });

      if (perf.length > 0) {
        this.reportPerf(perf[0]);
      }
    }
  }, {
    key: "startEventQueueHandling",
    value: function startEventQueueHandling(eventQueue) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;

        var queueEvents, _loop;

        return _regeneratorRuntime().wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                eventQueue.idle = false;
                queueEvents = eventQueue.queueEvents;
                _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                  var event, handlers, handlerJobs;
                  return _regeneratorRuntime().wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          event = queueEvents.shift();
                          handlers = _this.eventHandlers[event.eventName] || [];
                          _context.prev = 2;
                          handlerJobs = handlers.map(function (handler) {
                            return handler(event.eventDetail);
                          });
                          _context.next = 6;
                          return Promise.allSettled(handlerJobs);

                        case 6:
                          _context.next = 11;
                          break;

                        case 8:
                          _context.prev = 8;
                          _context.t0 = _context["catch"](2);

                          _this.reportError(_context.t0);

                        case 11:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _loop, null, [[2, 8]]);
                });

              case 3:
                if (!(queueEvents.length > 0)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.delegateYield(_loop(), "t0", 5);

              case 5:
                _context2.next = 3;
                break;

              case 7:
                eventQueue.idle = true;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return Monitor;
}();

var loadOnce$1 = false;
function loadRuntimeMonitor() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$globalName = _ref.globalName,
      globalName = _ref$globalName === void 0 ? '__PNS_RUNTIME__' : _ref$globalName;

  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var globalContext, runtimeConfig, monitor, _runtimeConfig$config, mainModulePlugins, idcRegion, pluginRegistry, _i, _Object$values, plugin;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window === 'undefined' || loadOnce$1)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            loadOnce$1 = true;
            globalContext = window[globalName];
            runtimeConfig = null;
            _context.prev = 5;
            _context.next = 8;
            return fetchRuntimeConfig();

          case 8:
            runtimeConfig = _context.sent;
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](5);
            logger.error(_context.t0);

          case 14:
            if (!(!runtimeConfig || !globalContext)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return");

          case 16:
            _context.prev = 16;
            _runtimeConfig$config = runtimeConfig.config.mainModulePlugins, mainModulePlugins = _runtimeConfig$config === void 0 ? [] : _runtimeConfig$config;
            idcRegion = runtimeConfig.appProps.idcRegion;
            monitor = new Monitor(idcRegion);
            _context.next = 22;
            return Promise.allSettled(mainModulePlugins.map(function (pluginCfg) {
              return loadMainModulePlugin(pluginCfg, globalName, monitor);
            }));

          case 22:
            pluginRegistry = globalContext[pluginRegistrySymbol];

            if (pluginRegistry) {
              for (_i = 0, _Object$values = Object.values(pluginRegistry); _i < _Object$values.length; _i++) {
                plugin = _Object$values[_i];
                plugin.setup(monitor);
              }

              monitor.init(globalName);
            }

            _context.next = 30;
            break;

          case 26:
            _context.prev = 26;
            _context.t1 = _context["catch"](16);
            logger.error('RuntimeMonitor start failed', _context.t1);
            monitor === null || monitor === void 0 ? void 0 : monitor.reportError(_context.t1);

          case 30:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 11], [16, 26]]);
  }));
}

var hasOwn = hasOwnProperty_1;

var isDataDescriptor$1 = function (descriptor) {
  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
};

var $ = _export;
var call$1 = functionCall;
var anObject$1 = anObject$i;
var isObject = isObject$e;
var isDataDescriptor = isDataDescriptor$1;
var fails$1 = fails$p;
var definePropertyModule = objectDefineProperty;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var getPrototypeOf = objectGetPrototypeOf;
var createPropertyDescriptor = createPropertyDescriptor$6;

// `Reflect.set` method
// https://tc39.es/ecma262/#sec-reflect.set
function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDescriptor = getOwnPropertyDescriptorModule.f(anObject$1(target), propertyKey);
  var existingDescriptor, prototype, setter;
  if (!ownDescriptor) {
    if (isObject(prototype = getPrototypeOf(target))) {
      return set(prototype, propertyKey, V, receiver);
    }
    ownDescriptor = createPropertyDescriptor(0);
  }
  if (isDataDescriptor(ownDescriptor)) {
    if (ownDescriptor.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = getOwnPropertyDescriptorModule.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      definePropertyModule.f(receiver, propertyKey, existingDescriptor);
    } else definePropertyModule.f(receiver, propertyKey, createPropertyDescriptor(0, V));
  } else {
    setter = ownDescriptor.set;
    if (setter === undefined) return false;
    call$1(setter, receiver, V);
  } return true;
}

// MS Edge 17-18 Reflect.set allows setting the property to object
// with non-writable property on the prototype
var MS_EDGE_BUG = fails$1(function () {
  var Constructor = function () { /* empty */ };
  var object = definePropertyModule.f(new Constructor(), 'a', { configurable: true });
  // eslint-disable-next-line es-x/no-reflect -- required for testing
  return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
});

$({ target: 'Reflect', stat: true, forced: MS_EDGE_BUG }, {
  set: set
});

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$1 = functionUncurryThis;
var toObject = toObject$9;

var floor = Math.floor;
var charAt = uncurryThis$1(''.charAt);
var replace = uncurryThis$1(''.replace);
var stringSlice$1 = uncurryThis$1(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var apply = functionApply;
var call = functionCall;
var uncurryThis = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails = fails$p;
var anObject = anObject$i;
var isCallable = isCallable$n;
var toIntegerOrInfinity = toIntegerOrInfinity$5;
var toLength = toLength$2;
var toString = toString$6;
var requireObjectCoercible = requireObjectCoercible$6;
var advanceStringIndex = advanceStringIndex$1;
var getMethod = getMethod$5;
var getSubstitution = getSubstitution$1;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol = wellKnownSymbol$n;

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var Tea = typeof window !== 'undefined' // eslint-disable-next-line @typescript-eslint/no-var-requires
? require('@dp/byted-tea-sdk-oversea')["default"] : null;
var teaInited = false;
var teaEnv = 'ALL_SG';
var teaChannelConfig = {
  ALL_SG: {
    channel: 'sg',
    channel_type: 'tcpy'
  },
  MALI_VA: {
    channel: 'va',
    channel_type: 'tcpy'
  },
  TTP: {
    channel_type: 'ttp'
  }
};

function teaReport(eventName) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!teaInited) {
    teaInited = true;
    Tea.init(Object.assign({
      app_id: 345918
    }, teaChannelConfig[teaEnv]));
    Tea.start();
  }

  Tea.event(eventName, Object.assign({
    page_url: location.href,
    host: location.host,
    user_agent: navigator.userAgent,
    referrer: document.referrer
  }, attributes));
}

function loadScript(url, type) {
  var scriptEle = document.createElement('script');
  scriptEle.src = url;

  if (/tiktok-web-us/.test(url)) {
    teaEnv = 'MALI_VA';
  } else if (/tiktok-web-aiso/.test(url)) {
    teaEnv = 'TTP';
  } else {
    teaEnv = 'ALL_SG';
  }

  if (type === 'module') {
    scriptEle.setAttribute('type', 'module');
  } else if (type === 'nomodule') {
    scriptEle.setAttribute('nomodule', '');
  }

  scriptEle.crossOrigin = 'anonymous';

  scriptEle.onerror = function () {
    return teaReport('cookie_banner_load_fail', {
      resource_url: url
    });
  };

  document.body.appendChild(scriptEle);
}
function isSSR() {
  return typeof window === 'undefined';
}

var loadOnce = false;
var bannerInstance, currentLocale;
var pendingDisabled = false;
var BANNER_CONFIG_ID = 'tiktok-cookie-banner-config';
function loadCookieBanner() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a, _b;

  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _options$locale, locale, fetchConfig, navigationList, userConfigEle, cookieBannerResource, baseUrl, esm, nomodule;

    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(loadOnce || isSSR())) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            loadOnce = true;
            _options$locale = options.locale, locale = _options$locale === void 0 ? getRuntimeQuery().locale : _options$locale;
            fetchConfig = {};

            if (locale) {
              currentLocale = locale;
              Reflect.set(fetchConfig, 'locale', locale);
            }

            _context.prev = 6;
            _context.next = 9;
            return fetchRuntimeConfig(fetchConfig);

          case 9:
            navigationList = _context.sent;

            if (navigationList) {
              _context.next = 12;
              break;
            }

            return _context.abrupt("return");

          case 12:
            // add navigationList to global
            userConfigEle = document.getElementById(BANNER_CONFIG_ID);

            if (!userConfigEle) {
              userConfigEle = document.createElement('script');
              userConfigEle.id = BANNER_CONFIG_ID;
              userConfigEle.setAttribute('type', 'application/json');
              document.body.appendChild(userConfigEle);
            }

            if (currentLocale === locale) {
              userConfigEle.innerHTML = JSON.stringify(navigationList);
            } // extract banner cdn resource url


            cookieBannerResource = (_b = (_a = navigationList === null || navigationList === void 0 ? void 0 : navigationList.config) === null || _a === void 0 ? void 0 : _a.cookieBanner) === null || _b === void 0 ? void 0 : _b.resource;

            if (cookieBannerResource) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return");

          case 18:
            baseUrl = cookieBannerResource.baseUrl, esm = cookieBannerResource.esm, nomodule = cookieBannerResource.nomodule;
            loadScript("".concat(baseUrl).concat(esm), 'module'), loadScript("".concat(baseUrl).concat(nomodule), 'nomodule'); // ensure there is only one banner element

            if (!bannerInstance) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return");

          case 22:
            bannerInstance = document.createElement('tiktok-cookie-banner');
            bannerInstance.setAttribute('locale', currentLocale);
            bannerInstance.setAttribute('user-config-ele-id', BANNER_CONFIG_ID);
            bannerInstance.setAttribute('disabled', "".concat(pendingDisabled));
            bannerInstance.addEventListener('bannerEvents', function (ev) {
              var detail = ev.detail;

              if (!detail || typeof detail.type !== 'string') {
                return;
              }

              var type = detail.type,
                  payload = detail.payload;

              if (!Array.isArray(payload)) {
                payload = [payload];
              }

              var eventCallbackName = "on".concat(type.replace(/^\w/, function (match) {
                return match.toUpperCase();
              }));

              if (typeof options[eventCallbackName] === 'function') {
                options[eventCallbackName].apply(options, _toConsumableArray(payload));
              }
            });
            document.body.appendChild(bannerInstance);
            _context.next = 33;
            break;

          case 30:
            _context.prev = 30;
            _context.t0 = _context["catch"](6);
            logger.error(_context.t0);

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 30]]);
  }));
}
function updateBannerLocale(locale) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var navigationList, userConfigEle;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (loadOnce) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return");

          case 3:
            currentLocale = locale;
            _context2.next = 6;
            return fetchRuntimeConfig({
              locale: locale
            });

          case 6:
            navigationList = _context2.sent;

            if (!(!navigationList || locale !== currentLocale)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return");

          case 9:
            // add navigationList to global
            userConfigEle = document.getElementById(BANNER_CONFIG_ID);

            if (!userConfigEle) {
              userConfigEle = document.createElement('script');
              userConfigEle.id = BANNER_CONFIG_ID;
              userConfigEle.setAttribute('type', 'application/json');
              document.body.appendChild(userConfigEle);
            }

            userConfigEle.innerHTML = JSON.stringify(navigationList);

            if (bannerInstance) {
              bannerInstance.setAttribute('locale', locale);
            }

            _context2.next = 18;
            break;

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](0);
            logger.error(_context2.t0);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 15]]);
  }));
}
function setDisabled(disabled) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            pendingDisabled = disabled;

            if (bannerInstance) {
              bannerInstance.setAttribute('disabled', "".concat(disabled));
            }

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadCookieBanner: loadCookieBanner,
  updateBannerLocale: updateBannerLocale,
  setDisabled: setDisabled
});

export { index as cookieBanner, fetchRuntimeConfig as init, loadRuntimeMonitor };
